import { useMemo } from 'react';
import { useLanguage } from './LanguageContext';

const DICT = {
  en: {
    categories: 'Categories',
    login: 'Login',
    listBiz: 'List your business',
    customerReviews: 'Customer Reviews',
    viewMap: 'View Map',
    callNow: 'Call Now',
    bookNow: 'Book Now',
    chooseStaff: 'Choose Your Staff',
    selectService: 'Select Service',
    selectServicesAsMuchAsYouNeed: 'Select services as much as you need',
    selectDate: 'Select a date',
    selectTime: 'Select a time',
    noReviews: 'No reviews yet. Be the first to review this business!',
    home: 'Home',
    // Footer
    about: 'About',
    team: 'Team',
    privacy: 'Privacy Policy',
    support: 'Support',
    quickLinks: 'Quick Links',
    contact: 'Contact',
    supportEmail: 'bookwithehgezly@gmail.com',
    backToTop: 'Back to top',
    brand: 'Ehgezly',
    brandBlurb: 'Simplify bookings, marketing & payments all in one platform. Reduce no‑shows with smart reminders. Manage services, staff schedules, and availability in real time. Track growth with actionable insights and repeat‑customer analytics.',
    footerPopularServices: 'Popular Services',
    footerPopularAreas: 'Popular Areas',
    footerMoreServices: 'More services...',
    footerMoreAreas: 'More areas...',
    footerFollowUs: 'Follow us on',
    footerSupportLine: 'For any support you can contact us via our Support page.',
    footerFaq: 'FAQ',
    footerSitemap: 'Sitemap',
    deleteAccount: 'Delete account',
    // Support page
    supportTitle: 'Support',
    supportSubtitle: 'Get help with the Ehgezly app and your bookings.',
    supportGeneralTitle: 'General support',
    supportGeneralText: 'For app issues, booking help, or account questions:',
    supportBusinessTitle: 'For business owners',
    supportBusinessText: 'Partners and shop owners:',
    supportReportTitle: 'Report a problem',
    supportReportText: 'Technical issues or feedback:',
    supportInAppTitle: 'In-app help',
    supportInAppText: 'Use the AI assistant in the app: Profile → Help, or ask from the dashboard.',
    supportPhoneLabel: 'Phone',
    // Auth
    welcomeBack: 'Welcome Back',
    signInSubtitle: 'Sign in to book beauty & wellness near you',
    authBrandLoginTitle: 'Pick up your beauty day',
    authBrandLoginDesc: 'Your shops, upcoming visits, and saved looks live here — ready when you are.',
    authBrandRegisterTitle: 'Book the glow you want',
    authBrandRegisterDesc: 'One free profile for cuts, color, skincare, and calm — booked around your life.',
    authBrandPointBook: 'Hold a real open slot',
    authBrandPointNear: 'Keep favorite pros close',
    authBrandPointRemind: 'Walk in prepared, not rushed',
    authBrandEyebrow: 'Ehgezly',
    authSlide1Title: 'Beauty & wellness, booked',
    authSlide1Desc: 'Salons, spas, and clinics near you. Reserve in minutes.',
    authSlide2Title: 'Your chair is waiting',
    authSlide2Desc: 'Continue unfinished bookings and keep favorite shops close.',
    authSlide3Title: 'Arrive ready, not rushed',
    authSlide3Desc: 'Gentle reminders before every cut, color, or care visit.',
    authSlideDot: 'Show highlight',
    emailAddress: 'Email Address',
    emailPlaceholder: 'Enter your email',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    rememberMe: 'Remember me',
    forgotPasswordQ: 'Forgot password?',
    signIn: 'Sign In',
    dontHaveAccount: "Don't have an account?",
    signUpHere: 'Sign up here',
    resetPassword: 'Reset Password',
    resetSubtitle: "Enter your email and we'll send you a 4-digit code",
    resetSubtitleCode: 'Enter the 4-digit code sent to your email and choose a new password.',
    sendResetLink: 'Send Reset Link',
    sendResetCode: 'Send Code',
    backToSignIn: 'Back to Sign In',
    emailRequired: 'Email is required',
    resetSent: 'Code sent! Check your email.',
    verificationCode: 'Verification code',
    verificationCodeRequired: 'Please enter the 4-digit code',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordRequired: 'Password is required',
    passwordMismatch: 'Passwords do not match',
    passwordUpdated: 'Password updated! You can sign in now.',
    setNewPassword: 'Set New Password',
    // Explore
    discoverServices: 'Book beauty & wellness near you',
    findPerfectService: 'Salons, spas, and clinics. Find a spot and reserve in minutes.',
    searchServices: 'Search shops or services…',
    exploreMore: 'Explore More Services',
    featuredShops: 'Ready to book',
    browseByCategory: 'Browse by Category',
    discoverTailored: 'Discover services tailored to your needs',
    grid: 'Grid',
    list: 'List',
    // About page
    aboutHeroTitle: 'Your Gateway to Beauty Excellence',
    aboutHeroSub: 'Discover, book, and experience the finest beauty services in your area',
    aboutTransformTitle: 'Transform Your ',
    beautyJourney: 'Beauty Journey',
    aboutTransformText: 'Connect with the finest beauty professionals in your area. Book appointments, discover new services, and transform your beauty routine.',
    getStartedNow: 'Get Started Now',
    happyCustomers: 'Happy Customers',
    beautyPros: 'Beauty Professionals',
    citiesCovered: 'Cities Covered',
    averageRating: 'Average Rating',
    whyChooseUs: 'Why Choose Us?',
    whyChooseUsSub: 'Experience the difference with our comprehensive beauty platform',
    aboutShopsTitle: 'Find nearby shops',
    aboutShopsDesc: 'Filter by service type and your area. Every salon and clinic listed on Ehgezly, sorted by top ratings.',
    aboutShopsAllCategories: 'All services',
    aboutShopsAllAreas: 'All areas',
    aboutShopsSearchPlaceholder: 'Search shops by name…',
    aboutShopsPrev: 'Previous shops',
    aboutShopsNext: 'Next shops',
    aboutShopsLoading: 'Loading shops…',
    aboutShopsEmpty: 'No matching shops.',
    aboutShopsShowAll: 'Show all shops',
    aboutShopsShowLess: 'Show less',
    discover: 'Discover',
    discoverText: 'Find the perfect beauty professional in your area with our advanced search and filtering system.',
    book: 'Book',
    bookText: 'Schedule appointments easily with real-time availability and instant confirmations.',
    remind: 'Remind',
    remindText: 'Never miss an appointment with smart reminders and notifications.',
    ctaTitle: 'Ready to Transform Your Beauty Routine?',
    ctaText: 'Join thousands of satisfied customers and discover your perfect beauty match today',
    createAccount: 'Create Account',
    joinUs: 'Join Ehgezly to book salons, spas, and clinics near you',
    signUp: 'Sign Up',
    fullName: 'Full Name',
    phoneNumber: 'Phone Number',
    createStrongPassword: 'Create a strong password',
    reqAtLeast8: 'At least 8 characters',
    reqLowercase: 'Lowercase letter',
    reqUppercase: 'Uppercase letter',
    reqNumber: 'Number',
    reqSpecial: 'Special character (e.g. ! @ # _ . ? -)',
    sendVerification: 'Send Verification Code',
    verifyPhone: 'Verify Your Phone',
    sent6Digit: 'We sent a 6-digit code to your phone number',
    verificationCode: 'Verification Code',
    resendIn: 'Resend in',
    resendCode: 'Resend code',
    verifyCode: 'Verify Code',
    demoCode: 'Demo Code',
    alreadyHaveAccount: 'Already have an account?',
    signInHere: 'Sign in here',
    enterYourFullName: 'Enter your full name',
    enterYourEmail: 'Enter your email',
    enter6DigitCode: 'Enter 6-digit code',
    // Navbar / generic
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    // Booking / receipt labels
    serviceLabel: 'Service:',
    dateLabel: 'Date:',
    timeLabel: 'Time:',
    staffLabel: 'Staff:',
    totalLabel: 'Total:',
    noSlots: 'No available slots for this date',
    bookAppointment: 'Book Appointment',
    shopNotFound: 'Shop not found',
    availableSlotTitle: 'Available time slot',
    bookedSlotTitle: 'All staff members are booked for this time slot',
    prevImage: 'Previous image',
    nextImage: 'Next image',
    // Dashboard (client)
    dashboard: 'Dashboard',
    navHome: 'Home',
    navHistory: 'History',
    navProfile: 'Profile',
    navNotifications: 'Notifications',
    navLogout: 'Logout',
    dashWelcome: 'Welcome back',
    dashCurrentAppt: 'Current appointment',
    dashExplore: 'Explore',
    dashNoActive: 'No active bookings at the moment',
    dashSessionExpired: 'Sign in to continue',
    dashSessionExpiredHint: 'Your session ended. Sign in again to see your current appointment.',
    dashSessionExpiredHistoryHint: 'Your session ended. Sign in again to view your appointment history.',
    dashSessionExpiredProfileHint: 'Your session ended. Sign in again to view your profile.',
    dashTryAgain: 'Try again',
    dashDiscoverCTA: 'Ready to book your next appointment? Discover amazing services and book with ease.',
    dashBookService: 'Book a service',
    dashStepPending: 'Pending',
    dashStepAccepted: 'Accepted',
    dashStepCompleted: 'Completed',
    dashCancelBooking: 'Cancel booking',
    dashHistoryTitle: 'Appointment History',
    dashHistorySub: 'Track all your past and upcoming appointments',
    dashStatTotal: 'Total',
    dashStatCompleted: 'Completed',
    dashStatPending: 'Pending',
    dashStatTotalSpent: 'Total Spent',
    dashSearchAppointments: 'Search appointments...',
    dashFilterAll: 'All',
    dashSortByDate: 'Sort by Date',
    dashSortByPrice: 'Sort by Price',
    dashSortByShop: 'Sort by Shop',
    dashLoading: 'Loading appointments...',
    dashErrorPrefix: 'Error loading appointments:',
    dashNoneFound: 'No appointments found',
    dashTryAdjust: 'Try adjusting your search or filters',
    dashNoneYet: "You haven't made any appointments yet",
    dashBookFirst: 'Book Your First Appointment',
    dashBookingDetails: 'Booking Details',
    dashShopInfo: 'Shop & booking',
    dashShopName: 'Shop',
    dashBookingId: 'Booking ID',
    dashServiceInfo: 'Service',
    dashService: 'Service',
    dashStaff: 'Staff',
    dashDateAndTime: 'Date & time',
    dashDate: 'Date',
    dashTime: 'Time',
    dashPayment: 'Payment',
    dashTotalPrice: 'Total',
    dashCompleted: 'Completed',
    dashNotes: 'Notes',
    dashReview: 'Review',
    markAllRead: 'Mark All Read',
    clearAll: 'Clear All',
    refresh: 'Refresh',
    notificationUnread: 'Unread',
    notificationRead: 'Read',
    dashError: 'Something went wrong',
    clearNotificationsConfirm: 'Are you sure you want to clear all notifications?',
    allNotificationsCleared: 'All notifications cleared',
    close: 'Close',
    notification: 'Notification',
    searchNotifications: 'Search notifications',
    filterNotifications: 'Filter by status',
    notificationActions: 'Notification actions',
    notificationList: 'Notifications list',
    labelDate: 'Date',
    labelTime: 'Time',
    labelStaff: 'Staff',
    labelPrice: 'Price',
    dashNotAssigned: 'Not assigned',
    reviewTitle: 'Rate your visit to',
    reviewSubmit: 'Submit',
    reviewLater: 'Later',
    reviewPlaceholder: 'Optional comment…',
    // Shop Owner Dashboard
    ownerNavProfile: 'Profile',
    ownerNavCalendar: 'Calendar',
    ownerNavAppointments: 'Appointments',
    ownerNavAnalytics: 'Analytics',
    ownerNavLogout: 'Logout',
    ownerWelcome: 'Welcome back 👋',
    ownerLoginTitle: 'Shop Owner Login',
    ownerLoginShop: 'Shop name',
    ownerLoginPassword: 'Password',
    ownerLoginBtn: 'Log in',
    ownerLoginSubtitle: 'Access your business dashboard',
    ownerNeedHelp: 'Need help? ',
    ownerContactSupport: 'Contact Support',
    ownerExportPDF: 'Export PDF',
    ownerPerformanceInsights: 'Performance Insights',
    ownerGeneratedOn: 'Generated on',
    ownerRatingsReviews: 'Ratings & Reviews',
    ownerTotalReviews: 'Total Reviews',
    ownerNoReviewsYet: 'No reviews yet',
    ownerShowReviews: 'Show Reviews',
    ownerHideReviews: 'Hide Reviews',
    ownerBizProfile: 'Business Profile',
    ownerBizProfileSub: 'Manage your business information and settings',
    ownerEditProfile: 'Edit Profile',
    ownerBusinessName: 'Business Name',
    ownerLocation: 'Location',
    ownerPhone: 'Phone',
    ownerCategory: 'Category',
    ownerImages: 'Business Images',
    ownerNoImages: 'No images uploaded yet',
    ownerServices: 'Services',
    ownerStaffMembers: 'Staff Members',
    ownerEditBizTitle: 'Edit business profile',
    ownerBasicInfo: 'Basic information',
    ownerLabelName: 'Name',
    ownerLabelTown: 'Town',
    ownerSelect: 'Select…',
    ownerLabelMap: 'Map Embed URL',
    ownerImagesHintClick: 'Click or drop images here',
    ownerImagesHintMax: 'You can upload up to 5 images',
    ownerAvailability: 'Availability',
    ownerSlotsFor: 'Slots for',
    ownerDayPickerHint: '(right-click a day to remove)',
    ownerServicesCount: 'Services',
    ownerServiceNamePh: 'Service Name',
    ownerServicePricePh: 'Price (EGP)',
    ownerAddService: '+ Add service',
    ownerStaffCount: 'Staff Members',
    ownerStaffNamePh: 'Staff Name',
    ownerRemoveStaff: 'Remove Staff',
    ownerAddStaff: '+ Add staff member',
    ownerDuration: 'Duration',
    ownerMins: 'mins',
    ownerChangePassword: 'Change Password',
    passwordFillBoth: 'Please fill both fields',
    passwordMinLength: 'New password must be at least 8 characters',
    passwordUpdatedSuccess: 'Password updated',
    passwordUpdateFailed: 'Failed to update password',
    ownerCancel: 'Cancel',
    ownerSaveChanges: 'Save changes',
    ownerMyAppointments: 'My Appointments',
    ownerMyAppointmentsSub: 'Manage all your business appointments',
    ownerStatusAll: 'All Statuses',
    ownerAllStaff: 'All staff',
    ownerSelectDate: 'Select Date',
    ownerSortByDate: 'Sort by Date',
    ownerSortByPrice: 'Sort by Price',
    ownerSortByClient: 'Sort by Client',
    ownerEmptyAppts: 'No appointments found',
    ownerEmptyApptsHelp: "You don't have any appointments yet",
    ownerClient: 'Client',
    ownerAccept: 'Accept',
    ownerDecline: 'Decline',
    ownerMarkComplete: 'Mark Complete',
    ownerCancelBtn: 'Cancel',
    ownerViewClientProfile: 'View Client Profile',
    ownerBookingRequest: 'Booking Request',
    ownerAppointmentId: 'Appointment ID',
    ownerServiceNameLabel: 'Service Name',
    ownerDateLabel: 'Date',
    ownerTimeLabel: 'Time',
    // Shop Owner Dashboard - Calendar & Analytics
    ownerLoginFailed: 'Login failed',
    ownerPleaseComplete: 'Please complete all fields',
    ownerAvailable: 'Available',
    ownerLoadingClientProfile: 'Loading client profile...',
    ownerCouldNotLoadClient: 'Could not load client profile.',
    ownerSelectAppointment: 'Select an appointment',
    ownerClientProfile: 'Client Profile',
    ownerBookingStats: 'Booking Statistics',
    ownerTotalBookings: 'Total Bookings',
    ownerTotalSpentEGP: 'Total Spent (EGP)',
    ownerCancelled: 'Cancelled',
    emailNow: 'Email Now',
    ownerBusinessPerformanceOverview: 'Business Performance Overview',
    ownerStartDate: 'Start Date',
    ownerEndDate: 'End Date',
    ownerReset: 'Reset',
    ownerAllServices: 'All Services',
    ownerLast30Days: 'Last 30 Days',
    ownerLast12Weeks: 'Last 12 Weeks',
    ownerLast12Months: 'Last 12 Months',
    ownerLast5Years: 'Last 5 Years',
    ownerCustomRange: 'Custom Range',
    ownerBookingsVsRevenue: 'Bookings vs Revenue',
    ownerExportCSV: 'Export CSV',
    ownerAppointmentStatusDistribution: 'Appointment Status Distribution',
    ownerNoAppointmentDataAvailable: 'No appointment data available',
    ownerTopServicesByBookings: 'Top Services by Bookings',
    ownerNoServiceBookingsAvailable: 'No service bookings available',
    ownerRevenueByStaffMember: 'Revenue by Staff Member',
    ownerNoStaffRevenueDataAvailable: 'No staff revenue data available',
    ownerBookingsByStaffMember: 'Bookings by Staff Member',
    ownerNoStaffBookingDataAvailable: 'No staff booking data available',
    ownerRevenueByServiceType: 'Revenue by Service Type',
    ownerNoServiceRevenueDataAvailable: 'No service revenue data available',
    ownerStaffPerformanceOverview: 'Staff Performance Overview',
    ownerBookings: 'Bookings',
    ownerRevenue: 'Revenue',
    ownerCompletion: 'Completion',
    ownerAvgValue: 'Avg Value',
    ownerNoStaffDataAvailable: 'No staff data available',
    ownerServicePerformanceOverview: 'Service Performance Overview',
    ownerAvgPrice: 'Avg Price',
    ownerNoServicePerformanceDataAvailable: 'No service performance data available',
    ownerRevenueByHour: 'Revenue by Hour',
    ownerNoRevenueByHourDataAvailable: 'No revenue by hour data available',
    ownerWelcomeBack: 'Welcome back',
    ownerLoading: 'Loading…',
    // Recommended common
    recPracticalAdvice: 'Practical advice, checklists, and scripts to get the result you want',
    recFindStylist: 'Find a Stylist',
    recBookConsultation: 'Book Consultation',
    recBookNow: 'Book Now',
    recContactSalon: 'Contact Salon',
    recHairRemovalGuideMeta: 'Professional Hair Removal Guide • Updated December 2024',
    recBookHairRemoval: 'Book Hair Removal',
    recViewAllServices: 'View All Services',
    // Analytics KPI labels
    ownerTotalAppointments: 'Total Appointments',
    ownerRevenueEGP: 'Revenue (EGP)',
    ownerAvgBookingValue: 'Avg Booking Value',
    ownerCompletionRate: 'Completion Rate',
    ownerCancellationRate: 'Cancellation Rate',
    ownerAccepted: 'Accepted',
    // Report Summary
    ownerGenerateReport: 'Generate Report',
    ownerReportSummary: 'Report Summary',
    ownerRanking: 'Ranking',
    ownerBookingsRank: 'Bookings',
    ownerRevenueRank: 'Revenue',
    ownerExcellent: 'Excellent',
    ownerVeryGood: 'Very Good',
    ownerGood: 'Good',
    ownerBad: 'Bad',
    ownerStart: 'Start',
    ownerEnd: 'End',
    ownerAllStaff: 'All Staff',
    ownerAllServices: 'All Services',
    ownerDateRange: 'Date Range',
    ownerStaffLabelShort: 'Staff',
    ownerServiceLabelShort: 'Service',
    ownerFiltersContext: 'Filters',
    ownerAnalyticsTitle: 'Executive Summary',
    ownerAnalyticsAccessTitle: 'Analytics Access',
    ownerAnalyticsAccessHint: 'Enter the 4 digits provided by your admin to access analytics',
    ownerAnalyticsPasscodePlaceholder: 'Enter 4 digits',
    ownerAnalyticsCodeRequired: 'Please enter 4 digits',
    ownerAnalyticsCodeInvalid: 'Invalid entry',
    ownerAnalyticsCodeFailed: 'Validation failed. Please try again.',
    ownerLockAnalytics: 'Lock Analytics',
    ownerAccessAnalytics: 'Access Analytics',
    ownerValidating: 'Validating...',
    ownerTopServicesByRevenue: 'Top Services by Revenue',
    // Calendar
    ownerSunday: 'Sunday',
    ownerMonday: 'Monday', 
    ownerTuesday: 'Tuesday',
    ownerWednesday: 'Wednesday',
    ownerThursday: 'Thursday',
    ownerFriday: 'Friday',
    ownerSaturday: 'Saturday',
    ownerSun: 'Sun',
    ownerMon: 'Mon',
    ownerTue: 'Tue',
    ownerWed: 'Wed',
    ownerThu: 'Thu',
    ownerFri: 'Fri',
    ownerSat: 'Sat',
    // Recommended pages
    recommendedServices: 'Recommended Services',
    completeMensGroomingGuide: 'Complete Men\'s Grooming Guide 2024',
    professionalBarberingGuide: 'Professional Barbering Guide • Updated December 2024',
    masterArtMensGrooming: 'Master the art of men\'s grooming with our comprehensive guide to modern barbering techniques, mustache styles, and grooming routines. From classic cuts to contemporary trends, discover professional tips for maintaining your best look. Whether you\'re new to professional grooming or looking to refine your routine, this guide covers everything from haircuts to skincare.',
    bookBarberAppointment: 'Book Barber Appointment',
    viewAllServices: 'View All Services',
    tableOfContents: 'Table of Contents',
    sections: 'sections',
    minTotalRead: 'min total read',
    masterMustacheStyles: 'Master Mustache Styles & Face Shape Matching',
    discoverClassicModern: 'Discover classic and modern mustache styles that perfectly complement your face shape and enhance your masculine appeal',
    minRead: 'min read',
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    bookService: 'Book Service',
    // Category pages
    filterByTown: 'Filter By Town',
    total: 'Total',
    showMore: 'Show More',
    showLess: 'Show Less',
    allOurBarbershops: 'All Our Barbershops',
    allOurHairNailSalons: 'All Our Hair & Nail Salons',
    allOurMakeupServices: 'All Our Makeup Services',
    allOurLaserClinics: 'All Our Laser Clinics',
    searchBarbershops: 'Search barbershops…',
    searchSalons: 'Search salons…',
    searchMakeup: 'Search makeup services…',
    searchClinics: 'Search clinics…',
    allOurBrowsLashes: 'All Our Brows & Lashes',
    allOurMassageAesthetic: 'All Our Massage & Aesthetic Clinics',
    allOurTattooPiercing: 'All Our Tattoo & Piercing Shops',
    searchBrowsLashes: 'Search shops…',
    searchMassageAesthetic: 'Search clinics…',
    searchTattooPiercing: 'Search shops…',
    whereToExpectShops: 'Where to expect our shops',
    allOurPetServices: 'All Our Pet Services Shops',
    searchPetServices: 'Search pet services…',
    // Team page
    ourVision: 'Our Vision',
    smallTeamBigImpact: 'Small team. Big impact.',
    visionText: 'I\'m Youssef Helal, an Egyptian Computer Science graduate from Royal Holloway, University of London. My mission is to help people and make their lives easier. To achieve this, I\'m developing a booking app for beauty and wellness shops that saves time, simplifies scheduling, and offers key benefits:',
    quickEasyBooking: 'Quick and easy booking',
    transparentPricing: 'Transparent pricing and offers',
    timeSaving: 'Time saving for customers and businesses',
    ratingsReviews: 'Ratings and reviews for better choices',
    teamBenefitsTitle: 'What Ehgezly delivers',
    teamJoinTitle: 'Want to partner or join us?',
    teamJoinDesc: 'Reach out for business partnerships, careers, or general questions.',
    teamJoinCta: 'Contact support',
    // Privacy Policy
    effectiveLabel: 'Effective',
    // Privacy list items
    ppCollectAccountInfo: 'Account info (name, email, phone, shop details you provide).',
    ppCollectBookings: 'Bookings and payments (appointment details, totals; cards handled by secure processors).',
    ppCollectUsageData: 'Usage data (logs, device and browser info, cookies to keep you signed in and improve the app).',
    ppUseProvideImprove: 'Provide and improve the service.',
    ppUseProcess: 'Process bookings, receipts, and notifications.',
    ppUsePreventFraud: 'Prevent fraud and ensure security.',
    ppUseComply: 'Comply with legal requirements.',
    ppSharingIntro: 'We do not sell personal data. We share limited info with:',
    ppSharingProviders: 'Service providers (hosting, analytics, payments) under strict contracts.',
    ppSharingBooked: 'Booked shops to fulfill your appointment.',
    ppSharingAuthorities: 'Authorities when required by law or to protect safety.',
    ppSecurityText: 'Data is encrypted in transit and stored on hardened infrastructure. We keep it only as long as needed for the service and legal obligations, then delete or anonymize.',
    ppChoiceUpdateProfile: 'Update your profile anytime in the app.',
    ppChoiceUnsubscribe: 'Unsubscribe from marketing via email footer.',
    ppChoiceRequestDeletion: 'Request data or account deletion: bookwithehgezly@gmail.com.',
    ppChoiceControlCookies: 'Control cookies in your browser settings (some are essential).',
    // Dashboard Profile tab
    personalInformation: 'Personal Information',
    manageAccountDetails: 'Manage your account details and preferences',
    editProfile: 'Edit Profile',
    dashEditProfile: 'Edit Profile',
    dashChangePassword: 'Change Password',
    editPersonalInformation: 'Edit Personal Information',
    updateAccountDetails: 'Update your account details below',
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    memberSince: 'Member Since',
    dashMemberSince: 'Member Since',
    dashPhone: 'Phone',
    dashEmail: 'Email',
    unavailable: 'Unavailable',
    profileUpdated: 'Profile updated',
    failedToUpdateProfile: 'Failed to update profile',
    cancel: 'Cancel',
    saveChanges: 'Save Changes',
    saving: 'Saving…',
    updatePasswordSubtitle: 'Update your account password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    updatePassword: 'Update Password',
    // Auth components
    hidePassword: 'Hide password',
    showPassword: 'Show password',
    sent6DigitCode: 'We sent a 6-digit code to your phone.',
    phoneVerified: 'Phone verified — you can sign in now.',
    professionalMensHaircut: 'Professional Men\'s Haircut Trends & Styling',
    masterHottestHaircut: 'Master the hottest haircut trends and learn professional styling techniques for salon-quality results at home',
    completeBeardCare: 'Complete Beard Care & Professional Styling',
    learnProfessionalBeard: 'Learn professional beard maintenance routines, styling techniques, and troubleshooting for healthy, attractive facial hair',
    mensSkincareMastery: 'Men\'s Skincare Mastery & Healthy Skin Routine',
    buildProfessionalSkincare: 'Build a professional skincare routine that prevents common issues and maintains healthy, clear skin year-round',
    professionalGroomingTools: 'Professional Grooming Tools & Home Setup',
    buildProfessionalGrooming: 'Build a professional grooming toolkit and learn maintenance techniques for salon-quality results between barber visits',
    quickTips: 'Quick Tips',
    considerFaceShape: 'Consider your face shape when choosing a mustache style',
    startWithStyle: 'Start with a style that matches your hair growth pattern',
    factorProfessional: 'Factor in your professional environment and maintenance time',
    chooseCutsWork: 'Choose cuts that work with your hair texture and growth pattern',
    considerLifestyle: 'Consider your lifestyle and maintenance preferences',
    useQualityProducts: 'Use quality products for styling and maintenance',
    useBeardSpecific: 'Use beard-specific products for optimal care',
    establishConsistent: 'Establish a consistent daily and weekly routine',
    workWithNatural: 'Work with your natural growth pattern for best results',
    startWithBasic: 'Start with a basic routine and gradually add products',
    alwaysUseSunscreen: 'Always use sunscreen to prevent sun damage',
    chooseProductsSuitable: 'Choose products suitable for your skin type',
    investQualityTools: 'Invest in quality tools for better results and longevity',
    cleanSanitizeTools: 'Clean and sanitize tools regularly',
    replaceBladesAccessories: 'Replace blades and accessories on schedule',
    readyElevateGrooming: 'Ready to Elevate Your Grooming Game?',
    dontWaitTry: 'Don\'t wait to try these professional grooming techniques! Book an appointment with one of our expert barbers who specialize in modern cuts, classic styles, and comprehensive grooming services. From precision haircuts to beard styling and skincare treatments, we\'ll help you achieve the perfect look that reflects your personal style.',
    // Portfolio
    portfolio: 'Portfolio',
    portfolioImages: 'Portfolio Images',
    clickToAddPortfolioImages: 'Click to add portfolio images',
    upTo10PortfolioImages: 'Up to 10 portfolio images • showcase your work and services',
    removePortfolioImage: 'Remove portfolio image',
    portfolioPreview: 'Portfolio',
    tapToView: 'Tap to view',
    youCanUploadUpTo10PortfolioImages: 'You can upload up to 10 portfolio images.',
    // Weekdays
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    // Towns
    maadi: 'Maadi',
    masrElGedida: 'Masr El Gedida',
    heliopolis: 'Heliopolis',
    nasrCity: 'Nasr City',
    newCairo: 'New Cairo',
    octoberCity: 'October City',
    zamalek: 'Zamalek',
    mohandessin: 'Mohandessin',
    dokki: 'Dokki',
    giza: 'Giza',
    // Service Categories
    hairNail: 'Hair & Nail',
    barber: 'Barber',
    tattooPiercing: 'Tattoo and Piercing',
    laserClinics: 'Laser Clinics',
    browsLashes: 'Brows & Lashes',
    makeup: 'Makeup',
    massage: 'Massage',
    petServices: 'Pet Services',
    // Common UI strings
    selectATown: 'Select a town',
    selectACategory: 'Select a category',
    selectAll: 'Select All',
    uploadImages: 'Upload Image(s)',
    removeService: 'Remove Service',
    addMoreServices: '+ Add More Services',
    removeStaff: 'Remove Staff',
    addStaff: '+ Add Staff',
    remove: 'Remove',
    addMore: '+ Add More',
    uploadImage: 'Upload Image',
    removeImage: 'Remove Image',
    // Admin Dashboard
    enterAdminEmail: 'Enter your admin email',
    enterPassword: 'Enter your password',
    confirm: 'Confirm',
    cancel: 'Cancel',
    // Recommended Services
    hairTrendsStylingGuide: 'Hair Trends & Styling Guide',
    mensGroomingMustacheStyles: 'Men\'s Grooming & Mustache Styles',
    tattooIdeasArtistGuide: 'Tattoo Ideas & Artist Guide',
    hairRemovalSkincare: 'Hair Removal & Skincare',
    browLashEnhancement: 'Brow & Lash Enhancement',
    spaWellnessTreatments: 'Spa & Wellness Treatments',
    professionalHairRemovalMethods: 'Professional Hair Removal Methods & Techniques',
    compareDifferentHairRemoval: 'Compare different hair removal methods and choose the most effective technique for your skin type and lifestyle',
    considerSkinSensitivity: 'Consider your skin sensitivity and hair type',
    factorPainTolerance: 'Factor in pain tolerance and maintenance requirements',
    chooseMethodsFitBudget: 'Choose methods that fit your budget and lifestyle',
    skinPreparationPreTreatment: 'Skin Preparation & Pre-Treatment Care',
    learnEssentialSkinPreparation: 'Learn essential skin preparation techniques to maximize hair removal effectiveness and minimize side effects',
    exfoliateBeforeTreatment: 'Exfoliate 24-48 hours before treatment',
    avoidSunExposure: 'Avoid sun exposure and tanning',
    stopUsingRetinoids: 'Stop using retinoids and acids',
    postTreatmentCareHealing: 'Post-Treatment Care & Healing Process',
    masterAftercareRoutine: 'Master the aftercare routine for optimal healing and long-lasting hair removal results',
    keepTreatedAreasCool: 'Keep treated areas cool and moisturized',
    avoidSunExposureHeat: 'Avoid sun exposure and heat',
    dontPickScratch: 'Don\'t pick or scratch treated areas',
    commonIssuesTroubleshooting: 'Common Issues & Troubleshooting Guide',
    learnIdentifyResolve: 'Learn how to identify and resolve common hair removal side effects and complications',
    mostSideEffectsTemporary: 'Most side effects are temporary and normal',
    contactTechnicianPersistent: 'Contact your technician for persistent issues',
    followAftercareInstructions: 'Follow aftercare instructions carefully',
    // Hair Removal Content - English
    recHairRemovalIntro: 'Master professional hair removal techniques and skincare routines for smooth, healthy skin. From laser treatments to waxing, discover expert methods for effective hair removal and comprehensive aftercare. Whether you\'re new to professional hair removal or looking to optimize your routine, this guide covers everything from method selection to troubleshooting.',
    recHairRemovalMethodsIntro: 'Professional hair removal offers various methods, each with unique benefits and considerations. Understanding the differences helps you choose the most effective technique for your skin type, hair characteristics, and lifestyle preferences.',
    recHairRemovalMethodsTitle: 'Popular Hair Removal Methods',
    recHairRemovalLaserTitle: '1. Laser Hair Removal',
    recHairRemovalHowItWorks: 'How it works:',
    recHairRemovalLaserHow: 'Uses concentrated light to target hair follicles and prevent regrowth.',
    recHairRemovalBestFor: 'Best for:',
    recHairRemovalLaserBest: 'Dark hair on light skin, long-term reduction',
    recHairRemovalDuration: 'Duration:',
    recHairRemovalLaserDuration: '6-8 sessions for optimal results',
    recHairRemovalMaintenance: 'Maintenance:',
    recHairRemovalLaserMaintenance: 'Occasional touch-up sessions',
    recHairRemovalWaxingTitle: '2. Waxing',
    recHairRemovalWaxingHow: 'Warm wax is applied and removed with hair from the root.',
    recHairRemovalWaxingBest: 'Medium to coarse hair, smooth results',
    recHairRemovalWaxingDuration: 'Results last 3-6 weeks',
    recHairRemovalWaxingMaintenance: 'Regular appointments every 4-6 weeks',
    recHairRemovalSugaringTitle: '3. Sugaring',
    recHairRemovalSugaringHow: 'Natural sugar paste removes hair in the direction of growth.',
    recHairRemovalSugaringBest: 'Sensitive skin, natural ingredients',
    recHairRemovalSugaringDuration: 'Results last 3-5 weeks',
    recHairRemovalSugaringMaintenance: 'Regular appointments every 4-5 weeks',
    recHairRemovalElectrolysisTitle: '4. Electrolysis',
    recHairRemovalElectrolysisHow: 'Electric current destroys individual hair follicles permanently.',
    recHairRemovalElectrolysisBest: 'Small areas, permanent removal',
    recHairRemovalElectrolysisDuration: 'Multiple sessions over months',
    recHairRemovalElectrolysisMaintenance: 'Permanent results once complete',
    recHairRemovalSkinPrepIntro: 'Proper skin preparation is crucial for successful hair removal treatments. Following pre-treatment guidelines helps minimize side effects, improves results, and ensures a comfortable experience.',
    recHairRemovalPreTreatmentGuidelines: 'Pre-Treatment Guidelines',
    recHairRemovalSkinPreparation: 'Skin Preparation',
    recHairRemovalExfoliation: 'Exfoliation:',
    recHairRemovalExfoliationText: 'Gently exfoliate 24-48 hours before treatment',
    recHairRemovalHydration: 'Hydration:',
    recHairRemovalHydrationText: 'Keep skin well-moisturized',
    recHairRemovalCleanSkin: 'Clean skin:',
    recHairRemovalCleanSkinText: 'Arrive with clean, product-free skin',
    recHairRemovalHairLength: 'Hair length:',
    recHairRemovalHairLengthText: 'Maintain appropriate hair length for treatment',
    recHairRemovalWhatToAvoid: 'What to Avoid',
    recHairRemovalSunExposure: 'Sun exposure:',
    recHairRemovalSunExposureText: 'Avoid sunbathing and tanning beds',
    recHairRemovalRetinoids: 'Retinoids:',
    recHairRemovalRetinoidsText: 'Stop using retinol products 1 week before',
    recHairRemovalAcids: 'Acids:',
    recHairRemovalAcidsText: 'Avoid glycolic, salicylic, and other acids',
    recHairRemovalMedications: 'Medications:',
    recHairRemovalMedicationsText: 'Inform technician of any medications',
    recHairRemovalTreatmentDayPrep: 'Treatment Day Preparation',
    recHairRemovalBeforeAppointment: 'Before Your Appointment',
    recHairRemovalComfortableClothing: 'Comfortable clothing:',
    recHairRemovalComfortableClothingText: 'Wear loose, comfortable clothes',
    recHairRemovalHydrationDrink: 'Hydration:',
    recHairRemovalHydrationDrinkText: 'Drink plenty of water',
    recHairRemovalPainManagement: 'Pain management:',
    recHairRemovalPainManagementText: 'Consider over-the-counter pain relief if needed',
    recHairRemovalQuestions: 'Questions:',
    recHairRemovalQuestionsText: 'Prepare any questions about the treatment',
    recHairRemovalAftercareIntro: 'Proper aftercare is essential for optimal healing and long-lasting results. Following post-treatment guidelines helps prevent complications and ensures your skin recovers quickly and effectively.',
    recHairRemovalImmediateAftercare: 'Immediate Aftercare',
    recHairRemovalFirst24Hours: 'First 24 Hours',
    recHairRemovalCooling: 'Cooling:',
    recHairRemovalCoolingText: 'Apply cool compresses to reduce redness',
    recHairRemovalMoisturizing: 'Moisturizing:',
    recHairRemovalMoisturizingText: 'Use gentle, fragrance-free moisturizer',
    recHairRemovalAvoidHeat: 'Avoid heat:',
    recHairRemovalAvoidHeatText: 'No hot showers, saunas, or steam rooms',
    recHairRemovalLooseClothing: 'Loose clothing:',
    recHairRemovalLooseClothingText: 'Wear loose, breathable fabrics',
    recHairRemovalFirstWeek: 'First Week',
    recHairRemovalGentleCleansing: 'Gentle cleansing:',
    recHairRemovalGentleCleansingText: 'Use mild, fragrance-free cleanser',
    recHairRemovalSunProtection: 'Sun protection:',
    recHairRemovalSunProtectionText: 'Avoid direct sun exposure',
    recHairRemovalNoExfoliation: 'No exfoliation:',
    recHairRemovalNoExfoliationText: 'Avoid scrubs and exfoliating products',
    recHairRemovalHydrationKeep: 'Hydration:',
    recHairRemovalHydrationKeepText: 'Keep skin well-moisturized',
    recHairRemovalHealingTimeline: 'Healing Timeline',
    recHairRemovalWhatToExpect: 'What to Expect',
    recHairRemovalDay12: 'Day 1-2:',
    recHairRemovalDay12Text: 'Redness, slight swelling, tenderness',
    recHairRemovalDay35: 'Day 3-5:',
    recHairRemovalDay35Text: 'Redness subsides, skin begins to normalize',
    recHairRemovalWeek2: 'Week 2:',
    recHairRemovalWeek2Text: 'Skin returns to normal, hair shedding begins',
    recHairRemovalWeek34: 'Week 3-4:',
    recHairRemovalWeek34Text: 'New hair growth cycle begins',
    recHairRemovalTroubleshootingIntro: 'Understanding common side effects and knowing how to address them helps ensure a smooth recovery process. Most issues are temporary and can be managed with proper care and attention.',
    recHairRemovalCommonSideEffects: 'Common Side Effects',
    recHairRemovalNormalReactions: 'Normal Reactions',
    recHairRemovalRedness: 'Redness:',
    recHairRemovalRednessText: 'Temporary redness lasting 24-48 hours',
    recHairRemovalSwelling: 'Swelling:',
    recHairRemovalSwellingText: 'Mild swelling, especially in sensitive areas',
    recHairRemovalTenderness: 'Tenderness:',
    recHairRemovalTendernessText: 'Sensitivity to touch for 1-3 days',
    recHairRemovalDryness: 'Dryness:',
    recHairRemovalDrynessText: 'Temporary dryness and flaking',
    recHairRemovalWhenToSeekHelp: 'When to Seek Help',
    recHairRemovalExcessiveRedness: 'Excessive redness:',
    recHairRemovalExcessiveRednessText: 'Redness that worsens or spreads',
    recHairRemovalSevereSwelling: 'Severe swelling:',
    recHairRemovalSevereSwellingText: 'Swelling that doesn\'t improve',
    recHairRemovalSignsOfInfection: 'Signs of infection:',
    recHairRemovalSignsOfInfectionText: 'Pus, increased pain, fever',
    recHairRemovalAllergicReactions: 'Allergic reactions:',
    recHairRemovalAllergicReactionsText: 'Rash, hives, difficulty breathing',
    recHairRemovalPreventionTips: 'Prevention Tips',
    recHairRemovalAvoidingComplications: 'Avoiding Complications',
    recHairRemovalFollowInstructions: 'Follow instructions:',
    recHairRemovalFollowInstructionsText: 'Adhere to pre and post-treatment guidelines',
    recHairRemovalChooseQualifiedProviders: 'Choose qualified providers:',
    recHairRemovalChooseQualifiedProvidersText: 'Select licensed, experienced technicians',
    recHairRemovalCommunicateConcerns: 'Communicate concerns:',
    recHairRemovalCommunicateConcernsText: 'Discuss any health conditions or medications',
    recHairRemovalPatchTesting: 'Patch testing:',
    recHairRemovalPatchTestingText: 'Request patch tests for sensitive skin',
    recHairRemovalFooter: 'Don\'t wait to experience the benefits of professional hair removal! Book a consultation with one of our expert technicians who specialize in safe, effective hair removal treatments. From laser therapy to waxing and sugaring, we\'ll help you choose the perfect method for your skin type and hair removal goals.',
    // Makeup & Brow Enhancement Content - English
    completeMakeupBrowGuide: 'Complete Makeup & Brow Enhancement Guide 2024',
    professionalBeautyGuide: 'Professional Beauty Guide • Updated December 2024',
    recMakeupIntro: 'Master the art of professional makeup application and brow enhancement with our comprehensive guide to modern beauty techniques. From flawless foundation to dramatic eye looks, discover expert tips for achieving salon-quality results at home. Whether you\'re new to professional makeup or looking to refine your skills, this guide covers everything from basic techniques to advanced artistry.',
    professionalBrowShaping: 'Professional Brow Shaping & Face Framing',
    masterBrowShapingTechniques: 'Master brow shaping techniques and learn how to create the perfect arch that frames your face and enhances your natural beauty',
    lashEnhancementDramaticEye: 'Lash Enhancement & Dramatic Eye Techniques',
    discoverProfessionalLashTreatments: 'Discover professional lash treatments and learn techniques for creating dramatic, eye-catching looks that make your eyes pop',
    professionalMakeupFoundation: 'Professional Makeup Foundation & Color Theory',
    buildSolidFoundationMakeup: 'Build a solid foundation in makeup application, color theory, and skin preparation for flawless, long-lasting results',
    advancedEyeMakeupArtistry: 'Advanced Eye Makeup & Artistry Techniques',
    masterAdvancedEyeMakeup: 'Master advanced eye makeup techniques, from subtle everyday looks to dramatic evening styles that enhance your natural beauty',
    recBrowShapingIntro: 'Master brow shaping techniques and learn how to create the perfect arch that frames your face and enhances your natural beauty. Well-shaped eyebrows are the foundation of a polished look.',
    recBrowShapingContent1: 'Well-shaped eyebrows are the foundation of a polished look, framing your face and enhancing your natural beauty. Professional brow shaping techniques can transform your appearance by creating the perfect arch, thickness, and shape for your face structure and personal style.',
    recBrowShapingContent2: 'Brow Shaping Techniques',
    recBrowShapingContent3: '1. Threading',
    recBrowShapingContent4: 'How it works:',
    recBrowShapingContent5: 'Cotton thread is twisted and rolled over skin to remove hair at the root with precision.',
    recBrowShapingContent6: 'Benefits:',
    recBrowShapingContent7: 'Precise control, no chemicals, suitable for sensitive skin',
    recBrowShapingContent8: 'Duration:',
    recBrowShapingContent9: 'Results last 2-4 weeks',
    recBrowShapingContent10: '2. Waxing',
    recBrowShapingContent11: 'Warm wax is applied and removed with hair, pulling hair from the root.',
    recBrowShapingContent12: 'Quick results, smooth finish, longer-lasting',
    recBrowShapingContent13: 'Results last 3-6 weeks',
    recBrowShapingContent14: 'Brow Shapes for Face Types',
    recBrowShapingContent15: 'Oval Face',
    recBrowShapingContent16: 'Ideal shape:',
    recBrowShapingContent17: 'Soft, slightly curved brow with gentle arch',
    recBrowShapingContent18: 'Technique:',
    recBrowShapingContent19: 'Follow natural brow line, avoid over-plucking',
    recBrowShapingContent20: 'Round Face',
    recBrowShapingContent21: 'High arch with angled tail to elongate face',
    recBrowShapingContent22: 'Create higher arch, extend tail slightly',
    recBrowShapingContent23: 'Brow Styling Products',
    recBrowShapingContent24: 'Brow Pencils',
    recBrowShapingContent25: 'Best for:',
    recBrowShapingContent26: 'Defining shape, filling sparse areas',
    recBrowShapingContent27: 'Application:',
    recBrowShapingContent28: 'Light strokes in direction of hair growth',
    recBrowShapingContent29: 'Color selection:',
    recBrowShapingContent30: 'Match to hair color or go slightly lighter',
    recBrowShapingContent31: 'Brow Gels',
    recBrowShapingContent32: 'Holding shape, adding volume',
    recBrowShapingContent33: 'Brush through brows in upward motion',
    recBrowShapingContent34: 'Types:',
    recBrowShapingContent35: 'Clear, tinted, or colored options',
    recBrowShapingQuickTip1: 'Choose threading for precise control and sensitive skin',
    recBrowShapingQuickTip2: 'Consider your face shape when determining brow arch',
    recBrowShapingQuickTip3: 'Use brow pencils for defining shape and filling sparse areas',
    recLashEnhancementIntro: 'Discover professional lash treatments and learn techniques for creating dramatic, eye-catching looks that make your eyes pop. Beautiful lashes can transform your entire appearance.',
    recLashEnhancementContent1: 'Beautiful lashes can transform your entire look, making your eyes appear larger, more defined, and more expressive. Professional lash enhancement techniques offer various options for achieving the perfect lash look, from natural enhancement to dramatic volume.',
    recLashEnhancementContent2: 'Professional Lash Treatments',
    recLashEnhancementContent3: '1. Lash Extensions',
    recLashEnhancementContent4: 'Individual synthetic lashes are attached to natural lashes for length and volume.',
    recLashEnhancementContent5: 'Long-lasting results, no daily mascara needed',
    recLashEnhancementContent6: '3-4 weeks with proper care',
    recLashEnhancementContent7: '2. Lash Lifting',
    recLashEnhancementContent8: 'Natural lashes are curled and tinted for enhanced appearance.',
    recLashEnhancementContent9: 'Natural look, low maintenance, long-lasting',
    recLashEnhancementContent10: '6-8 weeks',
    recLashEnhancementContent11: 'Lash Extension Types',
    recLashEnhancementContent12: 'Classic Extensions',
    recLashEnhancementContent13: 'Description:',
    recLashEnhancementContent14: 'One extension per natural lash for natural look',
    recLashEnhancementContent15: 'Natural enhancement, everyday wear',
    recLashEnhancementContent16: 'Volume Extensions',
    recLashEnhancementContent17: 'Multiple extensions per natural lash for dramatic volume',
    recLashEnhancementContent18: 'Dramatic look, special occasions',
    recLashEnhancementContent19: 'Lash Care and Maintenance',
    recLashEnhancementContent20: 'Daily Care',
    recLashEnhancementContent21: 'Gentle cleansing:',
    recLashEnhancementContent22: 'Use oil-free cleanser to remove makeup',
    recLashEnhancementContent23: 'Avoid rubbing:',
    recLashEnhancementContent24: 'Pat dry instead of rubbing',
    recLashEnhancementContent25: 'Brush lashes:',
    recLashEnhancementContent26: 'Use clean mascara wand to brush lashes',
    recLashEnhancementContent27: 'Avoid oil-based products:',
    recLashEnhancementContent28: 'Can cause extensions to fall out',
    recLashEnhancementQuickTip1: 'Choose classic extensions for natural enhancement',
    recLashEnhancementQuickTip2: 'Use oil-free cleanser to maintain lash extensions',
    recLashEnhancementQuickTip3: 'Consider lash lifting for low-maintenance results',
    recMakeupFoundationIntro: 'Build a solid foundation in makeup application, color theory, and skin preparation for flawless, long-lasting results. Professional makeup starts with understanding these fundamental principles.',
    recMakeupFoundationContent1: 'Professional makeup application starts with understanding color theory, skin preparation, and proper product selection. These fundamental techniques create the perfect canvas for any makeup look, ensuring long-lasting, flawless results that enhance your natural beauty.',
    recMakeupFoundationContent2: 'Color Theory for Makeup',
    recMakeupFoundationContent3: 'Skin Undertones',
    recMakeupFoundationContent4: 'Cool undertones:',
    recMakeupFoundationContent5: 'Pink, red, or blue undertones in skin',
    recMakeupFoundationContent6: 'Warm undertones:',
    recMakeupFoundationContent7: 'Yellow, golden, or peach undertones in skin',
    recMakeupFoundationContent8: 'Neutral undertones:',
    recMakeupFoundationContent9: 'Mix of cool and warm undertones',
    recMakeupFoundationContent10: 'Foundation Selection',
    recMakeupFoundationContent11: 'Foundation Types',
    recMakeupFoundationContent12: 'Liquid foundation:',
    recMakeupFoundationContent13: 'Versatile, buildable coverage',
    recMakeupFoundationContent14: 'Cream foundation:',
    recMakeupFoundationContent15: 'Full coverage, good for dry skin',
    recMakeupFoundationContent16: 'Powder foundation:',
    recMakeupFoundationContent17: 'Light coverage, good for oily skin',
    recMakeupFoundationContent18: 'Stick foundation:',
    recMakeupFoundationContent19: 'Convenient, buildable coverage',
    recMakeupFoundationContent20: 'Application Techniques',
    recMakeupFoundationContent21: 'Brush application:',
    recMakeupFoundationContent22: 'Use foundation brush for even coverage',
    recMakeupFoundationContent23: 'Sponge application:',
    recMakeupFoundationContent24: 'Use beauty sponge for seamless blend',
    recMakeupFoundationContent25: 'Finger application:',
    recMakeupFoundationContent26: 'Use fingers for natural, warm application',
    recMakeupFoundationContent27: 'Layering technique:',
    recMakeupFoundationContent28: 'Build coverage gradually for natural look',
    recMakeupFoundationContent29: 'Concealer Techniques',
    recMakeupFoundationContent30: 'Color Correction',
    recMakeupFoundationContent31: 'Green concealer:',
    recMakeupFoundationContent32: 'Neutralizes redness',
    recMakeupFoundationContent33: 'Peach/orange concealer:',
    recMakeupFoundationContent34: 'Neutralizes dark circles',
    recMakeupFoundationContent35: 'Yellow concealer:',
    recMakeupFoundationContent36: 'Brightens and corrects purple tones',
    recMakeupFoundationContent37: 'Lavender concealer:',
    recMakeupFoundationContent38: 'Neutralizes yellow tones',
    recMakeupFoundationQuickTip1: 'Identify your skin undertones for perfect foundation matching',
    recMakeupFoundationQuickTip2: 'Use color correction to neutralize unwanted tones',
    recMakeupFoundationQuickTip3: 'Build coverage gradually for natural-looking results',
    recEyeMakeupIntro: 'Master advanced eye makeup techniques, from subtle everyday looks to dramatic evening styles that enhance your natural beauty. Eye makeup is the focal point of many looks.',
    recEyeMakeupContent1: 'Eye makeup is the focal point of many looks, requiring skill, creativity, and understanding of eye shapes and color theory. From subtle everyday looks to dramatic evening styles, mastering eye makeup techniques allows you to create endless variations that enhance your natural beauty.',
    recEyeMakeupContent2: 'Eye Shape Analysis',
    recEyeMakeupContent3: 'Common Eye Shapes',
    recEyeMakeupContent4: 'Almond eyes:',
    recEyeMakeupContent5: 'Balanced, slightly pointed at outer corners',
    recEyeMakeupContent6: 'Round eyes:',
    recEyeMakeupContent7: 'Circular shape, equal width and height',
    recEyeMakeupContent8: 'Hooded eyes:',
    recEyeMakeupContent9: 'Eyelid crease is hidden when eyes are open',
    recEyeMakeupContent10: 'Monolid eyes:',
    recEyeMakeupContent11: 'No visible crease in the eyelid',
    recEyeMakeupContent12: 'Eyeshadow Techniques',
    recEyeMakeupContent13: 'Basic Application',
    recEyeMakeupContent14: 'Base color:',
    recEyeMakeupContent15: 'Apply light color all over lid',
    recEyeMakeupContent16: 'Crease color:',
    recEyeMakeupContent17: 'Apply medium color in crease',
    recEyeMakeupContent18: 'Lid color:',
    recEyeMakeupContent19: 'Apply main color on lid',
    recEyeMakeupContent20: 'Highlight:',
    recEyeMakeupContent21: 'Apply light color on brow bone',
    recEyeMakeupContent22: 'Advanced Techniques',
    recEyeMakeupContent23: 'Cut crease:',
    recEyeMakeupContent24: 'Sharp line between lid and crease',
    recEyeMakeupContent25: 'Smoky eye:',
    recEyeMakeupContent26: 'Blended, gradient effect',
    recEyeMakeupContent27: 'Halo eye:',
    recEyeMakeupContent28: 'Light center with darker outer edges',
    recEyeMakeupContent29: 'Winged eye:',
    recEyeMakeupContent30: 'Extended eyeliner for dramatic effect',
    recEyeMakeupContent31: 'Eyeliner Techniques',
    recEyeMakeupContent32: 'Eyeliner Types',
    recEyeMakeupContent33: 'Pencil eyeliner:',
    recEyeMakeupContent34: 'Easy to use, good for beginners',
    recEyeMakeupContent35: 'Liquid eyeliner:',
    recEyeMakeupContent36: 'Precise, long-lasting',
    recEyeMakeupContent37: 'Gel eyeliner:',
    recEyeMakeupContent38: 'Versatile, can be used with brush',
    recEyeMakeupContent39: 'Pen eyeliner:',
    recEyeMakeupContent40: 'Convenient, precise application',
    recEyeMakeupContent41: 'Mascara Application',
    recEyeMakeupContent42: 'Application Techniques',
    recEyeMakeupContent43: 'Wiggle technique:',
    recEyeMakeupContent44: 'Wiggle wand from roots to tips',
    recEyeMakeupContent45: 'Zigzag technique:',
    recEyeMakeupContent46: 'Move wand in zigzag motion',
    recEyeMakeupContent47: 'Layering technique:',
    recEyeMakeupContent48: 'Apply multiple coats for volume',
    recEyeMakeupContent49: 'Bottom lashes:',
    recEyeMakeupContent50: 'Use lighter touch for lower lashes',
    recEyeMakeupQuickTip1: 'Analyze your eye shape before choosing techniques',
    recEyeMakeupQuickTip2: 'Start with basic application and build complexity',
    recEyeMakeupQuickTip3: 'Use the wiggle technique for mascara application',
    readyMasterProfessionalMakeup: 'Ready to Master Professional Makeup?',
    dontWaitLearnMakeup: 'Don\'t wait to learn these professional makeup techniques! Book a consultation with one of our expert makeup artists who specialize in brow shaping, lash enhancement, and professional makeup application. From everyday looks to special occasion makeup, we\'ll help you achieve the perfect look that enhances your natural beauty and boosts your confidence.',
    bookMakeupService: 'Book Makeup Service',
    bookBrowService: 'Book Brow Service',
    // Spa & Wellness Content - English
    completeSpaWellnessGuide: 'Complete Spa & Wellness Guide 2024',
    professionalWellnessGuide: 'Professional Wellness Guide • Updated December 2024',
    recSpaIntro: 'Discover the transformative power of professional spa treatments and wellness therapies. From therapeutic massage to advanced aesthetic treatments, this comprehensive guide covers everything you need to know about relaxation, rejuvenation, and holistic wellness. Whether you\'re seeking stress relief, skin rejuvenation, or overall wellness, this guide provides expert insights into the latest treatments and techniques.',
    professionalMassageTherapy: 'Professional Massage Therapy & Healing Techniques',
    discoverTherapeuticMassageTypes: 'Discover therapeutic massage types and learn how to choose the right treatment for relaxation, pain relief, and overall wellness',
    advancedAestheticMedicine: 'Advanced Aesthetic Medicine & Skin Rejuvenation',
    exploreCuttingEdgeAesthetic: 'Explore cutting-edge aesthetic treatments and learn about non-invasive to minimally invasive solutions for youthful, healthy skin',
    holisticWellnessTherapies: 'Holistic Wellness Therapies & Mind-Body Healing',
    discoverHolisticTreatmentModalities: 'Discover holistic treatment modalities that address physical, mental, and emotional well-being for complete wellness',
    completeSpaExperience: 'Complete Spa Experience & Wellness Journey Guide',
    learnMaximizeSpaExperience: 'Learn how to maximize your spa experience and get the most value from your wellness investment',
    recMassageIntro: 'Discover therapeutic massage types and learn how to choose the right treatment for relaxation, pain relief, and overall wellness. Professional massage therapy offers numerous benefits for both physical and mental well-being.',
    recMassageContent1: 'Professional massage therapy offers numerous benefits for both physical and mental well-being. From deep tissue work to gentle relaxation techniques, different massage styles address various needs and conditions. Understanding the different types helps you choose the most effective treatment for your specific goals.',
    recMassageContent2: 'Popular Massage Types',
    recMassageContent3: '1. Swedish Massage',
    recMassageContent4: 'Description:',
    recMassageContent5: 'Classic relaxation massage using long strokes, kneading, and circular movements.',
    recMassageContent6: 'Benefits:',
    recMassageContent7: 'Stress relief, improved circulation, muscle relaxation',
    recMassageContent8: 'Best for:',
    recMassageContent9: 'Beginners, stress relief, general relaxation',
    recMassageContent10: 'Duration:',
    recMassageContent11: '60-90 minutes',
    recMassageContent12: '2. Deep Tissue Massage',
    recMassageContent13: 'Intense massage targeting deeper muscle layers and connective tissue.',
    recMassageContent14: 'Pain relief, improved mobility, chronic tension relief',
    recMassageContent15: 'Chronic pain, muscle tension, athletes',
    recMassageContent16: '3. Hot Stone Massage',
    recMassageContent17: 'Heated stones are placed on the body and used in massage strokes.',
    recMassageContent18: 'Deep relaxation, improved circulation, stress relief',
    recMassageContent19: 'Stress relief, muscle tension, relaxation',
    recMassageContent20: '75-90 minutes',
    recMassageContent21: '4. Sports Massage',
    recMassageContent22: 'Specialized massage for athletes and active individuals.',
    recMassageContent23: 'Injury prevention, improved performance, faster recovery',
    recMassageContent24: 'Athletes, active individuals, injury prevention',
    recMassageContent25: 'Specialized Massage Techniques',
    recMassageContent26: 'Trigger Point Therapy',
    recMassageContent27: 'Focuses on specific trigger points to relieve pain.',
    recMassageContent28: 'Targeted pain relief, improved function',
    recMassageContent29: 'Chronic pain, muscle knots, tension headaches',
    recMassageContent30: 'Myofascial Release',
    recMassageContent31: 'Gentle technique targeting the fascia (connective tissue).',
    recMassageContent32: 'Improved flexibility, pain relief, better posture',
    recMassageContent33: 'Chronic pain, limited mobility, postural issues',
    recMassageContent34: 'Massage Benefits',
    recMassageContent35: 'Physical Benefits',
    recMassageContent36: 'Pain relief:',
    recMassageContent37: 'Reduces muscle tension and chronic pain',
    recMassageContent38: 'Improved circulation:',
    recMassageContent39: 'Enhances blood flow and lymphatic drainage',
    recMassageContent40: 'Better sleep:',
    recMassageContent41: 'Promotes relaxation and better sleep quality',
    recMassageContent42: 'Enhanced flexibility:',
    recMassageContent43: 'Improves range of motion and flexibility',
    recMassageContent44: 'Immune support:',
    recMassageContent45: 'Boosts immune system function',
    recMassageContent46: 'Mental Benefits',
    recMassageContent47: 'Stress reduction:',
    recMassageContent48: 'Lowers cortisol levels and stress',
    recMassageContent49: 'Mood improvement:',
    recMassageContent50: 'Increases endorphins and serotonin',
    recMassageContent51: 'Mental clarity:',
    recMassageContent52: 'Improves focus and mental clarity',
    recMassageContent53: 'Emotional release:',
    recMassageContent54: 'Helps process emotions and trauma',
    recMassageContent55: 'Relaxation:',
    recMassageContent56: 'Promotes deep relaxation and calm',
    recMassageQuickTip1: 'Start with Swedish massage for relaxation and stress relief',
    recMassageQuickTip2: 'Choose deep tissue for chronic pain and muscle tension',
    recMassageQuickTip3: 'Communicate openly with your therapist about pressure and comfort',
    recAestheticIntro: 'Explore cutting-edge aesthetic treatments and learn about non-invasive to minimally invasive solutions for youthful, healthy skin. Aesthetic medicine combines medical expertise with cosmetic treatments.',
    recAestheticContent1: 'Aesthetic medicine combines medical expertise with cosmetic treatments to address various skin concerns and signs of aging. These advanced treatments offer non-invasive to minimally invasive solutions for achieving youthful, healthy-looking skin with minimal downtime and long-lasting results.',
    recAestheticContent2: 'Popular Aesthetic Treatments',
    recAestheticContent3: '1. Botox Injections',
    recAestheticContent4: 'Neurotoxin injections that temporarily relax facial muscles.',
    recAestheticContent5: 'Reduces wrinkles, prevents new lines, smooths expression lines',
    recAestheticContent6: 'Areas treated:',
    recAestheticContent7: 'Forehead, crow\'s feet, frown lines',
    recAestheticContent8: 'Results last 3-6 months',
    recAestheticContent9: '2. Dermal Fillers',
    recAestheticContent10: 'Injectable gels that restore volume and smooth wrinkles.',
    recAestheticContent11: 'Restores volume, smooths wrinkles, enhances facial contours',
    recAestheticContent12: 'Lips, cheeks, nasolabial folds, under eyes',
    recAestheticContent13: 'Results last 6-18 months depending on type',
    recAestheticContent14: '3. Chemical Peels',
    recAestheticContent15: 'Chemical solutions that remove damaged skin layers.',
    recAestheticContent16: 'Improves texture, reduces fine lines, evens skin tone',
    recAestheticContent17: 'Types:',
    recAestheticContent18: 'Light, medium, and deep peels',
    recAestheticContent19: 'Downtime:',
    recAestheticContent20: 'Varies from none to several days',
    recAestheticContent21: '4. Laser Treatments',
    recAestheticContent22: 'Laser technology for various skin concerns.',
    recAestheticContent23: 'Skin resurfacing, hair removal, pigmentation treatment',
    recAestheticContent24: 'Fractional laser, IPL, laser hair removal',
    recAestheticContent25: 'Results:',
    recAestheticContent26: 'Gradual improvement over multiple sessions',
    recAestheticContent27: 'Advanced Skin Treatments',
    recAestheticContent28: 'Microneedling',
    recAestheticContent29: 'Creates micro-injuries to stimulate collagen production.',
    recAestheticContent30: 'Improves texture, reduces scars, tightens skin',
    recAestheticContent31: 'Mild redness for 24-48 hours',
    recAestheticContent32: 'Radiofrequency Treatments',
    recAestheticContent33: 'Uses radiofrequency energy to heat and tighten skin.',
    recAestheticContent34: 'Skin tightening, wrinkle reduction, body contouring',
    recAestheticContent35: 'Minimal, slight redness',
    recAestheticContent36: 'Ultrasound Therapy',
    recAestheticContent37: 'Uses ultrasound energy to lift and tighten skin.',
    recAestheticContent38: 'Non-invasive lifting, skin tightening, natural results',
    recAestheticContent39: 'Minimal, no downtime',
    recAestheticContent40: 'Treatment Planning',
    recAestheticContent41: 'Consultation Process',
    recAestheticContent42: 'Skin assessment:',
    recAestheticContent43: 'Evaluate skin condition and concerns',
    recAestheticContent44: 'Goal setting:',
    recAestheticContent45: 'Discuss desired outcomes and expectations',
    recAestheticContent46: 'Treatment plan:',
    recAestheticContent47: 'Develop personalized treatment protocol',
    recAestheticContent48: 'Timeline:',
    recAestheticContent49: 'Establish treatment schedule and maintenance',
    recAestheticContent50: 'Combination Treatments',
    recAestheticContent51: 'Multi-modal approach:',
    recAestheticContent52: 'Combine different treatments for optimal results',
    recAestheticContent53: 'Staggered treatments:',
    recAestheticContent54: 'Space treatments appropriately',
    recAestheticContent55: 'Maintenance schedule:',
    recAestheticContent56: 'Plan ongoing treatments for sustained results',
    recAestheticContent57: 'Home care:',
    recAestheticContent58: 'Integrate professional treatments with home care',
    recAestheticQuickTip1: 'Schedule consultations to discuss treatment options and expectations',
    recAestheticQuickTip2: 'Consider combination treatments for optimal results',
    recAestheticQuickTip3: 'Plan treatments around your schedule and downtime tolerance',
    recWellnessIntro: 'Discover holistic treatment modalities that address physical, mental, and emotional well-being for complete wellness. These approaches combine ancient wisdom with modern techniques.',
    recWellnessContent1: 'Wellness therapies focus on treating the whole person, addressing physical, mental, and emotional well-being. These holistic approaches combine ancient wisdom with modern techniques to promote balance, healing, and overall wellness. From aromatherapy to meditation, these therapies support your journey toward optimal health.',
    recWellnessContent2: 'Holistic Treatment Modalities',
    recWellnessContent3: '1. Aromatherapy',
    recWellnessContent4: 'Uses essential oils to promote physical and emotional well-being.',
    recWellnessContent5: 'Stress relief, mood enhancement, relaxation',
    recWellnessContent6: 'Applications:',
    recWellnessContent7: 'Massage, inhalation, baths, diffusers',
    recWellnessContent8: 'Popular oils:',
    recWellnessContent9: 'Lavender, eucalyptus, peppermint, chamomile',
    recWellnessContent10: '2. Reflexology',
    recWellnessContent11: 'Applies pressure to specific points on feet, hands, and ears.',
    recWellnessContent12: 'Stress relief, improved circulation, pain reduction',
    recWellnessContent13: 'Technique:',
    recWellnessContent14: 'Targeted pressure on reflex points',
    recWellnessContent15: '30-60 minutes',
    recWellnessContent16: '3. Reiki',
    recWellnessContent17: 'Energy healing technique that promotes relaxation and healing.',
    recWellnessContent18: 'Stress reduction, emotional healing, energy balance',
    recWellnessContent19: 'Light touch or hands hovering over body',
    recWellnessContent20: 'Experience:',
    recWellnessContent21: 'Deep relaxation, warmth, tingling sensations',
    recWellnessContent22: '4. Meditation and Mindfulness',
    recWellnessContent23: 'Guided meditation and mindfulness practices for mental wellness.',
    recWellnessContent24: 'Stress reduction, improved focus, emotional balance',
    recWellnessContent25: 'Techniques:',
    recWellnessContent26: 'Breathing exercises, visualization, body scanning',
    recWellnessContent27: '15-60 minutes',
    recWellnessContent28: 'Bodywork Therapies',
    recWellnessContent29: 'Craniosacral Therapy',
    recWellnessContent30: 'Gentle touch therapy focusing on the craniosacral system.',
    recWellnessContent31: 'Stress relief, pain reduction, improved function',
    recWellnessContent32: 'Headaches, stress, trauma recovery',
    recWellnessContent33: 'Lymphatic Drainage',
    recWellnessContent34: 'Gentle massage technique to stimulate lymphatic flow.',
    recWellnessContent35: 'Reduces swelling, boosts immunity, detoxification',
    recWellnessContent36: 'Post-surgery, chronic swelling, immune support',
    recWellnessContent37: 'Wellness Benefits',
    recWellnessContent38: 'Physical Benefits',
    recWellnessContent39: 'Stress reduction:',
    recWellnessContent40: 'Lowers cortisol and stress hormones',
    recWellnessContent41: 'Improved sleep:',
    recWellnessContent42: 'Promotes better sleep quality and duration',
    recWellnessContent43: 'Pain relief:',
    recWellnessContent44: 'Reduces chronic pain and tension',
    recWellnessContent45: 'Enhanced immunity:',
    recWellnessContent46: 'Boosts immune system function',
    recWellnessContent47: 'Better circulation:',
    recWellnessContent48: 'Improves blood and lymphatic flow',
    recWellnessContent49: 'Mental and Emotional Benefits',
    recWellnessContent50: 'Mental clarity:',
    recWellnessContent51: 'Improves focus and cognitive function',
    recWellnessContent52: 'Emotional balance:',
    recWellnessContent53: 'Helps regulate emotions and mood',
    recWellnessContent54: 'Anxiety reduction:',
    recWellnessContent55: 'Decreases anxiety and worry',
    recWellnessContent56: 'Depression support:',
    recWellnessContent57: 'Helps manage depression symptoms',
    recWellnessContent58: 'Self-awareness:',
    recWellnessContent59: 'Increases mindfulness and self-awareness',
    recWellnessQuickTip1: 'Try aromatherapy for stress relief and mood enhancement',
    recWellnessQuickTip2: 'Consider reflexology for improved circulation and pain reduction',
    recWellnessQuickTip3: 'Practice meditation and mindfulness for mental wellness',
    recSpaExperienceIntro: 'Learn how to maximize your spa experience and get the most value from your wellness investment. A spa visit is more than just a treatment—it\'s a complete wellness experience.',
    recSpaExperienceContent1: 'A spa visit is more than just a treatment—it\'s a complete wellness experience designed to rejuvenate your mind, body, and spirit. Understanding how to prepare for and make the most of your spa experience ensures you receive maximum benefits and enjoyment from your wellness investment.',
    recSpaExperienceContent2: 'Pre-Spa Preparation',
    recSpaExperienceContent3: 'Before Your Visit',
    recSpaExperienceContent4: 'Hydration:',
    recSpaExperienceContent5: 'Drink plenty of water before your appointment',
    recSpaExperienceContent6: 'Light meals:',
    recSpaExperienceContent7: 'Eat lightly to avoid discomfort during treatments',
    recSpaExperienceContent8: 'Arrive early:',
    recSpaExperienceContent9: 'Allow time to relax and prepare mentally',
    recSpaExperienceContent10: 'Communicate needs:',
    recSpaExperienceContent11: 'Inform staff of any health conditions or preferences',
    recSpaExperienceContent12: 'Dress comfortably:',
    recSpaExperienceContent13: 'Wear loose, comfortable clothing',
    recSpaExperienceContent14: 'What to Bring',
    recSpaExperienceContent15: 'Identification:',
    recSpaExperienceContent16: 'Bring ID and any necessary documentation',
    recSpaExperienceContent17: 'Comfort items:',
    recSpaExperienceContent18: 'Bring personal items that enhance relaxation',
    recSpaExperienceContent19: 'Questions:',
    recSpaExperienceContent20: 'Prepare questions about treatments and aftercare',
    recSpaExperienceContent21: 'Open mind:',
    recSpaExperienceContent22: 'Be open to trying new treatments and experiences',
    recSpaExperienceContent23: 'During Your Spa Visit',
    recSpaExperienceContent24: 'Relaxation Areas',
    recSpaExperienceContent25: 'Lounge areas:',
    recSpaExperienceContent26: 'Take time to relax before and after treatments',
    recSpaExperienceContent27: 'Sauna and steam:',
    recSpaExperienceContent28: 'Use heat therapy for additional benefits',
    recSpaExperienceContent29: 'Quiet spaces:',
    recSpaExperienceContent30: 'Find peaceful areas for meditation or reading',
    recSpaExperienceContent31: 'Refreshments:',
    recSpaExperienceContent32: 'Enjoy healthy snacks and beverages',
    recSpaExperienceContent33: 'Treatment Etiquette',
    recSpaExperienceContent34: 'Communication:',
    recSpaExperienceContent35: 'Communicate openly with your therapist',
    recSpaExperienceContent36: 'Feedback:',
    recSpaExperienceContent37: 'Provide feedback on pressure and comfort',
    recSpaExperienceContent38: 'Relaxation:',
    recSpaExperienceContent39: 'Focus on relaxation and letting go',
    recSpaExperienceContent40: 'Presence:',
    recSpaExperienceContent41: 'Be present and mindful during treatments',
    recSpaExperienceContent42: 'Post-Treatment Care',
    recSpaExperienceContent43: 'Immediate Aftercare',
    recSpaExperienceContent44: 'Drink plenty of water to flush toxins',
    recSpaExperienceContent45: 'Rest:',
    recSpaExperienceContent46: 'Allow time to rest and integrate the treatment',
    recSpaExperienceContent47: 'Gentle movement:',
    recSpaExperienceContent48: 'Engage in light, gentle movement',
    recSpaExperienceContent49: 'Healthy meals:',
    recSpaExperienceContent50: 'Eat nourishing, light meals',
    recSpaExperienceContent51: 'Long-term Benefits',
    recSpaExperienceContent52: 'Regular visits:',
    recSpaExperienceContent53: 'Schedule regular treatments for ongoing benefits',
    recSpaExperienceContent54: 'Home care:',
    recSpaExperienceContent55: 'Integrate recommended home care practices',
    recSpaExperienceContent56: 'Lifestyle changes:',
    recSpaExperienceContent57: 'Adopt healthy lifestyle habits',
    recSpaExperienceContent58: 'Stress management:',
    recSpaExperienceContent59: 'Practice stress reduction techniques',
    recSpaExperienceContent60: 'Choosing the Right Spa',
    recSpaExperienceContent61: 'Research Factors',
    recSpaExperienceContent62: 'Reputation:',
    recSpaExperienceContent63: 'Read reviews and ask for recommendations',
    recSpaExperienceContent64: 'Services:',
    recSpaExperienceContent65: 'Ensure they offer treatments you\'re interested in',
    recSpaExperienceContent66: 'Staff qualifications:',
    recSpaExperienceContent67: 'Verify therapist training and certifications',
    recSpaExperienceContent68: 'Facility quality:',
    recSpaExperienceContent69: 'Visit to assess cleanliness and atmosphere',
    recSpaExperienceContent70: 'Pricing:',
    recSpaExperienceContent71: 'Understand costs and package options',
    recSpaExperienceContent72: 'Red Flags to Avoid',
    recSpaExperienceContent73: 'Poor hygiene:',
    recSpaExperienceContent74: 'Avoid spas with cleanliness issues',
    recSpaExperienceContent75: 'Unqualified staff:',
    recSpaExperienceContent76: 'Ensure therapists are properly trained',
    recSpaExperienceContent77: 'Pressure tactics:',
    recSpaExperienceContent78: 'Avoid spas that pressure you into services',
    recSpaExperienceContent79: 'Unclear pricing:',
    recSpaExperienceContent80: 'Ensure transparent pricing and policies',
    recSpaExperienceContent81: 'Poor communication:',
    recSpaExperienceContent82: 'Choose spas that listen to your needs',
    recSpaExperienceQuickTip1: 'Arrive early to relax and prepare mentally',
    recSpaExperienceQuickTip2: 'Communicate openly with your therapist about preferences',
    recSpaExperienceQuickTip3: 'Stay hydrated and rest after treatments',
    readyBeginWellnessJourney: 'Ready to Begin Your Wellness Journey?',
    dontWaitExperienceSpa: 'Don\'t wait to experience the transformative benefits of professional spa treatments and wellness therapies! Book a consultation with one of our expert therapists who specialize in massage therapy, aesthetic treatments, and holistic wellness. From stress relief to skin rejuvenation, we\'ll help you achieve optimal health and well-being through personalized treatments and care.',
    bookSpaTreatment: 'Book Spa Treatment',
    bookMassage: 'Book Massage',
    // Hair & Nail Salon Recommended Content - English
    recHairNailTitle: 'Recommended Services',
    recHairNailSubtitle: 'Practical advice, checklists, and scripts to get the result you want',
    recHairNailDescription: 'Discover services tailored to your needs',
    recFaceShapeTitle: 'Find Your Perfect Hairstyle Based on Face Shape',
    recFaceShapeDescription: 'Learn how to identify your face shape and choose hairstyles that enhance your natural beauty and boost your confidence',
    recFaceShapeContent1: 'A quick, accurate understanding of your face shape helps pick haircuts and fringes that flatter your features and save time and disappointment. Do the simple photo + measure test at home before your consult.',
    recFaceShapeContent2: 'Do this before your salon consult',
    recFaceShapeContent3: 'Stand in natural light, pull hair back and take a straight-on photo.',
    recFaceShapeContent4: 'Mark the widest points (forehead/cheekbones/jaw) and measure approximate proportions.',
    recFaceShapeContent5: 'Note how much time you want to spend styling daily — that should guide recommendations.',
    recFaceShapeContent6: 'Style guidance by shape (quick)',
    recFaceShapeContent7: 'Most styles work. Consider trying bobs, long layers or face-framing pieces.',
    recFaceShapeContent8: 'Add vertical length and angles — long layers, deep side parts, face-framing highlights.',
    recFaceShapeContent9: 'Soften the jaw with textured layers and side-swept fringes.',
    recFaceShapeContent10: 'Bring balance by adding width at chin level — lobs, soft waves.',
    recFaceShapeContent11: 'Use soft fringes or chin-length pieces to balance cheekbones.',
    recFaceShapeContent12: 'Create width with shoulder-length styles, waves, or blunt bangs to shorten the perceived length.',
    recFaceShapeContent13: 'Turn it into an effective conversation',
    recFaceShapeContent14: 'Bring 2–3 photos showing the look you like from different angles and tell your stylist how much time you want to spend styling each morning.',
    recHairTrendsTitle: 'Master Trending Hair Styles & At-Home Styling',
    recHairTrendsDescription: 'Discover the hottest hair trends of 2024 and learn professional techniques to recreate them at home with salon-quality results',
    recHairTrendsContent1: 'Styles trending now emphasize texture and natural movement rather than stiff precision. The look should fit your life — here\'s how to get those trends to work for you.',
    recHairTrendsContent3: 'Use a salt or texture spray and diffuse lightly. Ask for internal layering (not heavy weight removal) at the salon to keep shape.',
    recHairTrendsContent4: 'Low commitment — growable and forgiving. Style with a round brush or a quick flat-iron swoop.',
    recHairTrendsContent5: 'Sleek, low-frizz styling benefits from a smoothing product and a quality paddle brush.',
    recHairTrendsContent6: 'Small framed highlights or slightly shorter front layers — they brighten and are easy to maintain.',
    recHairTrendsContent7: 'Styling recipes (simple)',
    recHairTrendsContent8: 'For soft waves: 1) Work heat protectant through damp hair. 2) Use a 1" curling wand, wrap sections away from your face for 8–10s, then finger-comb with a texturizing spray.',
    recHairColorTitle: 'Professional Hair Coloring Guide & Color Maintenance',
    recHairColorDescription: 'Understand different hair coloring techniques, choose the right color for your skin tone, and maintain vibrant color between salon visits',
    recHairColorContent1: 'Color can transform your look — keep it healthy and wearable by understanding the technique and the upkeep needed.',
    recHairColorContent3: 'Hand-painted highlights that grow out more invisibly — lower maintenance for many people.',
    recHairColorContent4: 'Softens the line between natural root and color so you can extend time between touch-ups.',
    recHairColorContent5: 'Brightens the face with a few strategically placed lighter strands.',
    recHairColorContent6: 'Refreshes tone and increases shine without heavy chemical lift.',
    recHairColorContent7: 'At-home care that actually helps',
    recHairColorContent8: 'Use a color-safe, sulfate-free shampoo and conditioner — avoid daily washing when possible.',
    recHairColorContent9: 'Use a weekly deep-conditioning mask if your hair is porous or chemically treated.',
    recHairColorContent10: 'Choose a purple shampoo only if you see warm/brassy tones on blonde; use it sparingly (once a week to start).',
    recHairColorContent11: 'Always use a heat protectant before hot tools to protect color and reduce breakage.',
    recHairColorContent12: 'Patch test & allergies',
    recHairColorContent13: 'If you\'ve had reactions before or sensitive skin, ask for a patch test 48–72 hours prior to any new color treatment.',
    recNailCareTitle: 'Complete Nail Care Guide & Design Inspiration',
    recNailCareDescription: 'Learn essential nail care routines, choose the perfect nail shape and length for your lifestyle, and discover stunning design ideas',
    recNailCareContent1: 'Great-looking nails start with healthy preparation and realistic expectations — know the options and the maintenance routines that preserve nail health.',
    recNailCareContent2: 'Choosing a style that fits your life',
    recNailCareContent3: 'Short/clean: minimal upkeep, easier for manual tasks and sports.',
    recNailCareContent4: 'Medium with small art accents: balances style and durability.',
    recNailCareContent5: 'Long or intricate art: higher maintenance — plan appointments accordingly.',
    recNailCareContent6: 'Preparation & aftercare tips',
    recNailCareContent7: 'Arrive with clean nails (no polish) so the technician can assess natural condition.',
    recNailCareContent8: 'Use cuticle oil daily to keep cuticles soft and prevent lifting.',
    recNailCareContent9: 'Seal edges with a top coat and reapply a clear top coat every few days to extend wear.',
    recNailCareContent10: 'Quick fixes for common nail problems',
    recNailCareContent11: 'Small lift or crack: gently file the edge smooth and apply a thin layer of top coat; see your tech for a proper repair.',
    recNailCareContent12: 'Broken natural nail: clean, dry, and apply a flexible adhesive patch (or ask your tech to reinforce with a thin overlay).',
    recMaintenanceTitle: 'Salon Results Maintenance & Hair/Nail Health',
    recMaintenanceDescription: 'Extend your salon results with professional maintenance routines, proper product selection, and healthy habits for beautiful hair and nails',
    recMaintenanceContent1: 'Consistency beats expensive interventions. A few good habits repeated regularly preserve salon results and hair/nail health.',
    recMaintenanceContent3: 'Limit washing to 2–3× per week if possible (adjust for scalp oiliness); use lukewarm or cool water.',
    recMaintenanceContent4: 'Apply a hydrating mask or leave-in treatment once per week for dry or colored hair.',
    recMaintenanceContent5: 'Use cuticle oil nightly and a nourishing hand cream after washing hands.',
    recMaintenanceContent7: 'Schedule trims to remove split ends and preserve shape (frequency depends on style).',
    recMaintenanceContent8: 'Refresh gloss/toner or targeted refresh if color starts to fade noticeably.',
    recMaintenanceContent9: 'For enhancements (extensions, overlays), schedule regular maintenance appointments recommended by your tech.',
    recMaintenanceContent10: 'Protective daily habits',
    recMaintenanceContent11: 'Use heat protectant and avoid max heat settings on tools.',
    recMaintenanceContent12: 'Sleep on a silk pillowcase or use a silk/satin scarf to reduce friction.',
    recMaintenanceContent13: 'Wear gloves for extended cleaning or gardening to protect nails and hands from harsh chemicals.',
    recHairNailHealthTitle: 'Essential Hair & Nail Health Tips',
    recHairNailHealthDescription: 'Learn professional tips for maintaining healthy hair and nails between salon visits, preventing damage, and achieving long-lasting beauty results',
    recHairNailHealthContent1: 'Healthy hair and nails are the foundation of beautiful salon results. These professional tips will help you maintain your salon look longer and prevent common damage issues.',
    recHairNailHealthContent3: 'Wash hair 2-3 times per week maximum to preserve natural oils and color.',
    recHairNailHealthContent4: 'Use lukewarm water - hot water strips moisture and causes frizz.',
    recHairNailHealthContent5: 'Choose sulfate-free formulas for colored hair, clarifying shampoos for buildup.',
    recHairNailHealthContent6: 'Apply conditioner from mid-length to ends, leave for 2-3 minutes before rinsing.',
    recHairNailHealthContent7: 'Pat hair gently with a microfiber towel, avoid rubbing which causes breakage.',
    recHairNailHealthContent8: 'Heat Styling Protection',
    recHairNailHealthContent9: 'Heat Protectant',
    recHairNailHealthContent10: 'Temperature Settings',
    recHairNailHealthContent11: 'Tool Selection',
    recHairNailHealthContent12: 'Limit heat styling to 2-3 times per week maximum.',
    recHairNailHealthContent13: 'Cool Down',
    recHairNailHealthContent14: 'Nail Care Essentials',
    recHairNailHealthContent15: 'Cuticle Care',
    recHairNailHealthContent16: 'Nail Shape',
    recHairNailHealthContent17: 'Length Maintenance',
    recHairNailHealthContent18: 'Base Coat',
    recHairNailHealthContent19: 'Top Coat',
    recHairNailHealthContent20: 'Nutrition for Hair & Nail Health',
    recHairNailHealthContent21: 'Protein',
    recHairNailHealthContent22: 'Biotin',
    recHairNailHealthContent23: 'Iron',
    recHairNailHealthContent24: 'Omega-3s',
    recHairNailHealthContent25: 'Hydration',
    recHairNailHealthContent26: 'Common Problems & Solutions',
    recHairNailHealthContent27: 'Use deep conditioning treatments weekly and avoid over-washing.',
    recHairNailHealthContent28: 'Regular trims every 6-10 weeks prevent further damage.',
    recHairNailHealthContent29: 'Apply nail strengthener and avoid harsh chemicals.',
    recHairNailHealthContent30: 'Use color-safe products and protect from UV exposure.',
    recHairNailHealthContent31: 'Keep nails moisturized and avoid picking at polish.',
    recHairNailHealthContent32: 'Professional Maintenance Schedule',
    recHairNailHealthContent33: 'Every 6-10 weeks to maintain shape and remove damage.',
    recHairNailHealthContent34: 'Every 4-8 weeks depending on growth rate and color type.',
    recHairNailHealthContent35: 'Monthly professional treatments for damaged hair.',
    recHairNailHealthContent36: 'Every 2-3 weeks for optimal nail health and appearance.',
    recHairNailHealthContent37: 'Monthly for foot health and relaxation.',
    // Quick Tips for Hair & Nail Salon
    quickTipPhoto: 'Take a straight-on photo with hair pulled back',
    quickTipMeasure: 'Measure your face proportions',
    quickTipTime: 'Consider your daily styling time commitment',
    quickTipTexturedLob: 'Textured lob works great with salt spray',
    quickTipCurtainBangs: 'Curtain bangs are low-commitment and forgiving',
    quickTipHeatProtectant: 'Use heat protectant before styling tools',
    quickTipBalayage: 'Balayage grows out more naturally than traditional highlights',
    quickTipSulfateFree: 'Use sulfate-free shampoo to preserve color',
    quickTipPatchTest: 'Always request a patch test for new colors',
    quickTipCleanNails: 'Arrive with clean nails for better assessment',
    quickTipCuticleOil: 'Use cuticle oil daily to prevent lifting',
    quickTipLength: 'Choose length based on your lifestyle',
    quickTipWashing: 'Limit hair washing to 2-3 times per week',
    quickTipSilk: 'Use silk pillowcases to reduce friction',
    quickTipTrims: 'Schedule regular trims every 6-10 weeks',
    quickTipSulfateFreeHair: 'Use sulfate-free shampoo for colored hair',
    quickTipCuticleOilNails: 'Apply cuticle oil daily for stronger nails',
    quickTipThermalSprays: 'Protect hair from heat damage with thermal sprays',
    // Additional section headings
    'Dry Hair': 'Dry Hair',
    'Split Ends': 'Split Ends',
    'Brittle Nails': 'Brittle Nails',
    'Color Fading': 'Color Fading',
    'Nail Peeling': 'Nail Peeling',
    'Hair Trims': 'Hair Trims',
    'Color Touch-ups': 'Color Touch-ups',
    'Deep Conditioning': 'Deep Conditioning',
    Manicures: 'Manicures',
    Pedicures: 'Pedicures',
    // Privacy Policy
    privacyLead: 'We collect only what we need to run Ehgezly, never sell your data, and protect it with strong security controls.',
    ppWhatWeCollect: 'What we collect',
    ppHowWeUse: 'How we use it',
    ppSharing: 'Sharing',
    ppSecurity: 'Security and retention',
    ppYourChoices: 'Your choices',
    // Category Components
    allBarbers: 'All Barbers',
    allHairNailSalons: 'All Hair & Nail Salons',
    allTattooPiercingShops: 'All Tattoo & Piercing Shops',
    allLaserClinics: 'All Laser Clinics',
    allBrowsLashes: 'All Brows & Lashes',
    allMakeup: 'All Makeup',
    allMassage: 'All Massage',
    allPetServices: 'All Pet Services',
    // Filter Components
    showFilters: 'Show Filters',
    hideFilters: 'Hide Filters',
    noSalonsFound: 'No salons found',
    tryAdjustingFilters: 'Try adjusting your filters or search terms to find more results.',
    clearFilters: 'Clear Filters',
    advancedFilters: 'Advanced Filters',
    sortBy: 'Sort by:',
    minimumRating: 'Minimum Rating',
    filterByTown: 'Filter by Town',
    priceRange: 'Price Range',
    // Booking Page - Days
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    // Booking Page - Time
    time: 'Time',
    selectTime: 'Select a time',
    availableTimes: 'Available Times',
    noAvailableTimes: 'No available times',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening',
    // Booking Page Login Prompt
    signInToBook: '🔐 Sign in to book your appointment',
    createAccountOrSignIn: 'Create an account or sign in to continue with your booking. Your selections will be saved automatically.',
    createAccount: 'Create Account',
    signIn: 'Sign In',
    // AI Support
    aiSupportOpen: 'Open AI Support',
    aiAssistantTitle: 'Ehgezly AI Assistant',
    aiAssistantSubtitle: 'How can I help you today?',
    aiWhatDoYouNeed: 'What do you need help with?',
    aiQuickActions: 'Quick Actions',
    aiBookAppointment: 'Book an appointment',
    aiViewBookings: 'View my bookings',
    aiContactSupport: 'Contact support',
    aiReportProblem: 'Report a problem',
    aiBackToCategories: '← Back',
    aiBackToQuestions: '← Back to Questions',
    aiBookNow: 'Book Now',
    aiAskAnotherQuestion: 'Ask Another Question',
    aiContactHumanSupport: 'Contact Human Support',
    aiNeedHelpWith: 'I need help with:',
    aiWasThisHelpful: 'Was this helpful?',
    aiYes: 'Yes',
    aiNo: 'No',
    aiTypeYourQuestion: 'Type your question...',
    aiRelatedQuestions: 'Related Questions',
    aiFeedbackYes: "Great! I'm glad I could help. Is there anything else you'd like to know?",
    aiFeedbackNo: "I'm sorry that wasn't helpful. Would you like to contact our support team for more assistance?",
    aiNoSpecificAnswer: 'I can help with booking, your account, or finding a salon. For anything else, message us on WhatsApp.',
    aiCtaVerifyEmail: 'Verify email',
    aiCtaBrowseSalons: 'Browse salons',
    aiCtaSignUp: 'Sign up',
    aiCtaResetPassword: 'Reset password',
    aiCtaEditProfile: 'Open profile',
    aiCtaDeleteAccount: 'Delete account page',
    aiCtaExplore: 'Open Explore',
    aiCtaListBusiness: 'List your business',
    aiCtaLeaveReview: 'Open History',
    aiCtaContact: 'Contact us',
    aiCtaPrivacy: 'Privacy Policy',
    aiCtaWhatsApp: 'Chat on WhatsApp',
    aiCtaToggleLang: 'Switch to Arabic',
    // AI Support Categories
    aiCategoryBooking: 'Booking',
    aiCategoryAccount: 'Account',
    aiCategoryBusiness: 'Salons',
    aiCategoryTechnical: 'Support',
    // AI Support Questions - Booking
    aiQHowToBook: 'How do I book an appointment?',
    aiAHowToBook: 'On Home, pick a category, then a salon. Choose a service, staff, date, and time, and send the request. The salon accepts or declines, and you get an email. You can have only one active booking at a time.',
    aiQCancelAppointment: 'How do I cancel a booking?',
    aiACancelAppointment: 'Open Dashboard and cancel your current booking. Reschedule is not available yet — to change the time, cancel and book again.',
    aiQBookingFailed: 'My booking failed, what should I do?',
    aiABookingFailed: 'This is usually because your email is not verified, the slot was taken, or you already have an active booking. Ehgezly does not take payment when you book. Check your email for a verification code, or open Dashboard to see your current appointment.',
    aiQNoAvailability: 'No available time slots shown',
    aiANoAvailability: 'That staff or day may be full. Try another time, another staff member, or a different salon.',
    aiQBookingPending: 'Why is my booking still Pending?',
    aiABookingPending: 'Pending means the salon has not accepted or declined yet. Wait for their reply — you will get an email. Check the booking on Dashboard.',
    aiQBookingNotAvailable: 'I got Not available. What now?',
    aiABookingNotAvailable: 'The salon could not take that slot. Pick another time, staff member, or salon and send a new request.',
    aiQActiveBookingBlock: 'I already have an appointment, why can’t I book?',
    aiAActiveBookingBlock: 'You can have only one active booking at a time (pending or confirmed). Cancel it from Dashboard first, then book the new one.',
    aiQLeaveReview: 'How do I leave a review?',
    aiALeaveReview: 'After a completed visit, open History in Dashboard and rate the salon. We also email a review link.',
    // AI Support Questions - Account
    aiQCreateAccount: 'How do I create an account?',
    aiACreateAccount: 'Tap Sign up, enter your email and Egyptian phone number, then enter the code we send to your email. You need a verified email to book.',
    aiQVerifyEmail: 'I need to verify my email / I did not get the code',
    aiAVerifyEmail: 'We send a 4-digit code to your email, not SMS. Check spam. On the verification screen you can request a new code. You must verify before you can book.',
    aiQForgotPassword: 'I forgot my password, how to reset?',
    aiAForgotPassword: 'On the login page, tap Forgot password. We email you a reset code — not a link. Enter the code and choose a new password.',
    aiQUpdateProfile: 'How do I update my profile?',
    aiAUpdateProfile: 'In Dashboard, open the Profile tab to change your name, phone, or photo.',
    aiQDeleteAccount: 'How do I delete my account?',
    aiADeleteAccount: 'Submit a request on the Delete account page. Our team reviews it — your account is not removed instantly.',
    aiQChangeLanguage: 'How do I switch English / Arabic?',
    aiAChangeLanguage: 'Use the AR / EN button at the top of Home. The site and this help chat follow that language.',
    // AI Support Questions - Finding a salon
    aiQFindBusiness: 'How do I find a salon?',
    aiAFindBusiness: 'Use the category boxes on Home. After you sign in, you can also use Explore and Map. On the website, Explore and Map need an account.',
    aiQListBusiness: 'How do I list my salon on Ehgezly?',
    aiAListBusiness: 'Shop owners add a salon with List your business — services, staff, hours, and photos. Do not message a salon to get listed; use the form.',
    aiQBusinessHours: 'How do I check salon hours?',
    aiABusinessHours: 'Open a salon and start a booking. The available times are the hours they take appointments that day.',
    aiQServicePrices: 'How do I see service prices?',
    aiAServicePrices: 'Prices appear when you pick a service on the salon page, and again in the summary before you send the request.',
    aiQBusinessReviews: 'How do I read or leave a review?',
    aiABusinessReviews: 'Read reviews on the salon page. After a completed visit, leave yours from History in Dashboard, or from the review email we send.',
    // AI Support Questions - Technical
    aiQAppNotWorking: 'The site is not working properly',
    aiAAppNotWorking: 'Refresh the page or try another browser. If it still fails, contact us.',
    aiQNotificationsNotWorking: 'I\'m not receiving notifications',
    aiANotificationsNotWorking: 'Booking updates go to your email and to Notifications in Dashboard. Check spam, and make sure the email on your account is correct.',
    aiQSlowLoading: 'The site is loading slowly',
    aiASlowLoading: 'Check your connection, close extra tabs, and refresh. If it stays slow, contact us.',
    aiQDataPrivacy: 'How is my data protected?',
    aiADataPrivacy: 'We use your name, email, and phone to run your account and bookings. Salons see what they need for the appointment. Read the Privacy Policy for details.',
    aiQContactHuman: 'How do I contact a human?',
    aiAContactHuman: 'Message us on WhatsApp or send a note from the Contact page. Use WhatsApp for a faster reply.',
    // Barbershop content translations - English
    recBarberMustacheIntro: 'Discover the perfect mustache style that enhances your facial features and reflects your personal style. From classic sophistication to bold modern statements, find the ideal mustache for your face shape and lifestyle.',
    recBarberMustacheContent1: 'The mustache has made a major comeback in 2024, with styles ranging from classic sophistication to bold modern statements. Professional barbers share their expertise on choosing the perfect mustache style for your face shape, lifestyle, and personal preference.',
    recBarberMustacheContent2: 'Popular Mustache Styles',
    recBarberMustacheContent3: '1. The Classic Pencil Mustache',
    recBarberMustacheContent4: 'Description:',
    recBarberMustacheContent5: 'Thin, precise line above the upper lip, popularized by Hollywood icons like Clark Gable.',
    recBarberMustacheContent6: 'Best for:',
    recBarberMustacheContent7: 'Professional settings, formal occasions, and those who prefer subtle facial hair.',
    recBarberMustacheContent8: 'Maintenance:',
    recBarberMustacheContent9: 'Daily trimming with precision scissors or electric trimmer.',
    recBarberMustacheContent10: '2. The Handlebar Mustache',
    recBarberMustacheContent11: 'Full mustache with curled ends that point upward, creating a distinctive, bold look.',
    recBarberMustacheContent12: 'Those who want a statement piece and don\'t mind daily styling.',
    recBarberMustacheContent13: 'Styling:',
    recBarberMustacheContent14: 'Use mustache wax to curl and hold the ends in place.',
    recBarberMustacheContent15: '3. The Chevron Mustache',
    recBarberMustacheContent16: 'Thick, full mustache that covers the upper lip, popularized by Tom Selleck.',
    recBarberMustacheContent17: 'Men with thick facial hair who want a classic, masculine look.',
    recBarberMustacheContent18: 'Regular trimming to maintain shape and prevent overgrowth.',
    recBarberMustacheContent19: '4. The Horseshoe Mustache',
    recBarberMustacheContent20: 'Mustache that extends down the sides of the mouth, resembling a horseshoe shape.',
    recBarberMustacheContent21: 'Bold individuals who want a distinctive, edgy look.',
    recBarberMustacheContent22: 'Requires careful trimming to maintain the horseshoe shape.',
    recBarberMustacheContent23: 'Choosing the Right Mustache Style',
    recBarberMustacheContent24: 'Face Shape Considerations',
    recBarberMustacheContent25: 'Round faces:',
    recBarberMustacheContent26: 'Choose styles that add length, like the pencil or handlebar',
    recBarberMustacheContent27: 'Square faces:',
    recBarberMustacheContent28: 'Softer styles like the chevron work well',
    recBarberMustacheContent29: 'Oval faces:',
    recBarberMustacheContent30: 'Most styles work, experiment to find your preference',
    recBarberMustacheContent31: 'Long faces:',
    recBarberMustacheContent32: 'Fuller styles like the chevron add width',
    recBarberMustacheContent33: 'Lifestyle Factors',
    recBarberMustacheContent34: 'Professional environment:',
    recBarberMustacheContent35: 'Consider workplace policies and client expectations',
    recBarberMustacheContent36: 'Maintenance time:',
    recBarberMustacheContent37: 'Some styles require daily styling and care',
    recBarberMustacheContent38: 'Personal style:',
    recBarberMustacheContent39: 'Choose a style that reflects your personality',
    recBarberMustacheContent40: 'Hair growth pattern:',
    recBarberMustacheContent41: 'Work with your natural hair growth',
    recBarberHaircutIntro: 'Master the hottest haircut trends and learn professional styling techniques that blend classic barbering with modern aesthetics. From precision cuts to textured styles, discover versatile looks that enhance your individual expression.',
    recBarberHaircutContent1: 'Men\'s haircuts have evolved significantly, blending classic barbering techniques with modern styling trends. From precision cuts to textured styles, this year\'s trends focus on versatility, low maintenance, and individual expression.',
    recBarberHaircutContent2: 'Top Haircut Trends',
    recBarberHaircutContent3: '1. The Modern Fade',
    recBarberHaircutContent4: 'Gradual transition from short to shorter hair, creating a seamless blend.',
    recBarberHaircutContent5: 'Variations:',
    recBarberHaircutContent6: 'High fade, mid fade, low fade, skin fade',
    recBarberHaircutContent7: 'Touch-ups every 2-3 weeks to maintain the fade',
    recBarberHaircutContent8: '2. The Textured Crop',
    recBarberHaircutContent9: 'Short, textured cut with choppy layers and natural movement.',
    recBarberHaircutContent10: 'Thick hair that needs texture and movement',
    recBarberHaircutContent11: 'Use texturizing products for added definition',
    recBarberHaircutContent12: '3. The Classic Side Part',
    recBarberHaircutContent13: 'Timeless style with a defined part and slicked-back sides.',
    recBarberHaircutContent14: 'Professional settings and formal occasions',
    recBarberHaircutContent15: 'Use pomade or gel for a polished look',
    recBarberHaircutContent16: '4. The Long Top, Short Sides',
    recBarberHaircutContent17: 'Longer hair on top with shorter sides, allowing for versatile styling.',
    recBarberHaircutContent18: 'Styling options:',
    recBarberHaircutContent19: 'Slicked back, textured, or styled up',
    recBarberHaircutContent20: 'Regular trims to maintain shape',
    recBarberHaircutContent21: 'Hair Styling Tips',
    recBarberHaircutContent22: 'Product Selection',
    recBarberHaircutContent23: 'Pomade:',
    recBarberHaircutContent24: 'For slick, polished looks',
    recBarberHaircutContent25: 'Wax:',
    recBarberHaircutContent26: 'For textured, matte finishes',
    recBarberHaircutContent27: 'Gel:',
    recBarberHaircutContent28: 'For strong hold and shine',
    recBarberHaircutContent29: 'Cream:',
    recBarberHaircutContent30: 'For natural, flexible styling',
    recBarberHaircutContent31: 'Styling Techniques',
    recBarberHaircutContent32: 'Blow drying:',
    recBarberHaircutContent33: 'Use heat to create volume and shape',
    recBarberHaircutContent34: 'Finger styling:',
    recBarberHaircutContent35: 'Use fingers to create natural texture',
    recBarberHaircutContent36: 'Comb styling:',
    recBarberHaircutContent37: 'Use combs for precise, clean looks',
    recBarberHaircutContent38: 'Product application:',
    recBarberHaircutContent39: 'Start with small amounts and build up',
    recBarberHaircutQuickTip1: 'Choose cuts that work with your hair texture and growth pattern',
    recBarberHaircutQuickTip2: 'Consider your lifestyle and maintenance preferences',
    recBarberHaircutQuickTip3: 'Use quality products for styling and maintenance',
    recBarberBeardIntro: 'Learn professional beard maintenance routines, styling techniques, and troubleshooting methods for achieving healthy, attractive facial hair that enhances your appearance and feels comfortable.',
    recBarberBeardContent1: 'A well-groomed beard requires proper care, maintenance, and styling techniques. Professional barbers share their secrets for achieving a healthy, attractive beard that enhances your appearance and feels comfortable.',
    recBarberBeardContent2: 'Beard Care Routine',
    recBarberBeardContent3: 'Daily Care',
    recBarberBeardContent4: 'Washing:',
    recBarberBeardContent5: 'Use beard-specific shampoo 2-3 times per week',
    recBarberBeardContent6: 'Conditioning:',
    recBarberBeardContent7: 'Apply beard conditioner to keep hair soft',
    recBarberBeardContent8: 'Moisturizing:',
    recBarberBeardContent9: 'Use beard oil to prevent dryness and itchiness',
    recBarberBeardContent10: 'Brushing:',
    recBarberBeardContent11: 'Use a boar bristle brush to distribute oils',
    recBarberBeardContent12: 'Combing:',
    recBarberBeardContent13: 'Use a wide-tooth comb to detangle and style',
    recBarberBeardContent14: 'Weekly Maintenance',
    recBarberBeardContent15: 'Trimming:',
    recBarberBeardContent16: 'Maintain shape and remove split ends',
    recBarberBeardContent17: 'Exfoliating:',
    recBarberBeardContent18: 'Remove dead skin cells and prevent ingrown hairs',
    recBarberBeardContent19: 'Deep conditioning:',
    recBarberBeardContent20: 'Use beard masks for extra moisture',
    recBarberBeardContent21: 'Styling:',
    recBarberBeardContent22: 'Use beard balm for hold and styling',
    recBarberBeardContent23: 'Beard Styling Techniques',
    recBarberBeardContent24: 'Shaping Your Beard',
    recBarberBeardContent25: 'Define the neckline:',
    recBarberBeardContent26: 'Create a clean line below the jaw',
    recBarberBeardContent27: 'Trim the cheeks:',
    recBarberBeardContent28: 'Maintain a natural cheek line',
    recBarberBeardContent29: 'Shape the mustache:',
    recBarberBeardContent30: 'Keep it neat and defined',
    recBarberBeardContent31: 'Even out length:',
    recBarberBeardContent32: 'Trim longer hairs for uniform appearance',
    recBarberBeardContent33: 'Beard Styles',
    recBarberBeardContent34: 'Full beard:',
    recBarberBeardContent35: 'Natural, untrimmed growth',
    recBarberBeardContent36: 'Short beard:',
    recBarberBeardContent37: 'Trimmed to 1-2 inches in length',
    recBarberBeardContent38: 'Goatee:',
    recBarberBeardContent39: 'Hair on chin and mustache area only',
    recBarberBeardContent40: 'Van Dyke:',
    recBarberBeardContent41: 'Mustache and goatee without connecting',
    recBarberBeardContent42: 'Stubble:',
    recBarberBeardContent43: 'Short, maintained facial hair',
    recBarberBeardContent44: 'Common Beard Problems & Solutions',
    recBarberBeardContent45: 'Itchiness',
    recBarberBeardContent46: 'Causes:',
    recBarberBeardContent47: 'Dry skin, new growth, poor hygiene',
    recBarberBeardContent48: 'Solutions:',
    recBarberBeardContent49: 'Use beard oil, exfoliate regularly, maintain cleanliness',
    recBarberBeardContent50: 'Patchy Growth',
    recBarberBeardContent51: 'Genetics, age, hormonal factors',
    recBarberBeardContent52: 'Choose styles that work with your growth pattern, be patient',
    recBarberBeardContent53: 'Ingrown Hairs',
    recBarberBeardContent54: 'Improper shaving, tight clothing, poor hygiene',
    recBarberBeardContent55: 'Exfoliate regularly, use proper shaving techniques',
    recBarberBeardQuickTip1: 'Use beard-specific products for optimal care',
    recBarberBeardQuickTip2: 'Establish a consistent daily and weekly routine',
    recBarberBeardQuickTip3: 'Work with your natural growth pattern for best results',
    recBarberSkincareIntro: 'Build a professional skincare routine that prevents common issues like acne, irritation, and premature aging. Learn essential techniques for maintaining healthy, clear skin with a simple, consistent approach.',
    recBarberSkincareContent1: 'Proper skincare is essential for maintaining healthy, clear skin and preventing common issues like acne, irritation, and premature aging. A simple, consistent routine can make a significant difference in your skin\'s appearance and health.',
    recBarberSkincareContent2: 'Basic Skincare Routine',
    recBarberSkincareContent3: 'Morning Routine',
    recBarberSkincareContent4: 'Cleanser:',
    recBarberSkincareContent5: 'Gentle face wash to remove overnight oils',
    recBarberSkincareContent6: 'Toner:',
    recBarberSkincareContent7: 'Balance pH and prepare skin for products',
    recBarberSkincareContent8: 'Moisturizer:',
    recBarberSkincareContent9: 'Hydrate and protect skin',
    recBarberSkincareContent10: 'Sunscreen:',
    recBarberSkincareContent11: 'Essential for preventing sun damage',
    recBarberSkincareContent12: 'Evening Routine',
    recBarberSkincareContent13: 'Remove dirt, oil, and products from the day',
    recBarberSkincareContent14: 'Exfoliant:',
    recBarberSkincareContent15: 'Remove dead skin cells (2-3 times per week)',
    recBarberSkincareContent16: 'Serum:',
    recBarberSkincareContent17: 'Target specific skin concerns',
    recBarberSkincareContent18: 'Repair and hydrate overnight',
    recBarberSkincareContent19: 'Common Skin Concerns',
    recBarberSkincareContent20: 'Acne',
    recBarberSkincareContent21: 'Excess oil, bacteria, hormonal changes',
    recBarberSkincareContent22: 'Salicylic acid, benzoyl peroxide, gentle cleansing',
    recBarberSkincareContent23: 'Razor Burn',
    recBarberSkincareContent24: 'Improper shaving technique, dull blades',
    recBarberSkincareContent25: 'Sharp blades, proper preparation, soothing products',
    recBarberSkincareContent26: 'Dry Skin',
    recBarberSkincareContent27: 'Weather, harsh products, insufficient moisture',
    recBarberSkincareContent28: 'Gentle cleansers, rich moisturizers, humidifiers',
    recBarberSkincareContent29: 'Professional Treatments',
    recBarberSkincareContent30: 'Facials',
    recBarberSkincareContent31: 'Professional facials provide deep cleaning, exfoliation, and treatment for specific skin concerns. Regular facials can improve skin texture, reduce breakouts, and maintain healthy skin.',
    recBarberSkincareContent32: 'Chemical Peels',
    recBarberSkincareContent33: 'Chemical peels remove damaged skin layers, revealing smoother, more even skin. They can help with acne, aging, and pigmentation issues.',
    recBarberSkincareQuickTip1: 'Start with a basic routine and gradually add products',
    recBarberSkincareQuickTip2: 'Always use sunscreen to prevent sun damage',
    recBarberSkincareQuickTip3: 'Choose products suitable for your skin type',
    recBarberToolsIntro: 'Build a professional grooming toolkit with the right tools and techniques for achieving salon-quality results at home. Learn maintenance schedules and proper care for extending the life of your grooming equipment.',
    recBarberToolsContent1: 'Having the right grooming tools is essential for maintaining your appearance between barber visits. Professional barbers recommend specific tools and techniques for achieving salon-quality results at home.',
    recBarberToolsContent2: 'Essential Tools',
    recBarberToolsContent3: 'Hair Cutting Tools',
    recBarberToolsContent4: 'Electric clippers:',
    recBarberToolsContent5: 'For trimming and fading',
    recBarberToolsContent6: 'Scissors:',
    recBarberToolsContent7: 'For precise cutting and detailing',
    recBarberToolsContent8: 'Combs:',
    recBarberToolsContent9: 'For sectioning and styling',
    recBarberToolsContent10: 'Mirrors:',
    recBarberToolsContent11: 'For checking all angles',
    recBarberToolsContent12: 'Beard Grooming Tools',
    recBarberToolsContent13: 'Beard trimmer:',
    recBarberToolsContent14: 'For maintaining length and shape',
    recBarberToolsContent15: 'Beard brush:',
    recBarberToolsContent16: 'For distributing oils and styling',
    recBarberToolsContent17: 'Beard comb:',
    recBarberToolsContent18: 'For detangling and styling',
    recBarberToolsContent19: 'Beard oil:',
    recBarberToolsContent20: 'For moisturizing and conditioning',
    recBarberToolsContent21: 'Skincare Tools',
    recBarberToolsContent22: 'Face cleanser:',
    recBarberToolsContent23: 'For daily cleaning',
    recBarberToolsContent24: 'Exfoliating scrub:',
    recBarberToolsContent25: 'For removing dead skin',
    recBarberToolsContent26: 'Moisturizer:',
    recBarberToolsContent27: 'For hydrating skin',
    recBarberToolsContent28: 'Sunscreen:',
    recBarberToolsContent29: 'For protecting from UV damage',
    recBarberToolsContent30: 'Tool Maintenance',
    recBarberToolsContent31: 'Cleaning and Sanitizing',
    recBarberToolsContent32: 'Regular cleaning:',
    recBarberToolsContent33: 'Clean tools after each use',
    recBarberToolsContent34: 'Sanitizing:',
    recBarberToolsContent35: 'Use alcohol or sanitizing solutions',
    recBarberToolsContent36: 'Sharpening:',
    recBarberToolsContent37: 'Keep blades sharp for best results',
    recBarberToolsContent38: 'Storage:',
    recBarberToolsContent39: 'Store tools in clean, dry places',
    recBarberToolsContent40: 'Replacement Schedule',
    recBarberToolsContent41: 'Razor blades:',
    recBarberToolsContent42: 'Replace every 5-7 shaves',
    recBarberToolsContent43: 'Clipper blades:',
    recBarberToolsContent44: 'Sharpen or replace every 6 months',
    recBarberToolsContent45: 'Scissors:',
    recBarberToolsContent46: 'Sharpen annually or as needed',
    recBarberToolsContent47: 'Brushes:',
    recBarberToolsContent48: 'Clean monthly, replace annually',
    recBarberToolsQuickTip1: 'Invest in quality tools for better results and longevity',
    recBarberToolsQuickTip2: 'Clean and sanitize tools regularly',
    recBarberToolsQuickTip3: 'Replace blades and accessories on schedule',
    // Tattoo & Piercing translations - English
    completeTattooPiercingGuide: 'Complete Tattoo & Piercing Guide 2024',
    professionalBodyArtGuide: 'Professional Body Art Guide • Updated December 2024',
    exploreWorldBodyArt: 'Explore the world of professional body art with our comprehensive guide to tattoos and piercings. From choosing the perfect design to understanding the healing process, discover everything you need to know about safe, professional body modification. Whether you\'re a first-timer or looking to expand your collection, this guide covers design inspiration, artist selection, and proper care.',
    professionalTattooDesign: 'Professional Tattoo Design & Style Selection',
    exploreTattooArtStyles: 'Explore tattoo art styles and learn how to choose designs that reflect your personality and aesthetic preferences',
    expertTattooArtistSelection: 'Expert Tattoo Artist Selection & Portfolio Evaluation',
    learnFindPerfectArtist: 'Learn how to find the perfect tattoo artist and evaluate portfolios for quality, style match, and professional standards',
    completePiercingGuide: 'Complete Piercing Guide & Placement Options',
    discoverDifferentPiercing: 'Discover different piercing types, healing times, and placement options for safe, stylish body modification',
    professionalAftercare: 'Professional Aftercare & Healing Process',
    recTattooMasterAftercareRoutine: 'Master the aftercare routine for optimal healing and long-lasting satisfaction with your body art',
    safetyStandardsHygiene: 'Safety Standards & Hygiene Best Practices',
    understandEssentialSafety: 'Understand essential safety considerations and hygiene practices for safe, professional body modification',
    recTattooDesignIntro: 'Explore tattoo art styles and learn how to choose designs that reflect your personality and aesthetic preferences. Tattoo art has evolved into a sophisticated form of self-expression.',
    recTattooDesignContent1: 'Tattoo art has evolved into a sophisticated form of self-expression, with countless styles and techniques available. From traditional designs to contemporary art, understanding different tattoo styles helps you choose the perfect design that reflects your personality and aesthetic preferences.',
    recTattooDesignContent2: 'Popular Tattoo Styles',
    recTattooDesignContent3: '1. Traditional/Classic Tattoos',
    recTattooDesignContent4: 'Characteristics:',
    recTattooDesignContent5: 'Bold black outlines, solid colors, classic imagery like roses, eagles, and anchors.',
    recTattooDesignContent6: 'Best for:',
    recTattooDesignContent7: 'Those who appreciate timeless, bold designs with strong symbolism.',
    recTattooDesignContent8: 'Popular motifs:',
    recTattooDesignContent9: 'Roses, eagles, anchors, hearts, daggers',
    recTattooDesignContent10: '2. Realistic/Photorealistic',
    recTattooDesignContent11: 'Highly detailed, lifelike representations of people, animals, or objects.',
    recTattooDesignContent12: 'Those who want detailed, artistic representations with photographic quality.',
    recTattooDesignContent13: 'Popular subjects:',
    recTattooDesignContent14: 'Portraits, animals, nature scenes, objects',
    recTattooDesignContent15: '3. Watercolor Tattoos',
    recTattooDesignContent16: 'Flowing, colorful designs that mimic watercolor paintings with soft edges and vibrant colors.',
    recTattooDesignContent17: 'Those who want artistic, colorful designs with a painterly aesthetic.',
    recTattooDesignContent18: 'Popular elements:',
    recTattooDesignContent19: 'Abstract shapes, nature scenes, artistic interpretations',
    recTattooDesignContent20: '4. Geometric Tattoos',
    recTattooDesignContent21: 'Precise lines, shapes, and patterns with mathematical precision and symmetry.',
    recTattooDesignContent22: 'Those who appreciate clean, minimalist designs with symbolic meaning.',
    recTattooDesignContent23: 'Popular elements:',
    recTattooDesignContent24: 'Mandalas, sacred geometry, geometric animals',
    recTattooDesignContent25: '5. Minimalist Tattoos',
    recTattooDesignContent26: 'Simple, clean designs with thin lines and minimal detail.',
    recTattooDesignContent27: 'Those who prefer subtle, understated designs that are easy to maintain.',
    recTattooDesignContent28: 'Popular elements:',
    recTattooDesignContent29: 'Simple symbols, words, small illustrations',
    recTattooDesignContent30: 'Design Considerations',
    recTattooDesignContent31: 'Placement Options',
    recTattooDesignContent32: 'Visible areas:',
    recTattooDesignContent33: 'Arms, legs, hands, neck - consider professional implications',
    recTattooDesignContent34: 'Hidden areas:',
    recTattooDesignContent35: 'Back, chest, ribs - more private placement',
    recTattooDesignContent36: 'Pain levels:',
    recTattooDesignContent37: 'Some areas are more sensitive than others',
    recTattooDesignContent38: 'Size considerations:',
    recTattooDesignContent39: 'Larger designs need more space',
    recTattooDesignContent40: 'Personalization Tips',
    recTattooDesignContent41: 'Meaningful symbols:',
    recTattooDesignContent42: 'Choose designs that represent your values or experiences',
    recTattooDesignContent43: 'Custom designs:',
    recTattooDesignContent44: 'Work with artists to create unique, personal pieces',
    recTattooDesignContent45: 'Color preferences:',
    recTattooDesignContent46: 'Consider how colors will age and fade over time',
    recTattooDesignContent47: 'Size and detail:',
    recTattooDesignContent48: 'Balance complexity with longevity and readability',
    recTattooDesignQuickTip1: 'Choose styles that match your personal aesthetic and lifestyle',
    recTattooDesignQuickTip2: 'Consider placement carefully for professional implications',
    recTattooDesignQuickTip3: 'Work with artists to create custom, meaningful designs',
    recArtistSelectionIntro: 'Learn how to find the perfect tattoo artist and evaluate portfolios for quality, style match, and professional standards. The right artist will create beautiful work and provide proper guidance.',
    recArtistSelectionContent1: 'Selecting the right tattoo artist is crucial for achieving the best results and ensuring a safe, professional experience. The right artist will not only create beautiful work but also provide proper guidance, maintain high hygiene standards, and help you make informed decisions about your tattoo.',
    recArtistSelectionContent2: 'What to Look For',
    recArtistSelectionContent3: 'Portfolio Quality',
    recArtistSelectionContent4: 'Style match:',
    recArtistSelectionContent5: 'Choose an artist whose style aligns with your vision',
    recArtistSelectionContent6: 'Technical skill:',
    recArtistSelectionContent7: 'Look for clean lines, solid color, and proper shading',
    recArtistSelectionContent8: 'Consistency:',
    recArtistSelectionContent9: 'Check that their work quality is consistent across pieces',
    recArtistSelectionContent10: 'Healed photos:',
    recArtistSelectionContent11: 'Ask to see photos of healed tattoos, not just fresh ones',
    recArtistSelectionContent12: 'Professional Standards',
    recArtistSelectionContent13: 'Licensing:',
    recArtistSelectionContent14: 'Ensure the artist is properly licensed and certified',
    recArtistSelectionContent15: 'Hygiene:',
    recArtistSelectionContent16: 'Check that the studio maintains high cleanliness standards',
    recArtistSelectionContent17: 'Sterilization:',
    recArtistSelectionContent18: 'Verify that equipment is properly sterilized',
    recArtistSelectionContent19: 'Safety protocols:',
    recArtistSelectionContent20: 'Ask about their safety and hygiene procedures',
    recArtistSelectionContent21: 'Communication & Consultation',
    recArtistSelectionContent22: 'Listening skills:',
    recArtistSelectionContent23: 'Choose an artist who listens to your ideas and concerns',
    recArtistSelectionContent24: 'Expertise:',
    recArtistSelectionContent25: 'Look for artists who can provide guidance and recommendations',
    recArtistSelectionContent26: 'Transparency:',
    recArtistSelectionContent27: 'Choose someone who explains the process and answers questions',
    recArtistSelectionContent28: 'Comfort level:',
    recArtistSelectionContent29: 'Ensure you feel comfortable discussing your design',
    recArtistSelectionContent30: 'Research Process',
    recArtistSelectionContent31: 'Online Research',
    recArtistSelectionContent32: 'Studio websites:',
    recArtistSelectionContent33: 'Review portfolios and artist bios',
    recArtistSelectionContent34: 'Social media:',
    recArtistSelectionContent35: 'Check Instagram and Facebook for recent work',
    recArtistSelectionContent36: 'Reviews:',
    recArtistSelectionContent37: 'Read customer reviews and testimonials',
    recArtistSelectionContent38: 'Recommendations:',
    recArtistSelectionContent39: 'Ask friends and family for referrals',
    recArtistSelectionContent40: 'Studio Visits',
    recArtistSelectionContent41: 'Cleanliness:',
    recArtistSelectionContent42: 'Visit the studio to assess cleanliness and organization',
    recArtistSelectionContent43: 'Atmosphere:',
    recArtistSelectionContent44: 'Ensure the environment feels professional and comfortable',
    recArtistSelectionContent45: 'Artist availability:',
    recArtistSelectionContent46: 'Check if your preferred artist is available',
    recArtistSelectionContent47: 'Pricing:',
    recArtistSelectionContent48: 'Understand their pricing structure and policies',
    recArtistSelectionContent49: 'Consultation Process',
    recArtistSelectionContent50: 'Pre-Consultation Preparation',
    recArtistSelectionContent51: 'Design ideas:',
    recArtistSelectionContent52: 'Bring reference images and describe your vision',
    recArtistSelectionContent53: 'Size and placement:',
    recArtistSelectionContent54: 'Consider where you want the tattoo',
    recArtistSelectionContent55: 'Budget:',
    recArtistSelectionContent56: 'Have a realistic budget in mind',
    recArtistSelectionContent57: 'Questions:',
    recArtistSelectionContent58: 'Prepare questions about the process and aftercare',
    recArtistSelectionContent59: 'During Consultation',
    recArtistSelectionContent60: 'Design discussion:',
    recArtistSelectionContent61: 'Work together to refine your design',
    recArtistSelectionContent62: 'Timeline:',
    recArtistSelectionContent63: 'Understand the process and timeline',
    recArtistSelectionContent64: 'Aftercare:',
    recArtistSelectionContent65: 'Learn about proper care and healing',
    recArtistSelectionContent66: 'Pricing:',
    recArtistSelectionContent67: 'Get a clear estimate of costs',
    recArtistSelectionQuickTip1: 'Review portfolios for style match and technical skill',
    recArtistSelectionQuickTip2: 'Verify licensing and hygiene standards',
    recArtistSelectionQuickTip3: 'Choose artists who listen to your ideas and concerns',
    recPiercingIntro: 'Discover different piercing types, healing times, and placement options for safe, stylish body modification. Understanding these factors helps you make informed decisions about your body art.',
    recPiercingContent1: 'Body piercings offer a wide range of options for self-expression, from subtle ear piercings to bold body modifications. Understanding different piercing types, healing times, and care requirements helps you make informed decisions about your body art choices.',
    recPiercingContent2: 'Ear Piercings',
    recPiercingContent3: 'Lobe Piercings',
    recPiercingContent4: 'Description:',
    recPiercingContent5: 'The most common piercing, through the earlobe.',
    recPiercingContent6: 'Healing time:',
    recPiercingContent7: '6-8 weeks',
    recPiercingContent8: 'Pain level:',
    recPiercingContent9: 'Low',
    recPiercingContent10: 'Versatility:',
    recPiercingContent11: 'Can accommodate various jewelry styles',
    recPiercingContent12: 'Cartilage Piercings',
    recPiercingContent13: 'Piercings through the cartilage of the ear.',
    recPiercingContent14: '3-12 months',
    recPiercingContent15: 'Medium to high',
    recPiercingContent16: 'Popular types:',
    recPiercingContent17: 'Helix, tragus, conch, daith',
    recPiercingContent18: 'Facial Piercings',
    recPiercingContent19: 'Nose Piercings',
    recPiercingContent20: 'Piercings through the nostril or septum.',
    recPiercingContent21: '2-4 months (nostril), 6-8 months (septum)',
    recPiercingContent22: 'Low to medium',
    recPiercingContent23: 'Considerations:',
    recPiercingContent24: 'Professional implications, jewelry options',
    recPiercingContent25: 'Lip Piercings',
    recPiercingContent26: 'Various lip and mouth area piercings.',
    recPiercingContent27: '2-3 months',
    recPiercingContent28: 'Medium',
    recPiercingContent29: 'Labret, Monroe, snake bites',
    recPiercingContent30: 'Body Piercings',
    recPiercingContent31: 'Navel Piercings',
    recPiercingContent32: 'Piercing through the navel area.',
    recPiercingContent33: '6-12 months',
    recPiercingContent34: 'Considerations:',
    recPiercingContent35: 'Clothing choices, activity restrictions',
    recPiercingContent36: 'Surface Piercings',
    recPiercingContent37: 'Piercings that sit on the surface of the skin.',
    recPiercingContent38: 'Considerations:',
    recPiercingContent39: 'Higher rejection risk, specialized jewelry',
    recPiercingContent40: 'Jewelry Selection',
    recPiercingContent41: 'Material Options',
    recPiercingContent42: 'Surgical steel:',
    recPiercingContent43: 'Hypoallergenic, durable, affordable',
    recPiercingContent44: 'Titanium:',
    recPiercingContent45: 'Lightweight, hypoallergenic, high quality',
    recPiercingContent46: 'Gold:',
    recPiercingContent47: 'Luxurious, hypoallergenic, expensive',
    recPiercingContent48: 'Biocompatible materials:',
    recPiercingContent49: 'Safe for sensitive skin',
    recPiercingContent50: 'Jewelry Styles',
    recPiercingContent51: 'Studs:',
    recPiercingContent52: 'Simple, versatile, good for healing',
    recPiercingContent53: 'Hoops:',
    recPiercingContent54: 'Classic, various sizes available',
    recPiercingContent55: 'Captive bead rings:',
    recPiercingContent56: 'Secure, decorative',
    recPiercingContent57: 'Barbells:',
    recPiercingContent58: 'Straight or curved, various lengths',
    recPiercingQuickTip1: 'Start with lobe piercings for beginners',
    recPiercingQuickTip2: 'Choose hypoallergenic materials like titanium',
    recPiercingQuickTip3: 'Consider healing times when planning multiple piercings',
    recAftercareIntro: 'Master the aftercare routine for optimal healing and long-lasting satisfaction with your body art. Proper aftercare is essential for successful healing and prevents complications.',
    recAftercareContent1: 'Proper aftercare is essential for successful healing and long-term satisfaction with your body art. Following professional aftercare instructions helps prevent infections, promotes healing, and ensures your tattoo or piercing looks its best for years to come.',
    recAftercareContent2: 'Tattoo Aftercare',
    recAftercareContent3: 'Immediate Care (First 24 Hours)',
    recAftercareContent4: 'Keep bandage on:',
    recAftercareContent5: 'Leave the initial bandage on for 2-4 hours',
    recAftercareContent6: 'Gentle cleaning:',
    recAftercareContent7: 'Use mild, fragrance-free soap',
    recAftercareContent8: 'Pat dry:',
    recAftercareContent9: 'Gently pat dry with clean towel',
    recAftercareContent10: 'Avoid touching:',
    recAftercareContent11: 'Don\'t touch the tattoo with dirty hands',
    recAftercareContent12: 'First Week Care',
    recAftercareContent13: 'Wash twice daily:',
    recAftercareContent14: 'Clean with mild soap and warm water',
    recAftercareContent15: 'Moisturize:',
    recAftercareContent16: 'Apply thin layer of fragrance-free moisturizer',
    recAftercareContent17: 'Avoid soaking:',
    recAftercareContent18: 'No swimming, hot tubs, or long showers',
    recAftercareContent19: 'Protect from sun:',
    recAftercareContent20: 'Keep covered and avoid direct sunlight',
    recAftercareContent21: 'Healing Process',
    recAftercareContent22: 'Week 1:',
    recAftercareContent23: 'Redness, swelling, and tenderness',
    recAftercareContent24: 'Week 2-3:',
    recAftercareContent25: 'Peeling and flaking',
    recAftercareContent26: 'Week 4-6:',
    recAftercareContent27: 'Surface healing complete',
    recAftercareContent28: 'Month 2-3:',
    recAftercareContent29: 'Full healing and color settling',
    recAftercareContent30: 'Piercing Aftercare',
    recAftercareContent31: 'Cleaning Routine',
    recAftercareContent32: 'Saline solution:',
    recAftercareContent33: 'Use sterile saline solution twice daily',
    recAftercareContent34: 'Gentle cleaning:',
    recAftercareContent35: 'Use cotton swabs or gauze',
    recAftercareContent36: 'Rotate jewelry:',
    recAftercareContent37: 'Gently rotate jewelry while cleaning',
    recAftercareContent38: 'Pat dry:',
    recAftercareContent39: 'Gently pat dry after cleaning',
    recAftercareContent40: 'Healing Timeline',
    recAftercareContent41: 'Week 1:',
    recAftercareContent42: 'Redness, swelling, and tenderness',
    recAftercareContent43: 'Week 2-4:',
    recAftercareContent44: 'Gradual reduction in swelling',
    recAftercareContent45: 'Month 2-3:',
    recAftercareContent46: 'Significant healing progress',
    recAftercareContent47: 'Month 3-12:',
    recAftercareContent48: 'Complete healing depending on piercing type',
    recAftercareContent49: 'What to Avoid',
    recAftercareContent50: 'During Healing',
    recAftercareContent51: 'Swimming:',
    recAftercareContent52: 'Avoid pools, hot tubs, and natural bodies of water',
    recAftercareContent53: 'Sun exposure:',
    recAftercareContent54: 'Protect from direct sunlight',
    recAftercareContent55: 'Harsh products:',
    recAftercareContent56: 'Avoid alcohol, hydrogen peroxide, and harsh soaps',
    recAftercareContent57: 'Picking or scratching:',
    recAftercareContent58: 'Don\'t pick at scabs or crust',
    recAftercareContent59: 'Tight clothing:',
    recAftercareContent60: 'Avoid clothing that rubs or irritates',
    recAftercareContent61: 'Signs of Infection',
    recAftercareContent62: 'Excessive redness:',
    recAftercareContent63: 'Redness that spreads or worsens',
    recAftercareContent64: 'Swelling:',
    recAftercareContent65: 'Persistent or increasing swelling',
    recAftercareContent66: 'Pain:',
    recAftercareContent67: 'Severe or increasing pain',
    recAftercareContent68: 'Discharge:',
    recAftercareContent69: 'Yellow or green discharge',
    recAftercareContent70: 'Fever:',
    recAftercareContent71: 'Elevated body temperature',
    recAftercareContent72: 'When to Seek Help',
    recAftercareContent73: 'Contact your artist or piercer if you experience signs of infection, allergic reactions, or unusual healing patterns. Early intervention can prevent serious complications and ensure proper healing.',
    recAftercareQuickTip1: 'Follow aftercare instructions carefully and consistently',
    recAftercareQuickTip2: 'Keep treated areas clean and moisturized',
    recAftercareQuickTip3: 'Avoid sun exposure and swimming during healing',
    recSafetyIntro: 'Understand essential safety considerations and hygiene practices for safe, professional body modification. Safety should always be the top priority when getting tattoos or piercings.',
    recSafetyContent1: 'Safety should always be the top priority when getting tattoos or piercings. Understanding proper hygiene practices, safety protocols, and potential risks helps ensure a safe, professional experience and reduces the risk of complications.',
    recSafetyContent2: 'Studio Safety Standards',
    recSafetyContent3: 'Hygiene Requirements',
    recSafetyContent4: 'Sterilization:',
    recSafetyContent5: 'All equipment must be properly sterilized',
    recSafetyContent6: 'Disposable items:',
    recSafetyContent7: 'Single-use needles, gloves, and other items',
    recSafetyContent8: 'Clean environment:',
    recSafetyContent9: 'Studio should be clean and organized',
    recSafetyContent10: 'Proper licensing:',
    recSafetyContent11: 'Studio and artists must be licensed',
    recSafetyContent12: 'Safety Protocols',
    recSafetyContent13: 'Health screening:',
    recSafetyContent14: 'Artists should ask about health conditions',
    recSafetyContent15: 'Allergy testing:',
    recSafetyContent16: 'Test for metal allergies before piercings',
    recSafetyContent17: 'Proper technique:',
    recSafetyContent18: 'Artists should use proper techniques',
    recSafetyContent19: 'Emergency procedures:',
    recSafetyContent20: 'Studio should have emergency protocols',
    recSafetyContent21: 'Health Considerations',
    recSafetyContent22: 'Medical Conditions',
    recSafetyContent23: 'Diabetes:',
    recSafetyContent24: 'May affect healing and require special care',
    recSafetyContent25: 'Blood disorders:',
    recSafetyContent26: 'May increase bleeding risk',
    recSafetyContent27: 'Immune system issues:',
    recSafetyContent28: 'May affect healing and infection risk',
    recSafetyContent29: 'Skin conditions:',
    recSafetyContent30: 'May affect healing and appearance',
    recSafetyContent31: 'Medications',
    recSafetyContent32: 'Blood thinners:',
    recSafetyContent33: 'May increase bleeding risk',
    recSafetyContent34: 'Antibiotics:',
    recSafetyContent35: 'May affect healing process',
    recSafetyContent36: 'Steroids:',
    recSafetyContent37: 'May affect healing and immune response',
    recSafetyContent38: 'Accutane:',
    recSafetyContent39: 'May cause excessive scarring',
    recSafetyContent40: 'Risk Factors',
    recSafetyContent41: 'Infection Risks',
    recSafetyContent42: 'Poor hygiene:',
    recSafetyContent43: 'Improper cleaning increases infection risk',
    recSafetyContent44: 'Contaminated equipment:',
    recSafetyContent45: 'Unsterilized equipment can cause infections',
    recSafetyContent46: 'Unclean environment:',
    recSafetyContent47: 'Dirty studios increase infection risk',
    recSafetyContent48: 'Improper aftercare:',
    recSafetyContent49: 'Poor aftercare can lead to infections',
    recSafetyContent50: 'Allergic Reactions',
    recSafetyContent51: 'Metal allergies:',
    recSafetyContent52: 'Nickel and other metals can cause reactions',
    recSafetyContent53: 'Ink allergies:',
    recSafetyContent54: 'Some people are allergic to tattoo ink',
    recSafetyContent55: 'Latex allergies:',
    recSafetyContent56: 'Gloves and other latex products',
    recSafetyContent57: 'Cleaning products:',
    recSafetyContent58: 'Some cleaning solutions can cause reactions',
    recSafetyContent59: 'Prevention Tips',
    recSafetyContent60: 'Before Your Appointment',
    recSafetyContent61: 'Research studios:',
    recSafetyContent62: 'Choose reputable, licensed studios',
    recSafetyContent63: 'Check reviews:',
    recSafetyContent64: 'Read customer reviews and testimonials',
    recSafetyContent65: 'Visit the studio:',
    recSafetyContent66: 'Inspect cleanliness and organization',
    recSafetyContent67: 'Ask questions:',
    recSafetyContent68: 'Don\'t hesitate to ask about safety procedures',
    recSafetyContent69: 'During Your Appointment',
    recSafetyContent70: 'Observe hygiene:',
    recSafetyContent71: 'Watch for proper hygiene practices',
    recSafetyContent72: 'Ask about equipment:',
    recSafetyContent73: 'Ensure equipment is properly sterilized',
    recSafetyContent74: 'Communicate concerns:',
    recSafetyContent75: 'Speak up if something seems wrong',
    recSafetyContent76: 'Follow instructions:',
    recSafetyContent77: 'Listen to and follow all safety instructions',
    recSafetyQuickTip1: 'Choose licensed studios with proper sterilization',
    recSafetyQuickTip2: 'Inform artists about health conditions and medications',
    recSafetyQuickTip3: 'Watch for signs of infection and seek help promptly',
    readyExpressIndividuality: 'Ready to Express Your Individuality?',
    dontWaitExploreBodyArt: 'Don\'t wait to explore the world of professional body art! Book a consultation with one of our expert tattoo artists and piercers who specialize in safe, professional body modification. From custom tattoo designs to precision piercings, we\'ll help you create the perfect body art that reflects your unique style and personality.',
    bookTattooConsultation: 'Book Tattoo Consultation',
    bookPiercingAppointment: 'Book Piercing Appointment',
  },
  ar: {
    categories: 'الأقسام',
    login: 'تسجيل الدخول',
    listBiz: 'أضف نشاطك',
    customerReviews: 'تقييمات العملاء',
    viewMap: 'عرض الخريطة',
    callNow: 'اتصل الآن',
    bookNow: 'احجز الآن',
    chooseStaff: 'اختر الموظف',
    selectService: 'اختر الخدمة',
    selectServicesAsMuchAsYouNeed: 'اختر الخدمات كما تحتاج',
    selectDate: 'اختر تاريخاً',
    selectTime: 'اختر وقتاً',
    noReviews: 'لا توجد تقييمات بعد. كن أول من يقيّم هذا المتجر!',
    home: 'الرئيسية',
    // Footer
    about: 'من نحن',
    team: 'الفريق',
    privacy: 'سياسة الخصوصية',
    support: 'الدعم',
    quickLinks: 'روابط سريعة',
    contact: 'تواصل معنا',
    supportEmail: 'bookwithehgezly@gmail.com',
    backToTop: 'العودة للأعلى',
    brand: 'احجزلي',
    brandBlurb: 'بسّط الحجوزات والتسويق والمدفوعات في منصة واحدة. قلّل عدم الحضور بالتذكيرات الذكية. أدِر الخدمات وجداول الموظفين والتوافر في الوقت الفعلي. وتتبع النمو برؤى قابلة للتنفيذ وولاء العملاء.',
    footerPopularServices: 'الخدمات الشائعة',
    footerPopularAreas: 'المناطق الشائعة',
    footerMoreServices: 'المزيد من الخدمات...',
    footerMoreAreas: 'المزيد من المناطق...',
    footerFollowUs: 'تابعنا على',
    footerSupportLine: 'لأي دعم يمكنك التواصل معنا عبر صفحة الدعم.',
    footerFaq: 'الأسئلة الشائعة',
    footerSitemap: 'خريطة الموقع',
    deleteAccount: 'حذف الحساب',
    // Support page
    supportTitle: 'الدعم',
    supportSubtitle: 'احصل على مساعدة في تطبيق احجزلي وحجوزاتك.',
    supportGeneralTitle: 'الدعم العام',
    supportGeneralText: 'لمشاكل التطبيق أو الحجوزات أو الحساب:',
    supportBusinessTitle: 'لأصحاب الأعمال',
    supportBusinessText: 'الشركاء وأصحاب المتاجر:',
    supportReportTitle: 'الإبلاغ عن مشكلة',
    supportReportText: 'مشاكل تقنية أو اقتراحات:',
    supportInAppTitle: 'المساعدة داخل التطبيق',
    supportInAppText: 'استخدم المساعد الذكي: الملف الشخصي ← المساعدة، أو من لوحة التحكم.',
    supportPhoneLabel: 'هاتف',
    // Auth
    welcomeBack: 'مرحبًا بعودتك',
    signInSubtitle: 'سجّل الدخول لحجز خدمات الجمال والعناية بالقرب منك',
    authBrandLoginTitle: 'كمّل يوم جمالك',
    authBrandLoginDesc: 'محلاتك وزياراتك القادمة وإطلالاتك المحفوظة هنا — جاهزة متى ما كنت.',
    authBrandRegisterTitle: 'احجز الإطلالة اللي تبيها',
    authBrandRegisterDesc: 'حساب مجاني واحد للقص والصبغة والعناية والهدوء — بمواعيد تناسب يومك.',
    authBrandPointBook: 'احجز موعدًا متاحًا فعليًا',
    authBrandPointNear: 'خلّ محلاتك المفضلة قريبة',
    authBrandPointRemind: 'روح وأنت مستعد، مو مستعجل',
    authBrandEyebrow: 'احجزلي',
    authSlide1Title: 'الجمال والعافية، محجوزان',
    authSlide1Desc: 'صالونات وسبا وعيادات بالقرب منك. احجز خلال دقائق.',
    authSlide2Title: 'كرسيك بانتظارك',
    authSlide2Desc: 'كمّل الحجوزات الناقصة وخلّ محلاتك المفضلة قريبة.',
    authSlide3Title: 'وصل مستعد، مو مستعجل',
    authSlide3Desc: 'تذكيرات لطيفة قبل كل قص أو صبغة أو جلسة عناية.',
    authSlideDot: 'عرض الميزة',
    emailAddress: 'البريد الإلكتروني',
    emailPlaceholder: 'أدخل بريدك الإلكتروني',
    password: 'كلمة المرور',
    passwordPlaceholder: 'أدخل كلمة المرور',
    rememberMe: 'تذكرني',
    forgotPasswordQ: 'هل نسيت كلمة المرور؟',
    signIn: 'تسجيل الدخول',
    dontHaveAccount: 'لا تملك حسابًا؟',
    signUpHere: 'سجّل من هنا',
    resetPassword: 'إعادة تعيين كلمة المرور',
    resetSubtitle: 'أدخل بريدك وسنرسل لك رمزاً من 4 أرقام',
    resetSubtitleCode: 'أدخل الرمز المرسل إلى بريدك واختر كلمة مرور جديدة.',
    sendResetLink: 'إرسال رابط الاستعادة',
    sendResetCode: 'إرسال الرمز',
    backToSignIn: 'العودة لتسجيل الدخول',
    emailRequired: 'البريد الإلكتروني مطلوب',
    resetSent: 'تم إرسال الرمز! تحقق من بريدك.',
    verificationCode: 'رمز التحقق',
    verificationCodeRequired: 'يرجى إدخال الرمز المكون من 4 أرقام',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    passwordRequired: 'كلمة المرور مطلوبة',
    passwordMismatch: 'كلمات المرور غير متطابقة',
    passwordUpdated: 'تم تحديث كلمة المرور! يمكنك تسجيل الدخول الآن.',
    setNewPassword: 'حفظ كلمة المرور الجديدة',
    // Explore
    discoverServices: 'احجز خدمات الجمال والعافية قربك',
    findPerfectService: 'صالونات وسبا وعيادات. اختر مكانك واحجز في دقائق.',
    searchServices: 'ابحث عن متاجر أو خدمات…',
    exploreMore: 'استكشف المزيد من الخدمات',
    featuredShops: 'جاهز للحجز',
    browseByCategory: 'تصفح حسب الفئة',
    discoverTailored: 'اكتشف خدمات مصممة لاحتياجاتك',
    grid: 'شبكة',
    list: 'قائمة',
    // About page
    aboutHeroTitle: 'بوابتك لتميز الجمال',
    aboutHeroSub: 'اكتشف واحجز وجرب أفضل خدمات الجمال في منطقتك',
    aboutTransformTitle: 'حوّل ',
    beautyJourney: 'رحلتك الجمالية',
    aboutTransformText: 'تواصل مع أفضل خبراء الجمال في منطقتك. احجز المواعيد، واكتشف خدمات جديدة، وغيّر روتينك الجمالي.',
    getStartedNow: 'ابدأ الآن',
    happyCustomers: 'عملاء سعداء',
    beautyPros: 'خبراء جمال',
    citiesCovered: 'مدن مشمولة',
    averageRating: 'متوسط التقييم',
    whyChooseUs: 'لماذا تختارنا؟',
    whyChooseUsSub: 'اختبر الفرق مع منصتنا الشاملة في عالم الجمال',
    aboutShopsTitle: 'اعثر على محلات قريبة',
    aboutShopsDesc: 'فلترة حسب نوع الخدمة ومنطقتك. كل الصالونات والعيادات على احجزلي، مرتبة حسب أعلى التقييمات.',
    aboutShopsAllCategories: 'كل الخدمات',
    aboutShopsAllAreas: 'كل المناطق',
    aboutShopsSearchPlaceholder: 'ابحث عن محل بالاسم…',
    aboutShopsPrev: 'المحلات السابقة',
    aboutShopsNext: 'المحلات التالية',
    aboutShopsLoading: 'جاري تحميل المحلات…',
    aboutShopsEmpty: 'لا توجد محلات مطابقة.',
    aboutShopsShowAll: 'عرض كل المحلات',
    aboutShopsShowLess: 'عرض أقل',
    discover: 'اكتشف',
    discoverText: 'اعثر على خبير الجمال المثالي في منطقتك ببحث وتصفية متقدمة.',
    book: 'احجز',
    bookText: 'احجز المواعيد بسهولة مع توافر فوري وتأكيدات فورية.',
    remind: 'ذكّر',
    remindText: 'لا تفوّت موعدًا مع التذكيرات الذكية والإشعارات.',
    ctaTitle: 'هل أنت مستعد لتطوير روتين جمالك؟',
    ctaText: 'انضم إلى آلاف العملاء واكتشف تطابقك المثالي اليوم',
    createAccount: 'إنشاء حساب',
    joinUs: 'انضم إلى احجزلي لحجز الصالونات والسبا والعيادات بالقرب منك',
    signUp: 'إنشاء حساب',
    fullName: 'الاسم الكامل',
    phoneNumber: 'رقم الهاتف',
    createStrongPassword: 'أنشئ كلمة مرور قوية',
    reqAtLeast8: 'ثمانية أحرف على الأقل',
    reqLowercase: 'حرف صغير',
    reqUppercase: 'حرف كبير',
    reqNumber: 'رقم',
    reqSpecial: 'رمز خاص (مثل ! @ # _ . ? -)',
    sendVerification: 'إرسال رمز التحقق',
    verifyPhone: 'تحقق من هاتفك',
    sent6Digit: 'أرسلنا رمزًا مكونًا من 6 أرقام إلى رقمك',
    verificationCode: 'رمز التحقق',
    resendIn: 'إعادة الإرسال خلال',
    resendCode: 'إعادة إرسال الرمز',
    verifyCode: 'تحقق من الرمز',
    demoCode: 'الرمز التجريبي',
    alreadyHaveAccount: 'لديك حساب بالفعل؟',
    signInHere: 'سجّل الدخول من هنا',
    enterYourFullName: 'أدخل اسمك الكامل',
    enterYourEmail: 'أدخل بريدك الإلكتروني',
    enter6DigitCode: 'أدخل الرمز المكون من 6 أرقام',
    // Navbar / generic
    openMenu: 'فتح القائمة',
    closeMenu: 'إغلاق القائمة',
    // Booking / receipt labels
    serviceLabel: 'الخدمة:',
    dateLabel: 'التاريخ:',
    timeLabel: 'الوقت:',
    staffLabel: 'الموظف:',
    totalLabel: 'الإجمالي:',
    noSlots: 'No available times',
    bookAppointment: 'تأكيد الحجز',
    shopNotFound: 'المتجر غير موجود',
    availableSlotTitle: 'موعد متاح',
    bookedSlotTitle: 'جميع الموظفين محجوزون في هذا التوقيت',
    prevImage: 'الصورة السابقة',
    nextImage: 'الصورة التالية',
    // Dashboard (client)
    dashboard: 'حسابي',
    navHome: 'الرئيسية',
    navHistory: 'سجل الحجوزات',
    navProfile: 'الملف الشخصي',
    navNotifications: 'الإشعارات',
    navLogout: 'تسجيل الخروج',
    dashWelcome: 'مرحبًا بعودتك',
    dashCurrentAppt: 'الحجز الحالي',
    dashExplore: 'استكشف',
    dashNoActive: 'لا توجد حجوزات نشطة حاليًا',
    dashSessionExpired: 'سجّل الدخول للمتابعة',
    dashSessionExpiredHint: 'انتهت جلستك. سجّل الدخول مرة أخرى لعرض حجزك الحالي.',
    dashSessionExpiredHistoryHint: 'انتهت جلستك. سجّل الدخول مرة أخرى لعرض سجل مواعيدك.',
    dashSessionExpiredProfileHint: 'انتهت جلستك. سجّل الدخول مرة أخرى لعرض ملفك الشخصي.',
    dashTryAgain: 'حاول مرة أخرى',
    dashDiscoverCTA: 'جاهز لحجز موعدك القادم؟ اكتشف خدمات مميزة واحجز بسهولة.',
    dashBookService: 'احجز خدمة',
    dashStepPending: 'قيد المراجعة',
    dashStepAccepted: 'مقبول',
    dashStepCompleted: 'مكتمل',
    dashCancelBooking: 'إلغاء الحجز',
    dashHistoryTitle: 'سجل المواعيد',
    dashHistorySub: 'تتبع كل مواعيدك السابقة والقادمة',
    dashStatTotal: 'الإجمالي',
    dashStatCompleted: 'المكتملة',
    dashStatPending: 'المنتظرة',
    dashStatTotalSpent: 'إجمالي الإنفاق',
    dashSearchAppointments: 'ابحث في المواعيد...',
    dashFilterAll: 'الكل',
    dashSortByDate: 'الفرز حسب التاريخ',
    dashSortByPrice: 'الفرز حسب السعر',
    dashSortByShop: 'الفرز حسب المتجر',
    dashLoading: 'جارٍ تحميل المواعيد...',
    dashErrorPrefix: 'خطأ في تحميل المواعيد:',
    dashNoneFound: 'لم يتم العثور على مواعيد',
    dashTryAdjust: 'جرّب تعديل البحث أو خيارات التصفية',
    dashNoneYet: 'لم تقم بأي مواعيد بعد',
    dashBookFirst: 'احجز أول موعد لك',
    dashBookingDetails: 'تفاصيل الحجز',
    dashShopInfo: 'المتجر والحجز',
    dashShopName: 'المتجر',
    dashBookingId: 'رقم الحجز',
    dashServiceInfo: 'الخدمة',
    dashService: 'الخدمة',
    dashStaff: 'الموظف',
    dashDateAndTime: 'التاريخ والوقت',
    dashDate: 'التاريخ',
    dashTime: 'الوقت',
    dashPayment: 'الدفع',
    dashTotalPrice: 'الإجمالي',
    dashCompleted: 'مكتمل',
    dashNotes: 'ملاحظات',
    dashReview: 'تقييم',
    markAllRead: 'تحديد الكل كمقروء',
    clearAll: 'مسح الكل',
    refresh: 'تحديث',
    notificationUnread: 'غير مقروء',
    notificationRead: 'مقروء',
    dashError: 'حدث خطأ ما',
    clearNotificationsConfirm: 'هل أنت متأكد من رغبتك في مسح جميع الإشعارات؟',
    allNotificationsCleared: 'تم مسح جميع الإشعارات',
    close: 'إغلاق',
    notification: 'إشعار',
    searchNotifications: 'البحث في الإشعارات',
    filterNotifications: 'تصفية حسب الحالة',
    notificationActions: 'إجراءات الإشعارات',
    notificationList: 'قائمة الإشعارات',
    labelDate: 'التاريخ',
    labelTime: 'الوقت',
    labelStaff: 'الموظف',
    labelPrice: 'السعر',
    dashNotAssigned: 'غير محدد',
    reviewTitle: 'قيّم زيارتك إلى',
    reviewSubmit: 'إرسال',
    reviewLater: 'لاحقًا',
    reviewPlaceholder: 'تعليق اختياري…',
    // Shop Owner Dashboard
    ownerNavProfile: 'الملف',
    ownerNavCalendar: 'التقويم',
    ownerNavAppointments: 'المواعيد',
    ownerNavAnalytics: 'التحليلات',
    ownerNavLogout: 'خروج',
    ownerWelcome: 'مرحبًا بعودتك 👋',
    ownerLoginTitle: 'دخول مالك المحل',
    ownerLoginShop: 'اسم المتجر',
    ownerLoginPassword: 'كلمة المرور',
    ownerLoginBtn: 'دخول',
    ownerLoginSubtitle: 'لوحة تحكم المحل',
    ownerNeedHelp: 'محتاج مساعدة؟ ',
    ownerContactSupport: 'اتصل بالدعم',
    ownerExportPDF: 'تصدير PDF',
    ownerPerformanceInsights: 'رؤى الأداء',
    ownerGeneratedOn: 'تم الإنشاء في',
    ownerRatingsReviews: 'التقييمات والمراجعات',
    ownerTotalReviews: 'إجمالي المراجعات',
    ownerNoReviewsYet: 'لسه مفيش مراجعات',
    ownerShowReviews: 'عرض المراجعات',
    ownerHideReviews: 'إخفاء المراجعات',
    ownerBizProfile: 'ملف النشاط التجاري',
    ownerBizProfileSub: 'ادير معلومات المحل وإعداداته',
    ownerEditProfile: 'تعديل الملف',
    ownerBusinessName: 'اسم النشاط',
    ownerLocation: 'الموقع',
    ownerPhone: 'الهاتف',
    ownerCategory: 'الفئة',
    ownerImages: 'صور النشاط',
    ownerNoImages: 'لسه مفيش صور',
    ownerServices: 'الخدمات',
    ownerStaffMembers: 'أعضاء الطاقم',
    ownerEditBizTitle: 'تعديل ملف النشاط',
    ownerBasicInfo: 'المعلومات الأساسية',
    ownerLabelName: 'الاسم',
    ownerLabelTown: 'المدينة',
    ownerSelect: 'اختر…',
    ownerLabelMap: 'رابط خريطة',
    ownerImagesHintClick: 'اضغط أو اسحب الصور هنا',
    ownerImagesHintMax: 'تقدر ترفع لحد 5 صور',
    ownerAvailability: 'التوافر',
    ownerSlotsFor: 'مواعيد يوم',
    ownerDayPickerHint: '(كليك يمين على اليوم عشان تشيله)',
    ownerServicesCount: 'الخدمات',
    ownerServiceNamePh: 'اسم الخدمة',
    ownerServicePricePh: 'السعر (ج.م)',
    ownerAddService: '+ إضافة خدمة',
    ownerStaffCount: 'الطاقم',
    ownerStaffNamePh: 'اسم الموظف',
    ownerRemoveStaff: 'حذف الموظف',
    ownerAddStaff: '+ إضافة موظف',
    ownerDuration: 'المدة',
    ownerMins: 'دقائق',
    ownerChangePassword: 'تغيير كلمة المرور',
    passwordFillBoth: 'لو سمحت املأ الحقلين',
    passwordMinLength: 'الباسورد الجديد لازم يكون 8 حروف على الأقل',
    passwordUpdatedSuccess: 'تم تحديث كلمة المرور',
    passwordUpdateFailed: 'فشل تحديث كلمة المرور',
    ownerCancel: 'إلغاء',
    ownerSaveChanges: 'حفظ التغييرات',
    ownerMyAppointments: 'مواعيدي',
    ownerMyAppointmentsSub: 'ادير كل مواعيد المحل',
    ownerStatusAll: 'كل الحالات',
    ownerAllStaff: 'كل الطاقم',
    ownerSelectDate: 'اختر التاريخ',
    ownerSortByDate: 'الفرز حسب التاريخ',
    ownerSortByPrice: 'الفرز حسب السعر',
    ownerSortByClient: 'الفرز حسب العميل',
    ownerEmptyAppts: 'مفيش مواعيد',
    ownerEmptyApptsHelp: 'لسه مفيش مواعيد',
    ownerClient: 'العميل',
    ownerAccept: 'قبول',
    ownerDecline: 'رفض',
    ownerMarkComplete: 'تم الإنجاز',
    ownerCancelBtn: 'إلغاء',
    ownerViewClientProfile: 'عرض بيانات العميل',
    ownerBookingRequest: 'طلب حجز',
    ownerAppointmentId: 'رقم الموعد',
    ownerServiceNameLabel: 'اسم الخدمة',
    ownerDateLabel: 'التاريخ',
    ownerTimeLabel: 'الوقت',
    // Shop Owner Dashboard - Calendar & Analytics
    ownerLoginFailed: 'فشل تسجيل الدخول',
    ownerPleaseComplete: 'لو سمحت املأ كل الحقول',
    ownerAvailable: 'متاح',
    ownerLoadingClientProfile: 'بيتم تحميل بيانات العميل...',
    ownerCouldNotLoadClient: 'مش قادرين نحمل بيانات العميل.',
    ownerSelectAppointment: 'اختار موعد',
    ownerClientProfile: 'بيانات العميل',
    ownerBookingStats: 'إحصائيات الحجوزات',
    ownerTotalBookings: 'إجمالي الحجوزات',
    ownerTotalSpentEGP: 'إجمالي الإنفاق (ج.م)',
    ownerCancelled: 'ملغي',
    emailNow: 'ارسل إيميل',
    ownerBusinessPerformanceOverview: 'نظرة عامة على أداء النشاط التجاري',
    ownerStartDate: 'تاريخ البداية',
    ownerEndDate: 'تاريخ النهاية',
    ownerReset: 'إعادة تعيين',
    ownerAllServices: 'كل الخدمات',
    ownerLast30Days: 'آخر 30 يوم',
    ownerLast12Weeks: 'آخر 12 أسبوع',
    ownerLast12Months: 'آخر 12 شهر',
    ownerLast5Years: 'آخر 5 سنوات',
    ownerCustomRange: 'نطاق مخصص',
    ownerBookingsVsRevenue: 'الحجوزات مقابل الإيرادات',
    ownerExportCSV: 'تصدير CSV',
    ownerAppointmentStatusDistribution: 'توزيع حالة المواعيد',
    ownerNoAppointmentDataAvailable: 'لا توجد بيانات مواعيد متاحة',
    ownerTopServicesByBookings: 'أفضل الخدمات حسب الحجوزات',
    ownerTopServicesByRevenue: 'أفضل الخدمات حسب الإيرادات',
    ownerNoServiceBookingsAvailable: 'لا توجد حجوزات خدمات متاحة',
    ownerRevenueByStaffMember: 'الإيرادات حسب الموظف',
    ownerNoStaffRevenueDataAvailable: 'لا توجد بيانات إيرادات موظفين متاحة',
    ownerBookingsByStaffMember: 'الحجوزات حسب الموظف',
    ownerNoStaffBookingDataAvailable: 'لا توجد بيانات حجوزات موظفين متاحة',
    ownerRevenueByServiceType: 'الإيرادات حسب نوع الخدمة',
    ownerNoServiceRevenueDataAvailable: 'لا توجد بيانات إيرادات خدمات متاحة',
    ownerStaffPerformanceOverview: 'نظرة عامة على أداء الموظفين',
    ownerBookings: 'الحجوزات',
    ownerRevenue: 'الإيرادات',
    ownerCompletion: 'الإنجاز',
    ownerAvgValue: 'متوسط القيمة',
    ownerNoStaffDataAvailable: 'لا توجد بيانات موظفين متاحة',
    ownerServicePerformanceOverview: 'نظرة عامة على أداء الخدمات',
    ownerAvgPrice: 'متوسط السعر',
    ownerNoServicePerformanceDataAvailable: 'لا توجد بيانات أداء خدمات متاحة',
    ownerRevenueByHour: 'الإيرادات حسب الساعة',
    ownerNoRevenueByHourDataAvailable: 'لا توجد بيانات إيرادات حسب الساعة متاحة',
    ownerWelcomeBack: 'مرحبًا بعودتك',
    ownerLoading: 'بيتم التحميل…',
    ownerAnalyticsAccessTitle: 'لوحة التحليلات',
    ownerAnalyticsAccessHint: 'ادخل الرمز السري 4 أرقام اللي المدير اداه لك عشان تفتح التحليلات',
    ownerAnalyticsPasscodePlaceholder: 'ادخل الرمز 4 أرقام',
    ownerAnalyticsCodeRequired: 'من فضلك ادخل رمز من 4 أرقام',
    ownerAnalyticsCodeInvalid: 'الرمز غير صحيح',
    ownerAnalyticsCodeFailed: 'فشل التحقق من الرمز. حاول مرة تانية.',
    ownerLockAnalytics: 'قفل التحليلات',
    ownerAccessAnalytics: 'افتح التحليلات',
    ownerValidating: 'بيتم التحقق...',
    ownerReportSummary: 'تقرير',
    ownerRanking: 'الترتيب',
    ownerBookingsRank: 'الحجوزات',
    ownerRevenueRank: 'الإيرادات',
    ownerExcellent: 'ممتاز',
    ownerVeryGood: 'جيد جداً',
    ownerGood: 'جيد',
    ownerBad: 'ضعيف',
    ownerAnalyticsTitle: 'الملخص التنفيذي',
    ownerGenerateReport: 'إنشاء التقرير',
    // Recommended common
    recPracticalAdvice: 'نصائح عملية وقوائم تحقق ونصوص للوصول إلى النتيجة التي تريدها',
    recFindStylist: 'ابحث عن مصفف',
    recBookConsultation: 'احجز استشارة',
    recBookNow: 'احجز الآن',
    recContactSalon: 'تواصل مع الصالون',
    recHairRemovalGuideMeta: 'دليل إزالة الشعر الاحترافي • محدث ديسمبر 2024',
    recBookHairRemoval: 'احجز إزالة شعر',
    recViewAllServices: 'عرض جميع الخدمات',
    // Analytics KPI labels
    ownerDateRange: 'نطاق التاريخ',
    ownerStaffLabelShort: 'الموظف',
    ownerServiceLabelShort: 'الخدمة',
    ownerFiltersContext: 'خيارات التصفية',
    ownerTotalAppointments: 'إجمالي المواعيد',
    ownerRevenueEGP: 'الإيرادات (ج.م)',
    ownerAvgBookingValue: 'متوسط قيمة الحجز',
    ownerCompletionRate: 'معدل الإنجاز',
    ownerCancellationRate: 'معدل الإلغاء',
    ownerAccepted: 'مقبول',
    // Calendar
    ownerSunday: 'الأحد',
    ownerMonday: 'الاثنين', 
    ownerTuesday: 'الثلاثاء',
    ownerWednesday: 'الأربعاء',
    ownerThursday: 'الخميس',
    ownerFriday: 'الجمعة',
    ownerSaturday: 'السبت',
    ownerSun: 'أحد',
    ownerMon: 'إثنين',
    ownerTue: 'ثلاثاء',
    ownerWed: 'أربعاء',
    ownerThu: 'خميس',
    ownerFri: 'جمعة',
    ownerSat: 'سبت',
    // Recommended pages
    recommendedServices: 'الخدمات الموصى بها',
    completeMensGroomingGuide: 'دليل العناية بالرجال الشامل 2024',
    professionalBarberingGuide: 'دليل الحلاقة المهني • محدث ديسمبر 2024',
    masterArtMensGrooming: 'أتقن فن العناية بالرجال من خلال دليلنا الشامل لتقنيات الحلاقة الحديثة وأنماط الشوارب وروتين العناية. من القصات الكلاسيكية إلى الاتجاهات المعاصرة، اكتشف النصائح المهنية للحفاظ على أفضل مظهر لك. سواء كنت جديدًا في العناية المهنية أو تبحث عن تحسين روتينك، يغطي هذا الدليل كل شيء من قص الشعر إلى العناية بالبشرة.',
    // Barbershop translations - Arabic
    masterMustacheStyles: 'إتقان أنماط الشوارب ومطابقة شكل الوجه',
    discoverClassicModern: 'اكتشف أنماط الشوارب الكلاسيكية والحديثة التي تكمل شكل وجهك تمامًا وتعزز جاذبيتك الذكورية',
    professionalMensHaircut: 'اتجاهات قص شعر الرجال المهنية والتنسيق',
    masterHottestHaircut: 'أتقن أحدث اتجاهات قص الشعر وتعلم تقنيات التنسيق المهنية للحصول على نتائج عالية الجودة في المنزل',
    completeBeardCare: 'العناية الكاملة باللحية والتنسيق المهني',
    learnProfessionalBeard: 'تعلم روتين العناية المهنية باللحية وتقنيات التنسيق وحل المشاكل للحصول على شعر وجه صحي وجذاب',
    mensSkincareMastery: 'إتقان العناية ببشرة الرجال وروتين البشرة الصحية',
    buildProfessionalSkincare: 'ابني روتين عناية بالبشرة مهني يمنع المشاكل الشائعة ويحافظ على بشرة صحية ونقية على مدار السنة',
    professionalGroomingTools: 'أدوات العناية المهنية والإعداد المنزلي',
    buildProfessionalGrooming: 'ابني مجموعة أدوات عناية مهنية وتعلم تقنيات الصيانة للحصول على نتائج عالية الجودة بين زيارات الحلاق',
    considerFaceShape: 'ضع في اعتبارك شكل وجهك عند اختيار نمط الشارب',
    startWithStyle: 'ابدأ بنمط يطابق نمط نمو شعرك',
    factorProfessional: 'ضع في اعتبارك بيئتك المهنية ووقت الصيانة',
    readyElevateGrooming: 'مستعد لرفع مستوى لعبة العناية بك؟',
    dontWaitTry: 'لا تنتظر لتجربة هذه التقنيات المهنية للعناية! احجز موعداً مع أحد حلاقينا الخبراء المتخصصين في القصات الحديثة والأنماط الكلاسيكية وخدمات العناية الشاملة. من قص الشعر الدقيق إلى تنسيق اللحية وعلاجات العناية بالبشرة، سنساعدك في تحقيق المظهر المثالي الذي يعكس أسلوبك الشخصي.',
    // Barbershop content translations - Arabic
    recBarberMustacheIntro: 'اكتشف نمط الشارب المثالي الذي يعزز ملامح وجهك ويعكس أسلوبك الشخصي. من الأناقة الكلاسيكية إلى التصريحات العصرية الجريئة، اعثر على الشارب المثالي لشكل وجهك ونمط حياتك.',
    recBarberMustacheContent1: 'عاد الشارب بقوة في عام 2024، مع أنماط تتراوح من الأناقة الكلاسيكية إلى التصريحات العصرية الجريئة. يشارك الحلاقون المحترفون خبراتهم في اختيار نمط الشارب المثالي لشكل وجهك ونمط حياتك وتفضيلاتك الشخصية.',
    recBarberMustacheContent2: 'أنماط الشوارب الشائعة',
    recBarberMustacheContent3: '1. الشارب الكلاسيكي الرقيق',
    recBarberMustacheContent4: 'الوصف:',
    recBarberMustacheContent5: 'خط رفيع ودقيق فوق الشفة العليا، اشتهر به أيقونات هوليوود مثل كلارك جابل.',
    recBarberMustacheContent6: 'الأفضل لـ:',
    recBarberMustacheContent7: 'البيئات المهنية والمناسبات الرسمية وأولئك الذين يفضلون شعر الوجه الخفيف.',
    recBarberMustacheContent8: 'الصيانة:',
    recBarberMustacheContent9: 'تقليم يومي بمقصات دقيقة أو ماكينة حلاقة كهربائية.',
    recBarberMustacheContent10: '2. الشارب المقوس',
    recBarberMustacheContent11: 'شارب كامل مع نهايات مجعدة تشير إلى الأعلى، مما يخلق مظهرًا مميزًا وجريئًا.',
    recBarberMustacheContent12: 'أولئك الذين يريدون قطعة مميزة ولا يمانعون التنسيق اليومي.',
    recBarberMustacheContent13: 'التنسيق:',
    recBarberMustacheContent14: 'استخدم شمع الشارب لتجعيد النهايات وتثبيتها في مكانها.',
    recBarberMustacheContent15: '3. الشارب المثلث',
    recBarberMustacheContent16: 'شارب سميك وكامل يغطي الشفة العليا، اشتهر به توم سيلك.',
    recBarberMustacheContent17: 'الرجال ذوو شعر الوجه السميك الذين يريدون مظهرًا كلاسيكيًا ذكوريًا.',
    recBarberMustacheContent18: 'تقليم منتظم للحفاظ على الشكل ومنع النمو الزائد.',
    recBarberMustacheContent19: '4. الشارب على شكل حدوة الحصان',
    recBarberMustacheContent20: 'شارب يمتد إلى أسفل جانبي الفم، يشبه شكل حدوة الحصان.',
    recBarberMustacheContent21: 'الأفراد الجريئون الذين يريدون مظهرًا مميزًا وحادًا.',
    recBarberMustacheContent22: 'يتطلب تقليمًا دقيقًا للحفاظ على شكل حدوة الحصان.',
    recBarberMustacheContent23: 'اختيار نمط الشارب المناسب',
    recBarberMustacheContent24: 'اعتبارات شكل الوجه',
    recBarberMustacheContent25: 'الوجوه المستديرة:',
    recBarberMustacheContent26: 'اختر الأنماط التي تضيف الطول، مثل الرقيق أو المقوس',
    recBarberMustacheContent27: 'الوجوه المربعة:',
    recBarberMustacheContent28: 'الأنماط الأكثر نعومة مثل المثلث تعمل بشكل جيد',
    recBarberMustacheContent29: 'الوجوه البيضاوية:',
    recBarberMustacheContent30: 'معظم الأنماط تعمل، جرب للعثور على تفضيلك',
    recBarberMustacheContent31: 'الوجوه الطويلة:',
    recBarberMustacheContent32: 'الأنماط الأكثر امتلاءً مثل المثلث تضيف العرض',
    recBarberMustacheContent33: 'عوامل نمط الحياة',
    recBarberMustacheContent34: 'البيئة المهنية:',
    recBarberMustacheContent35: 'ضع في اعتبارك سياسات مكان العمل وتوقعات العملاء',
    recBarberMustacheContent36: 'وقت الصيانة:',
    recBarberMustacheContent37: 'بعض الأنماط تتطلب تنسيقًا ورعاية يومية',
    recBarberMustacheContent38: 'الأسلوب الشخصي:',
    recBarberMustacheContent39: 'اختر نمطًا يعكس شخصيتك',
    recBarberMustacheContent40: 'نمط نمو الشعر:',
    recBarberMustacheContent41: 'اعمل مع نمو شعرك الطبيعي',
    recBarberHaircutIntro: 'أتقن أحدث اتجاهات قص الشعر وتعلم تقنيات التنسيق المهنية التي تمزج بين الحلاقة الكلاسيكية والجماليات العصرية. من القصات الدقيقة إلى الأنماط الملمسية، اكتشف مظاهر متعددة تعزز تعبيرك الفردي.',
    recBarberHaircutContent1: 'تطورت قصات شعر الرجال بشكل كبير، ممزجة تقنيات الحلاقة الكلاسيكية مع اتجاهات التنسيق العصرية. من القصات الدقيقة إلى الأنماط الملمسية، تركز اتجاهات هذا العام على التنوع والصيانة المنخفضة والتعبير الفردي.',
    recBarberHaircutContent2: 'أفضل اتجاهات القص',
    recBarberHaircutContent3: '1. التدرج الحديث',
    recBarberHaircutContent4: 'انتقال تدريجي من الشعر القصير إلى الأقصر، مما يخلق مزجًا سلسًا.',
    recBarberHaircutContent5: 'الاختلافات:',
    recBarberHaircutContent6: 'تدرج عالي، تدرج متوسط، تدرج منخفض، تدرج جلدي',
    recBarberHaircutContent7: 'لمسات كل 2-3 أسابيع للحفاظ على التدرج',
    recBarberHaircutContent8: '2. القص الملمسي',
    recBarberHaircutContent9: 'قص قصير وملمسي مع طبقات مقطعة وحركة طبيعية.',
    recBarberHaircutContent10: 'الشعر السميك الذي يحتاج إلى ملمس وحركة',
    recBarberHaircutContent11: 'استخدم منتجات الملمس لإضافة التعريف',
    recBarberHaircutContent12: '3. الفرقة الجانبية الكلاسيكية',
    recBarberHaircutContent13: 'نمط خالد مع فرقة محددة وجوانب ملساء للخلف.',
    recBarberHaircutContent14: 'البيئات المهنية والمناسبات الرسمية',
    recBarberHaircutContent15: 'استخدم البوماد أو الجل للحصول على مظهر مصقول',
    recBarberHaircutContent16: '4. القمة الطويلة، الجوانب القصيرة',
    recBarberHaircutContent17: 'شعر أطول في القمة مع جوانب أقصر، مما يسمح بتنسيق متعدد.',
    recBarberHaircutContent18: 'خيارات التنسيق:',
    recBarberHaircutContent19: 'ملساء للخلف، ملمسي، أو منسق للأعلى',
    recBarberHaircutContent20: 'تقليمات منتظمة للحفاظ على الشكل',
    recBarberHaircutContent21: 'نصائح تنسيق الشعر',
    recBarberHaircutContent22: 'اختيار المنتج',
    recBarberHaircutContent23: 'البوماد:',
    recBarberHaircutContent24: 'للمظاهر الملساء والمصقولة',
    recBarberHaircutContent25: 'الشمع:',
    recBarberHaircutContent26: 'للمسات النهائية الملمسية والمطفأة',
    recBarberHaircutContent27: 'الجل:',
    recBarberHaircutContent28: 'للثبات القوي واللمعان',
    recBarberHaircutContent29: 'الكريم:',
    recBarberHaircutContent30: 'للتنسيق الطبيعي والمرن',
    recBarberHaircutContent31: 'تقنيات التنسيق',
    recBarberHaircutContent32: 'التجفيف بالمجفف:',
    recBarberHaircutContent33: 'استخدم الحرارة لإنشاء الحجم والشكل',
    recBarberHaircutContent34: 'التنسيق بالأصابع:',
    recBarberHaircutContent35: 'استخدم الأصابع لإنشاء ملمس طبيعي',
    recBarberHaircutContent36: 'التنسيق بالمشط:',
    recBarberHaircutContent37: 'استخدم الأمشاط للمظاهر الدقيقة والنظيفة',
    recBarberHaircutContent38: 'تطبيق المنتج:',
    recBarberHaircutContent39: 'ابدأ بكميات صغيرة وزد تدريجيًا',
    recBarberHaircutQuickTip1: 'اختر القصات التي تعمل مع ملمس شعرك ونمط النمو',
    recBarberHaircutQuickTip2: 'ضع في اعتبارك نمط حياتك وتفضيلات الصيانة',
    recBarberHaircutQuickTip3: 'استخدم منتجات عالية الجودة للتنسيق والصيانة',
    recBarberBeardIntro: 'تعلم روتين العناية المهنية باللحية وتقنيات التنسيق وطرق حل المشاكل لتحقيق شعر وجه صحي وجذاب يعزز مظهرك ويشعر بالراحة.',
    recBarberBeardContent1: 'تتطلب اللحية المهذبة بشكل جيد العناية والصيانة وتقنيات التنسيق المناسبة. يشارك الحلاقون المحترفون أسرارهم لتحقيق لحية صحية وجذابة تعزز مظهرك وتشعر بالراحة.',
    recBarberBeardContent2: 'روتين العناية باللحية',
    recBarberBeardContent3: 'العناية اليومية',
    recBarberBeardContent4: 'الغسيل:',
    recBarberBeardContent5: 'استخدم شامبو خاص باللحية 2-3 مرات في الأسبوع',
    recBarberBeardContent6: 'البلسم:',
    recBarberBeardContent7: 'طبق بلسم اللحية للحفاظ على الشعر ناعمًا',
    recBarberBeardContent8: 'الترطيب:',
    recBarberBeardContent9: 'استخدم زيت اللحية لمنع الجفاف والحكة',
    recBarberBeardContent10: 'الفرشاة:',
    recBarberBeardContent11: 'استخدم فرشاة من شعيرات الخنزير لتوزيع الزيوت',
    recBarberBeardContent12: 'المشط:',
    recBarberBeardContent13: 'استخدم مشطًا واسع الأسنان لفك التشابك والتنسيق',
    recBarberBeardContent14: 'الصيانة الأسبوعية',
    recBarberBeardContent15: 'التقليم:',
    recBarberBeardContent16: 'حافظ على الشكل وأزل الأطراف المنقسمة',
    recBarberBeardContent17: 'التقشير:',
    recBarberBeardContent18: 'أزل خلايا الجلد الميتة وامنع نمو الشعر تحت الجلد',
    recBarberBeardContent19: 'الترطيب العميق:',
    recBarberBeardContent20: 'استخدم أقنعة اللحية للترطيب الإضافي',
    recBarberBeardContent21: 'التنسيق:',
    recBarberBeardContent22: 'استخدم بلسم اللحية للثبات والتنسيق',
    recBarberBeardContent23: 'تقنيات تنسيق اللحية',
    recBarberBeardContent24: 'تشكيل لحيتك',
    recBarberBeardContent25: 'حدد خط العنق:',
    recBarberBeardContent26: 'أنشئ خطًا نظيفًا أسفل الفك',
    recBarberBeardContent27: 'قص الخدين:',
    recBarberBeardContent28: 'حافظ على خط خد طبيعي',
    recBarberBeardContent29: 'شكل الشارب:',
    recBarberBeardContent30: 'احتفظ به مرتبًا ومحددًا',
    recBarberBeardContent31: 'تسوية الطول:',
    recBarberBeardContent32: 'قص الشعر الأطول لمظهر موحد',
    recBarberBeardContent33: 'أنماط اللحية',
    recBarberBeardContent34: 'لحية كاملة:',
    recBarberBeardContent35: 'نمو طبيعي غير مقلم',
    recBarberBeardContent36: 'لحية قصيرة:',
    recBarberBeardContent37: 'مقلمة إلى 1-2 بوصة في الطول',
    recBarberBeardContent38: 'لحية الماعز:',
    recBarberBeardContent39: 'شعر على الذقن ومنطقة الشارب فقط',
    recBarberBeardContent40: 'فان دايك:',
    recBarberBeardContent41: 'شارب ولحية الماعز بدون اتصال',
    recBarberBeardContent42: 'اللحية الخفيفة:',
    recBarberBeardContent43: 'شعر وجه قصير ومحافظ عليه',
    recBarberBeardContent44: 'مشاكل اللحية الشائعة والحلول',
    recBarberBeardContent45: 'الحكة',
    recBarberBeardContent46: 'الأسباب:',
    recBarberBeardContent47: 'جلد جاف، نمو جديد، نظافة سيئة',
    recBarberBeardContent48: 'الحلول:',
    recBarberBeardContent49: 'استخدم زيت اللحية، قشر بانتظام، حافظ على النظافة',
    recBarberBeardContent50: 'النمو غير المتساوي',
    recBarberBeardContent51: 'الوراثة، العمر، العوامل الهرمونية',
    recBarberBeardContent52: 'اختر الأنماط التي تعمل مع نمط نموك، كن صبورًا',
    recBarberBeardContent53: 'الشعر النامي تحت الجلد',
    recBarberBeardContent54: 'الحلاقة غير الصحيحة، الملابس الضيقة، النظافة السيئة',
    recBarberBeardContent55: 'قشر بانتظام، استخدم تقنيات حلاقة صحيحة',
    recBarberBeardQuickTip1: 'استخدم منتجات خاصة باللحية للعناية المثلى',
    recBarberBeardQuickTip2: 'أنشئ روتينًا يوميًا وأسبوعيًا ثابتًا',
    recBarberBeardQuickTip3: 'اعمل مع نمط نموك الطبيعي للحصول على أفضل النتائج',
    recBarberSkincareIntro: 'ابني روتين عناية بالبشرة مهني يمنع المشاكل الشائعة مثل حب الشباب والتهيج والشيخوخة المبكرة. تعلم تقنيات أساسية للحفاظ على بشرة صحية ونقية بطريقة بسيطة وثابتة.',
    recBarberSkincareContent1: 'العناية بالبشرة المناسبة ضرورية للحفاظ على بشرة صحية ونقية ومنع المشاكل الشائعة مثل حب الشباب والتهيج والشيخوخة المبكرة. يمكن لروتين بسيط وثابت أن يحدث فرقًا كبيرًا في مظهر بشرتك وصحتها.',
    recBarberSkincareContent2: 'روتين العناية بالبشرة الأساسي',
    recBarberSkincareContent3: 'الروتين الصباحي',
    recBarberSkincareContent4: 'المنظف:',
    recBarberSkincareContent5: 'غسول وجه لطيف لإزالة الزيوت الليلية',
    recBarberSkincareContent6: 'التونر:',
    recBarberSkincareContent7: 'وازن الأس الهيدروجيني وجهز البشرة للمنتجات',
    recBarberSkincareContent8: 'المرطب:',
    recBarberSkincareContent9: 'رطب البشرة واحمها',
    recBarberSkincareContent10: 'واقي الشمس:',
    recBarberSkincareContent11: 'ضروري لمنع تلف الشمس',
    recBarberSkincareContent12: 'الروتين المسائي',
    recBarberSkincareContent13: 'أزل الأوساخ والزيوت والمنتجات من اليوم',
    recBarberSkincareContent14: 'المقشر:',
    recBarberSkincareContent15: 'أزل خلايا الجلد الميتة (2-3 مرات في الأسبوع)',
    recBarberSkincareContent16: 'السيروم:',
    recBarberSkincareContent17: 'استهدف مخاوف البشرة المحددة',
    recBarberSkincareContent18: 'أصلح ورطب طوال الليل',
    recBarberSkincareContent19: 'مخاوف البشرة الشائعة',
    recBarberSkincareContent20: 'حب الشباب',
    recBarberSkincareContent21: 'الزيت الزائد، البكتيريا، التغيرات الهرمونية',
    recBarberSkincareContent22: 'حمض الساليسيليك، بيروكسيد البنزويل، التنظيف اللطيف',
    recBarberSkincareContent23: 'حرق الحلاقة',
    recBarberSkincareContent24: 'تقنية حلاقة غير صحيحة، شفرات باهتة',
    recBarberSkincareContent25: 'شفرات حادة، تحضير صحيح، منتجات مهدئة',
    recBarberSkincareContent26: 'البشرة الجافة',
    recBarberSkincareContent27: 'الطقس، المنتجات القاسية، الرطوبة غير الكافية',
    recBarberSkincareContent28: 'منظفات لطيفة، مرطبات غنية، مرطبات الهواء',
    recBarberSkincareContent29: 'العلاجات المهنية',
    recBarberSkincareContent30: 'الوجه',
    recBarberSkincareContent31: 'توفر الوجه المهنية تنظيفًا عميقًا وتقشيرًا وعلاجًا لمخاوف البشرة المحددة. يمكن للوجه المنتظم أن يحسن ملمس البشرة ويقلل من البثور ويحافظ على بشرة صحية.',
    recBarberSkincareContent32: 'التقشير الكيميائي',
    recBarberSkincareContent33: 'يزيل التقشير الكيميائي طبقات الجلد التالفة، ويكشف عن بشرة أكثر نعومة وتوحيدًا. يمكن أن يساعد في مشاكل حب الشباب والشيخوخة والتلون.',
    recBarberSkincareQuickTip1: 'ابدأ بروتين أساسي وأضف المنتجات تدريجيًا',
    recBarberSkincareQuickTip2: 'استخدم واقي الشمس دائمًا لمنع تلف الشمس',
    recBarberSkincareQuickTip3: 'اختر منتجات مناسبة لنوع بشرتك',
    recBarberToolsIntro: 'ابني مجموعة أدوات عناية مهنية بالأدوات والتقنيات الصحيحة لتحقيق نتائج بجودة الصالون في المنزل. تعلم جداول الصيانة والعناية المناسبة لإطالة عمر معدات العناية الخاصة بك.',
    recBarberToolsContent1: 'امتلاك أدوات العناية الصحيحة ضروري للحفاظ على مظهرك بين زيارات الحلاق. يوصي الحلاقون المحترفون بأدوات وتقنيات محددة لتحقيق نتائج بجودة الصالون في المنزل.',
    recBarberToolsContent2: 'الأدوات الأساسية',
    recBarberToolsContent3: 'أدوات قص الشعر',
    recBarberToolsContent4: 'ماكينات الحلاقة الكهربائية:',
    recBarberToolsContent5: 'للتقليم والتدرج',
    recBarberToolsContent6: 'المقصات:',
    recBarberToolsContent7: 'للقص الدقيق والتفاصيل',
    recBarberToolsContent8: 'الأمشاط:',
    recBarberToolsContent9: 'للتقسيم والتنسيق',
    recBarberToolsContent10: 'المرايا:',
    recBarberToolsContent11: 'للتحقق من جميع الزوايا',
    recBarberToolsContent12: 'أدوات تنسيق اللحية',
    recBarberToolsContent13: 'ماكينة حلاقة اللحية:',
    recBarberToolsContent14: 'للحفاظ على الطول والشكل',
    recBarberToolsContent15: 'فرشاة اللحية:',
    recBarberToolsContent16: 'لتوزيع الزيوت والتنسيق',
    recBarberToolsContent17: 'مشط اللحية:',
    recBarberToolsContent18: 'لفك التشابك والتنسيق',
    recBarberToolsContent19: 'زيت اللحية:',
    recBarberToolsContent20: 'للترطيب والبلسم',
    recBarberToolsContent21: 'أدوات العناية بالبشرة',
    recBarberToolsContent22: 'منظف الوجه:',
    recBarberToolsContent23: 'للتنظيف اليومي',
    recBarberToolsContent24: 'مقشر التقشير:',
    recBarberToolsContent25: 'لإزالة الجلد الميت',
    recBarberToolsContent26: 'المرطب:',
    recBarberToolsContent27: 'لترطيب البشرة',
    recBarberToolsContent28: 'واقي الشمس:',
    recBarberToolsContent29: 'للحماية من تلف الأشعة فوق البنفسجية',
    recBarberToolsContent30: 'صيانة الأدوات',
    recBarberToolsContent31: 'التنظيف والتعقيم',
    recBarberToolsContent32: 'التنظيف المنتظم:',
    recBarberToolsContent33: 'نظف الأدوات بعد كل استخدام',
    recBarberToolsContent34: 'التعقيم:',
    recBarberToolsContent35: 'استخدم الكحول أو محاليل التعقيم',
    recBarberToolsContent36: 'الشحذ:',
    recBarberToolsContent37: 'احتفظ بالشفرات حادة للحصول على أفضل النتائج',
    recBarberToolsContent38: 'التخزين:',
    recBarberToolsContent39: 'قم بتخزين الأدوات في أماكن نظيفة وجافة',
    recBarberToolsContent40: 'جدول الاستبدال',
    recBarberToolsContent41: 'شفرات الحلاقة:',
    recBarberToolsContent42: 'استبدل كل 5-7 حلاقات',
    recBarberToolsContent43: 'شفرات ماكينة الحلاقة:',
    recBarberToolsContent44: 'اشحذ أو استبدل كل 6 أشهر',
    recBarberToolsContent45: 'المقصات:',
    recBarberToolsContent46: 'اشحذ سنويًا أو حسب الحاجة',
    recBarberToolsContent47: 'الفرش:',
    recBarberToolsContent48: 'نظف شهريًا، استبدل سنويًا',
    recBarberToolsQuickTip1: 'استثمر في أدوات عالية الجودة لنتائج أفضل وطول العمر',
    recBarberToolsQuickTip2: 'نظف وعقم الأدوات بانتظام',
    recBarberToolsQuickTip3: 'استبدل الشفرات والملحقات حسب الجدول',
    bookBarberAppointment: 'احجز موعد حلاقة',
    viewAllServices: 'عرض جميع الخدمات',
    tableOfContents: 'جدول المحتويات',
    sections: 'أقسام',
    minTotalRead: 'دقيقة إجمالي القراءة',
    masterMustacheStyles: 'إتقان أنماط الشوارب ومطابقة شكل الوجه',
    discoverClassicModern: 'اكتشف أنماط الشوارب الكلاسيكية والحديثة التي تكمل شكل وجهك تمامًا وتعزز جاذبيتك الذكورية',
    minRead: 'دقيقة قراءة',
    beginner: 'مبتدئ',
    intermediate: 'متوسط',
    advanced: 'متقدم',
    bookService: 'احجز خدمة',
    // Category pages
    filterByTown: 'تصفية حسب المنطقة',
    total: 'الإجمالي',
    showMore: 'عرض المزيد',
    showLess: 'عرض أقل',
    allOurBarbershops: 'كل محلات الحلاقة',
    allOurHairNailSalons: 'كل صالونات الشعر والأظافر',
    allOurMakeupServices: 'كل خدمات المكياج',
    allOurLaserClinics: 'كل عيادات الليزر',
    searchBarbershops: 'ابحث عن محلات الحلاقة…',
    searchSalons: 'ابحث عن الصالونات…',
    searchMakeup: 'ابحث عن خدمات المكياج…',
    searchClinics: 'ابحث عن العيادات…',
    allOurBrowsLashes: 'كل خدمات الحواجب والرموش',
    allOurMassageAesthetic: 'كل عيادات التدليك والجمال',
    allOurTattooPiercing: 'كل محلات الوشم والثقب',
    searchBrowsLashes: 'ابحث عن المحلات…',
    searchMassageAesthetic: 'ابحث عن العيادات…',
    searchTattooPiercing: 'ابحث عن المحلات…',
    whereToExpectShops: 'أين تتوقع محلاتنا',
    allOurPetServices: 'كل محلات خدمات الحيوانات الأليفة',
    searchPetServices: 'ابحث عن خدمات الحيوانات الأليفة…',
    // Team page
    ourVision: 'رؤيتنا',
    smallTeamBigImpact: 'فريق صغير. تأثير كبير.',
    visionText: 'أنا يوسف هلال، خريج علوم الحاسوب من جامعة رويال هولواي في لندن. مهمتي هي مساعدة الناس وجعل حياتهم أسهل. لتحقيق هذا، أقوم بتطوير تطبيق حجز لمحلات الجمال والعافية يوفر الوقت ويبسط الجدولة ويقدم فوائد رئيسية:',
    quickEasyBooking: 'حجز سريع وسهل',
    transparentPricing: 'أسعار شفافة وعروض',
    timeSaving: 'توفير الوقت للعملاء والشركات',
    ratingsReviews: 'تقييمات ومراجعات لخيارات أفضل',
    teamBenefitsTitle: 'ما يقدمه احجزلي',
    teamJoinTitle: 'تريد الشراكة أو الانضمام؟',
    teamJoinDesc: 'تواصل معنا للشراكات، الوظائف، أو أي استفسارات عامة.',
    teamJoinCta: 'تواصل مع الدعم',
    // Privacy Policy
    effectiveLabel: 'سريان',
    // Privacy list items
    ppCollectAccountInfo: 'معلومات الحساب (الاسم، البريد الإلكتروني، الهاتف، تفاصيل المتجر التي تقدمها).',
    ppCollectBookings: 'الحجوزات والمدفوعات (تفاصيل المواعيد، الإجمالي؛ البطاقات تتم معالجتها عبر مزودي دفع آمنين).',
    ppCollectUsageData: 'بيانات الاستخدام (السجلات، معلومات الجهاز والمتصفح، وملفات تعريف الارتباط للحفاظ على تسجيل دخولك وتحسين التطبيق).',
    ppUseProvideImprove: 'تقديم الخدمة وتحسينها.',
    ppUseProcess: 'معالجة الحجوزات والإيصالات والإشعارات.',
    ppUsePreventFraud: 'منع الاحتيال وضمان الأمان.',
    ppUseComply: 'الامتثال للمتطلبات القانونية.',
    ppSharingIntro: 'لا نبيع البيانات الشخصية. نشارك معلومات محدودة مع:',
    ppSharingProviders: 'مقدمي الخدمات (الاستضافة، التحليلات، المدفوعات) بموجب عقود صارمة.',
    ppSharingBooked: 'المتاجر المحجوزة لتنفيذ موعدك.',
    ppSharingAuthorities: 'الجهات المختصة عند الطلب بموجب القانون أو لحماية السلامة.',
    ppSecurityText: 'يتم تشفير البيانات أثناء النقل وتخزينها على بنية تحتية محصنة. نحتفظ بها فقط طالما كانت مطلوبة للخدمة والالتزامات القانونية، ثم نحذفها أو نُخفي هويتها.',
    ppChoiceUpdateProfile: 'حدّث ملفك الشخصي في أي وقت داخل التطبيق.',
    ppChoiceUnsubscribe: 'ألغِ الاشتراك في التسويق عبر تذييل البريد الإلكتروني.',
    ppChoiceRequestDeletion: 'اطلب بياناتك أو حذف الحساب: bookwithehgezly@gmail.com.',
    ppChoiceControlCookies: 'تحكم بملفات تعريف الارتباط من إعدادات المتصفح (بعضها أساسي).',
    // Dashboard Profile tab
    personalInformation: 'المعلومات الشخصية',
    manageAccountDetails: 'إدارة تفاصيل حسابك والتفضيلات',
    editProfile: 'تعديل الملف الشخصي',
    dashEditProfile: 'تعديل الملف الشخصي',
    dashChangePassword: 'تغيير كلمة المرور',
    editPersonalInformation: 'تعديل المعلومات الشخصية',
    updateAccountDetails: 'حدّث تفاصيل حسابك أدناه',
    name: 'الاسم',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    memberSince: 'عضو منذ',
    dashMemberSince: 'عضو منذ',
    dashPhone: 'الهاتف',
    dashEmail: 'البريد الإلكتروني',
    unavailable: 'غير متاح',
    profileUpdated: 'تم تحديث الملف الشخصي',
    failedToUpdateProfile: 'فشل في تحديث الملف الشخصي',
    cancel: 'إلغاء',
    saveChanges: 'حفظ التغييرات',
    saving: 'جاري الحفظ…',
    updatePasswordSubtitle: 'قم بتحديث كلمة مرور حسابك',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
    updatePassword: 'تحديث كلمة المرور',
    // Auth components
    hidePassword: 'إخفاء كلمة المرور',
    showPassword: 'إظهار كلمة المرور',
    sent6DigitCode: 'أرسلنا رمزاً من 6 أرقام إلى هاتفك.',
    phoneVerified: 'تم التحقق من الهاتف — يمكنك تسجيل الدخول الآن.',
    professionalMensHaircut: 'اتجاهات قص شعر الرجال المهنية والتنسيق',
    masterHottestHaircut: 'أتقن أحدث اتجاهات قص الشعر وتعلم تقنيات التنسيق المهنية للحصول على نتائج عالية الجودة في المنزل',
    completeBeardCare: 'العناية الكاملة باللحية والتنسيق المهني',
    learnProfessionalBeard: 'تعلم روتين العناية المهنية باللحية وتقنيات التنسيق وحل المشاكل للحصول على شعر وجه صحي وجذاب',
    mensSkincareMastery: 'إتقان العناية ببشرة الرجال وروتين البشرة الصحية',
    buildProfessionalSkincare: 'ابني روتين عناية بالبشرة مهني يمنع المشاكل الشائعة ويحافظ على بشرة صحية ونقية على مدار السنة',
    professionalGroomingTools: 'أدوات العناية المهنية والإعداد المنزلي',
    buildProfessionalGrooming: 'ابني مجموعة أدوات عناية مهنية وتعلم تقنيات الصيانة للحصول على نتائج عالية الجودة بين زيارات الحلاق',
    quickTips: 'نصائح سريعة',
    considerFaceShape: 'ضع في اعتبارك شكل وجهك عند اختيار نمط الشارب',
    startWithStyle: 'ابدأ بنمط يطابق نمط نمو شعرك',
    factorProfessional: 'ضع في اعتبارك بيئتك المهنية ووقت الصيانة',
    chooseCutsWork: 'اختر قصات تعمل مع ملمس شعرك ونمط النمو',
    considerLifestyle: 'ضع في اعتبارك نمط حياتك وتفضيلات الصيانة',
    useQualityProducts: 'استخدم منتجات عالية الجودة للتنسيق والصيانة',
    useBeardSpecific: 'استخدم منتجات خاصة باللحية للعناية المثلى',
    establishConsistent: 'أنشئ روتين يومي وأسبوعي ثابت',
    workWithNatural: 'اعمل مع نمط نموك الطبيعي للحصول على أفضل النتائج',
    startWithBasic: 'ابدأ بروتين أساسي وأضف المنتجات تدريجياً',
    alwaysUseSunscreen: 'استخدم واقي الشمس دائماً لمنع أضرار الشمس',
    chooseProductsSuitable: 'اختر منتجات مناسبة لنوع بشرتك',
    investQualityTools: 'استثمر في أدوات عالية الجودة للحصول على نتائج أفضل ومتانة أطول',
    cleanSanitizeTools: 'نظف وعقم الأدوات بانتظام',
    replaceBladesAccessories: 'استبدل الشفرات والملحقات حسب الجدول',
    readyElevateGrooming: 'مستعد لرفع مستوى لعبة العناية بك؟',
    dontWaitTry: 'لا تنتظر لتجربة هذه التقنيات المهنية للعناية! احجز موعداً مع أحد حلاقينا الخبراء المتخصصين في القصات الحديثة والأنماط الكلاسيكية وخدمات العناية الشاملة. من قص الشعر الدقيق إلى تنسيق اللحية وعلاجات العناية بالبشرة، سنساعدك في تحقيق المظهر المثالي الذي يعكس أسلوبك الشخصي.',
    // Portfolio
    portfolio: 'معرض الأعمال',
    portfolioImages: 'صور المعرض',
    clickToAddPortfolioImages: 'انقر لإضافة صور المعرض',
    upTo10PortfolioImages: 'حتى 10 صور معرض • اعرض أعمالك وخدماتك',
    removePortfolioImage: 'حذف صورة المعرض',
    portfolioPreview: 'معرض',
    tapToView: 'اضغط للعرض',
    youCanUploadUpTo10PortfolioImages: 'يمكنك رفع حتى 10 صور معرض.',
    // Weekdays
    sunday: 'الأحد',
    monday: 'الاثنين',
    tuesday: 'الثلاثاء',
    wednesday: 'الأربعاء',
    thursday: 'الخميس',
    friday: 'الجمعة',
    saturday: 'السبت',
    // Towns
    maadi: 'المعادي',
    masrElGedida: 'مصر الجديدة',
    heliopolis: 'مصر الجديدة',
    nasrCity: 'مدينة نصر',
    newCairo: 'القاهرة الجديدة',
    octoberCity: 'مدينة 6 أكتوبر',
    zamalek: 'الزمالك',
    mohandessin: 'المهندسين',
    dokki: 'الدقي',
    giza: 'الجيزة',
    // Service Categories
    hairNail: 'الشعر والأظافر',
    barber: 'الحلاقة',
    tattooPiercing: 'الوشم والثقب',
    laserClinics: 'عيادات الليزر',
    browsLashes: 'الحواجب والرموش',
    makeup: 'المكياج',
    massage: 'التدليك',
    petServices: 'خدمات الحيوانات الأليفة',
    // Common UI strings
    selectATown: 'اختر المدينة',
    selectACategory: 'اختر الفئة',
    selectAll: 'اختر الكل',
    uploadImages: 'رفع الصور',
    removeService: 'حذف الخدمة',
    addMoreServices: '+ إضافة المزيد من الخدمات',
    removeStaff: 'حذف الموظف',
    addStaff: '+ إضافة موظف',
    remove: 'حذف',
    addMore: '+ إضافة المزيد',
    uploadImage: 'رفع صورة',
    removeImage: 'حذف الصورة',
    // Admin Dashboard
    enterAdminEmail: 'أدخل بريد الإدارة الإلكتروني',
    enterPassword: 'أدخل كلمة المرور',
    confirm: 'تأكيد',
    cancel: 'إلغاء',
    // Recommended Services
    hairTrendsStylingGuide: 'دليل اتجاهات الشعر والتنسيق',
    mensGroomingMustacheStyles: 'عناية الرجال وأنماط الشوارب',
    tattooIdeasArtistGuide: 'أفكار الوشم ودليل الفنانين',
    hairRemovalSkincare: 'إزالة الشعر والعناية بالبشرة',
    browLashEnhancement: 'تحسين الحواجب والرموش',
    spaWellnessTreatments: 'علاجات السبا والعافية',
    professionalHairRemovalMethods: 'طرق إزالة الشعر المهنية والتقنيات',
    compareDifferentHairRemoval: 'قارن طرق إزالة الشعر المختلفة واختر التقنية الأكثر فعالية لنوع بشرتك ونمط حياتك',
    considerSkinSensitivity: 'ضع في اعتبارك حساسية بشرتك ونوع الشعر',
    factorPainTolerance: 'ضع في اعتبارك تحمل الألم ومتطلبات الصيانة',
    chooseMethodsFitBudget: 'اختر الطرق التي تناسب ميزانيتك ونمط حياتك',
    skinPreparationPreTreatment: 'تحضير البشرة والرعاية قبل العلاج',
    learnEssentialSkinPreparation: 'تعلم تقنيات تحضير البشرة الأساسية لتعظيم فعالية إزالة الشعر وتقليل الآثار الجانبية',
    exfoliateBeforeTreatment: 'قشّر البشرة قبل 24-48 ساعة من العلاج',
    avoidSunExposure: 'تجنب التعرض للشمس والتسمير',
    stopUsingRetinoids: 'توقف عن استخدام الريتينويدات والأحماض',
    postTreatmentCareHealing: 'الرعاية بعد العلاج وعملية الشفاء',
    masterAftercareRoutine: 'أتقن روتين الرعاية اللاحقة للشفاء الأمثل ونتائج إزالة الشعر طويلة الأمد',
    keepTreatedAreasCool: 'حافظ على المناطق المعالجة باردة ومرطبة',
    avoidSunExposureHeat: 'تجنب التعرض للشمس والحرارة',
    dontPickScratch: 'لا تلتقط أو تخدش المناطق المعالجة',
    commonIssuesTroubleshooting: 'دليل المشاكل الشائعة وحل المشاكل',
    learnIdentifyResolve: 'تعلم كيفية تحديد وحل الآثار الجانبية الشائعة لإزالة الشعر والمضاعفات',
    mostSideEffectsTemporary: 'معظم الآثار الجانبية مؤقتة وطبيعية',
    contactTechnicianPersistent: 'تواصل مع فنييك للمشاكل المستمرة',
    followAftercareInstructions: 'اتبع تعليمات الرعاية اللاحقة بعناية',
    // Hair Removal Content - Arabic
    recHairRemovalIntro: 'أتقن تقنيات إزالة الشعر المهنية وروتينات العناية بالبشرة للحصول على بشرة ناعمة وصحية. من علاجات الليزر إلى الشمع، اكتشف الطرق الخبيرة لإزالة الشعر الفعالة والرعاية الشاملة. سواء كنت جديدًا في إزالة الشعر المهنية أو تبحث عن تحسين روتينك، يغطي هذا الدليل كل شيء من اختيار الطريقة إلى حل المشاكل.',
    recHairRemovalMethodsIntro: 'تقدم إزالة الشعر المهنية طرقًا متنوعة، لكل منها فوائد واعتبارات فريدة. فهم الاختلافات يساعدك في اختيار التقنية الأكثر فعالية لنوع بشرتك وخصائص الشعر وتفضيلات نمط حياتك.',
    recHairRemovalMethodsTitle: 'طرق إزالة الشعر الشائعة',
    recHairRemovalLaserTitle: '1. إزالة الشعر بالليزر',
    recHairRemovalHowItWorks: 'كيف يعمل:',
    recHairRemovalLaserHow: 'يستخدم الضوء المركز لاستهداف بصيلات الشعر ومنع إعادة النمو.',
    recHairRemovalBestFor: 'الأفضل لـ:',
    recHairRemovalLaserBest: 'الشعر الداكن على البشرة الفاتحة، التقليل طويل الأمد',
    recHairRemovalDuration: 'المدة:',
    recHairRemovalLaserDuration: '6-8 جلسات للحصول على نتائج مثالية',
    recHairRemovalMaintenance: 'الصيانة:',
    recHairRemovalLaserMaintenance: 'جلسات لمسة عرضية',
    recHairRemovalWaxingTitle: '2. الشمع',
    recHairRemovalWaxingHow: 'يتم تطبيق الشمع الدافئ وإزالته مع الشعر من الجذر.',
    recHairRemovalWaxingBest: 'الشعر المتوسط إلى الخشن، نتائج ناعمة',
    recHairRemovalWaxingDuration: 'النتائج تدوم 3-6 أسابيع',
    recHairRemovalWaxingMaintenance: 'مواعيد منتظمة كل 4-6 أسابيع',
    recHairRemovalSugaringTitle: '3. السكر',
    recHairRemovalSugaringHow: 'معجون السكر الطبيعي يزيل الشعر في اتجاه النمو.',
    recHairRemovalSugaringBest: 'البشرة الحساسة، المكونات الطبيعية',
    recHairRemovalSugaringDuration: 'النتائج تدوم 3-5 أسابيع',
    recHairRemovalSugaringMaintenance: 'مواعيد منتظمة كل 4-5 أسابيع',
    recHairRemovalElectrolysisTitle: '4. التحليل الكهربائي',
    recHairRemovalElectrolysisHow: 'التيار الكهربائي يدمر بصيلات الشعر الفردية بشكل دائم.',
    recHairRemovalElectrolysisBest: 'المناطق الصغيرة، الإزالة الدائمة',
    recHairRemovalElectrolysisDuration: 'جلسات متعددة على مدى أشهر',
    recHairRemovalElectrolysisMaintenance: 'نتائج دائمة بمجرد اكتمالها',
    recHairRemovalSkinPrepIntro: 'تحضير البشرة المناسب أمر بالغ الأهمية لعلاجات إزالة الشعر الناجحة. اتباع إرشادات ما قبل العلاج يساعد في تقليل الآثار الجانبية وتحسين النتائج وضمان تجربة مريحة.',
    recHairRemovalPreTreatmentGuidelines: 'إرشادات ما قبل العلاج',
    recHairRemovalSkinPreparation: 'تحضير البشرة',
    recHairRemovalExfoliation: 'التقشير:',
    recHairRemovalExfoliationText: 'قشّر البشرة برفق قبل 24-48 ساعة من العلاج',
    recHairRemovalHydration: 'الترطيب:',
    recHairRemovalHydrationText: 'احتفظ ببشرة مرطبة جيدًا',
    recHairRemovalCleanSkin: 'البشرة النظيفة:',
    recHairRemovalCleanSkinText: 'احضر ببشرة نظيفة خالية من المنتجات',
    recHairRemovalHairLength: 'طول الشعر:',
    recHairRemovalHairLengthText: 'حافظ على طول الشعر المناسب للعلاج',
    recHairRemovalWhatToAvoid: 'ما يجب تجنبه',
    recHairRemovalSunExposure: 'التعرض للشمس:',
    recHairRemovalSunExposureText: 'تجنب حمامات الشمس وأسرة التسمير',
    recHairRemovalRetinoids: 'الريتينويدات:',
    recHairRemovalRetinoidsText: 'توقف عن استخدام منتجات الريتينول قبل أسبوع واحد',
    recHairRemovalAcids: 'الأحماض:',
    recHairRemovalAcidsText: 'تجنب الجليكوليك والساليسيليك والأحماض الأخرى',
    recHairRemovalMedications: 'الأدوية:',
    recHairRemovalMedicationsText: 'أبلغ الفني عن أي أدوية',
    recHairRemovalTreatmentDayPrep: 'تحضير يوم العلاج',
    recHairRemovalBeforeAppointment: 'قبل موعدك',
    recHairRemovalComfortableClothing: 'الملابس المريحة:',
    recHairRemovalComfortableClothingText: 'ارتدِ ملابس فضفاضة ومريحة',
    recHairRemovalHydrationDrink: 'الترطيب:',
    recHairRemovalHydrationDrinkText: 'اشرب الكثير من الماء',
    recHairRemovalPainManagement: 'إدارة الألم:',
    recHairRemovalPainManagementText: 'ضع في اعتبارك مسكنات الألم التي لا تستلزم وصفة طبية إذا لزم الأمر',
    recHairRemovalQuestions: 'الأسئلة:',
    recHairRemovalQuestionsText: 'جهز أي أسئلة حول العلاج',
    recHairRemovalAftercareIntro: 'الرعاية اللاحقة المناسبة ضرورية للشفاء الأمثل والنتائج طويلة الأمد. اتباع إرشادات ما بعد العلاج يساعد في منع المضاعفات ويضمن أن بشرتك تتعافى بسرعة وفعالية.',
    recHairRemovalImmediateAftercare: 'الرعاية اللاحقة الفورية',
    recHairRemovalFirst24Hours: 'أول 24 ساعة',
    recHairRemovalCooling: 'التبريد:',
    recHairRemovalCoolingText: 'طبق كمادات باردة لتقليل الاحمرار',
    recHairRemovalMoisturizing: 'الترطيب:',
    recHairRemovalMoisturizingText: 'استخدم مرطبًا لطيفًا خالياً من العطور',
    recHairRemovalAvoidHeat: 'تجنب الحرارة:',
    recHairRemovalAvoidHeatText: 'لا استحمام ساخن، ساونا، أو غرف بخار',
    recHairRemovalLooseClothing: 'الملابس الفضفاضة:',
    recHairRemovalLooseClothingText: 'ارتدِ أقمشة فضفاضة قابلة للتنفس',
    recHairRemovalFirstWeek: 'الأسبوع الأول',
    recHairRemovalGentleCleansing: 'التنظيف اللطيف:',
    recHairRemovalGentleCleansingText: 'استخدم منظفًا لطيفًا خالياً من العطور',
    recHairRemovalSunProtection: 'الحماية من الشمس:',
    recHairRemovalSunProtectionText: 'تجنب التعرض المباشر للشمس',
    recHairRemovalNoExfoliation: 'لا تقشير:',
    recHairRemovalNoExfoliationText: 'تجنب المقشرات ومنتجات التقشير',
    recHairRemovalHydrationKeep: 'الترطيب:',
    recHairRemovalHydrationKeepText: 'احتفظ ببشرة مرطبة جيدًا',
    recHairRemovalHealingTimeline: 'الجدول الزمني للشفاء',
    recHairRemovalWhatToExpect: 'ما يمكن توقعه',
    recHairRemovalDay12: 'اليوم 1-2:',
    recHairRemovalDay12Text: 'الاحمرار والتورم الطفيف والحساسية',
    recHairRemovalDay35: 'اليوم 3-5:',
    recHairRemovalDay35Text: 'ينحسر الاحمرار وتبدأ البشرة في العودة إلى طبيعتها',
    recHairRemovalWeek2: 'الأسبوع 2:',
    recHairRemovalWeek2Text: 'تعود البشرة إلى طبيعتها وتبدأ تساقط الشعر',
    recHairRemovalWeek34: 'الأسبوع 3-4:',
    recHairRemovalWeek34Text: 'تبدأ دورة نمو الشعر الجديدة',
    recHairRemovalTroubleshootingIntro: 'فهم الآثار الجانبية الشائعة ومعرفة كيفية معالجتها يساعد في ضمان عملية تعافي سلسة. معظم المشاكل مؤقتة ويمكن إدارتها بالرعاية والاهتمام المناسبين.',
    recHairRemovalCommonSideEffects: 'الآثار الجانبية الشائعة',
    recHairRemovalNormalReactions: 'ردود الفعل الطبيعية',
    recHairRemovalRedness: 'الاحمرار:',
    recHairRemovalRednessText: 'احمرار مؤقت يستمر 24-48 ساعة',
    recHairRemovalSwelling: 'التورم:',
    recHairRemovalSwellingText: 'تورم خفيف، خاصة في المناطق الحساسة',
    recHairRemovalTenderness: 'الحساسية:',
    recHairRemovalTendernessText: 'الحساسية للمس لمدة 1-3 أيام',
    recHairRemovalDryness: 'الجفاف:',
    recHairRemovalDrynessText: 'جفاف وتقشر مؤقت',
    recHairRemovalWhenToSeekHelp: 'متى تطلب المساعدة',
    recHairRemovalExcessiveRedness: 'الاحمرار المفرط:',
    recHairRemovalExcessiveRednessText: 'احمرار يزداد سوءاً أو ينتشر',
    recHairRemovalSevereSwelling: 'التورم الشديد:',
    recHairRemovalSevereSwellingText: 'تورم لا يتحسن',
    recHairRemovalSignsOfInfection: 'علامات العدوى:',
    recHairRemovalSignsOfInfectionText: 'صديد، ألم متزايد، حمى',
    recHairRemovalAllergicReactions: 'ردود الفعل التحسسية:',
    recHairRemovalAllergicReactionsText: 'طفح جلدي، شرى، صعوبة في التنفس',
    recHairRemovalPreventionTips: 'نصائح الوقاية',
    recHairRemovalAvoidingComplications: 'تجنب المضاعفات',
    recHairRemovalFollowInstructions: 'اتبع التعليمات:',
    recHairRemovalFollowInstructionsText: 'التزم بإرشادات ما قبل وبعد العلاج',
    recHairRemovalChooseQualifiedProviders: 'اختر مقدمي خدمات مؤهلين:',
    recHairRemovalChooseQualifiedProvidersText: 'اختر فنيين مرخصين وذوي خبرة',
    recHairRemovalCommunicateConcerns: 'تواصل المخاوف:',
    recHairRemovalCommunicateConcernsText: 'ناقش أي حالات صحية أو أدوية',
    recHairRemovalPatchTesting: 'اختبار التصحيح:',
    recHairRemovalPatchTestingText: 'اطلب اختبارات التصحيح للبشرة الحساسة',
    recHairRemovalFooter: 'لا تنتظر لتجربة فوائد إزالة الشعر المهنية! احجز استشارة مع أحد فنيينا الخبراء المتخصصين في علاجات إزالة الشعر الآمنة والفعالة. من علاج الليزر إلى الشمع والسكر، سنساعدك في اختيار الطريقة المثالية لنوع بشرتك وأهداف إزالة الشعر.',
    // Makeup & Brow Enhancement Content - Arabic
    completeMakeupBrowGuide: 'دليل المكياج وتحسين الحواجب الشامل 2024',
    professionalBeautyGuide: 'دليل الجمال المهني • محدث ديسمبر 2024',
    recMakeupIntro: 'أتقن فن تطبيق المكياج المهني وتحسين الحواجب من خلال دليلنا الشامل لتقنيات الجمال الحديثة. من الأساس المثالي إلى مظهر العيون الدرامي، اكتشف نصائح الخبراء لتحقيق نتائج بجودة الصالون في المنزل. سواء كنت جديدًا في المكياج المهني أو تبحث عن تحسين مهاراتك، يغطي هذا الدليل كل شيء من التقنيات الأساسية إلى الفن المتقدم.',
    professionalBrowShaping: 'تشكيل الحواجب المهني وإطار الوجه',
    masterBrowShapingTechniques: 'أتقن تقنيات تشكيل الحواجب وتعلم كيفية إنشاء القوس المثالي الذي يحيط بوجهك ويعزز جمالك الطبيعي',
    lashEnhancementDramaticEye: 'تحسين الرموش وتقنيات العيون الدرامية',
    discoverProfessionalLashTreatments: 'اكتشف علاجات الرموش المهنية وتعلم تقنيات إنشاء مظاهر درامية وجذابة تجعل عينيك تبرزان',
    professionalMakeupFoundation: 'أساس المكياج المهني ونظرية الألوان',
    buildSolidFoundationMakeup: 'ابني أساسًا قويًا في تطبيق المكياج ونظرية الألوان وتحضير البشرة للحصول على نتائج مثالية وطويلة الأمد',
    advancedEyeMakeupArtistry: 'تقنيات مكياج العيون المتقدمة والفن',
    masterAdvancedEyeMakeup: 'أتقن تقنيات مكياج العيون المتقدمة، من المظاهر اليومية الخفية إلى أنماط المساء الدرامية التي تعزز جمالك الطبيعي',
    recBrowShapingIntro: 'أتقن تقنيات تشكيل الحواجب وتعلم كيفية إنشاء القوس المثالي الذي يحيط بوجهك ويعزز جمالك الطبيعي. الحواجب المشكلة جيدًا هي أساس المظهر المصقول.',
    recBrowShapingContent1: 'الحواجب المشكلة جيدًا هي أساس المظهر المصقول، حيث تحيط بوجهك وتعزز جمالك الطبيعي. يمكن لتقنيات تشكيل الحواجب المهنية أن تحول مظهرك من خلال إنشاء القوس والسمك والشكل المثاليين لهيكل وجهك وأسلوبك الشخصي.',
    recBrowShapingContent2: 'تقنيات تشكيل الحواجب',
    recBrowShapingContent3: '1. الخيط',
    recBrowShapingContent4: 'كيف يعمل:',
    recBrowShapingContent5: 'يتم لف الخيط القطني ولفه على الجلد لإزالة الشعر من الجذر بدقة.',
    recBrowShapingContent6: 'الفوائد:',
    recBrowShapingContent7: 'تحكم دقيق، لا مواد كيميائية، مناسب للبشرة الحساسة',
    recBrowShapingContent8: 'المدة:',
    recBrowShapingContent9: 'النتائج تدوم 2-4 أسابيع',
    recBrowShapingContent10: '2. الشمع',
    recBrowShapingContent11: 'يتم تطبيق الشمع الدافئ وإزالته مع الشعر، سحب الشعر من الجذر.',
    recBrowShapingContent12: 'نتائج سريعة، مظهر ناعم، يدوم لفترة أطول',
    recBrowShapingContent13: 'النتائج تدوم 3-6 أسابيع',
    recBrowShapingContent14: 'أشكال الحواجب لأنواع الوجوه',
    recBrowShapingContent15: 'الوجه البيضاوي',
    recBrowShapingContent16: 'الشكل المثالي:',
    recBrowShapingContent17: 'حاجب ناعم منحني قليلاً بقوس لطيف',
    recBrowShapingContent18: 'التقنية:',
    recBrowShapingContent19: 'اتبع خط الحاجب الطبيعي، تجنب النتف المفرط',
    recBrowShapingContent20: 'الوجه المستدير',
    recBrowShapingContent21: 'قوس عالي مع ذيل مائل لإطالة الوجه',
    recBrowShapingContent22: 'أنشئ قوسًا أعلى، مدد الذيل قليلاً',
    recBrowShapingContent23: 'منتجات تنسيق الحواجب',
    recBrowShapingContent24: 'أقلام الحواجب',
    recBrowShapingContent25: 'الأفضل لـ:',
    recBrowShapingContent26: 'تحديد الشكل، ملء المناطق النادرة',
    recBrowShapingContent27: 'التطبيق:',
    recBrowShapingContent28: 'ضربات خفيفة في اتجاه نمو الشعر',
    recBrowShapingContent29: 'اختيار اللون:',
    recBrowShapingContent30: 'طابق لون الشعر أو اذهب إلى لون أفتح قليلاً',
    recBrowShapingContent31: 'جل الحواجب',
    recBrowShapingContent32: 'الحفاظ على الشكل، إضافة الحجم',
    recBrowShapingContent33: 'فرش من خلال الحواجب بحركة تصاعدية',
    recBrowShapingContent34: 'الأنواع:',
    recBrowShapingContent35: 'خيارات شفافة أو ملونة أو ملونة',
    recBrowShapingQuickTip1: 'اختر الخيط للتحكم الدقيق والبشرة الحساسة',
    recBrowShapingQuickTip2: 'ضع في اعتبارك شكل وجهك عند تحديد قوس الحاجب',
    recBrowShapingQuickTip3: 'استخدم أقلام الحواجب لتحديد الشكل وملء المناطق النادرة',
    recLashEnhancementIntro: 'اكتشف علاجات الرموش المهنية وتعلم تقنيات إنشاء مظاهر درامية وجذابة تجعل عينيك تبرزان. الرموش الجميلة يمكن أن تحول مظهرك بالكامل.',
    recLashEnhancementContent1: 'الرموش الجميلة يمكن أن تحول مظهرك بالكامل، مما يجعل عينيك تبدوان أكبر وأكثر تحديدًا وأكثر تعبيرًا. تقدم تقنيات تحسين الرموش المهنية خيارات متنوعة لتحقيق مظهر الرموش المثالي، من التحسين الطبيعي إلى الحجم الدرامي.',
    recLashEnhancementContent2: 'علاجات الرموش المهنية',
    recLashEnhancementContent3: '1. امتدادات الرموش',
    recLashEnhancementContent4: 'يتم ربط الرموش الاصطناعية الفردية بالرموش الطبيعية للطول والحجم.',
    recLashEnhancementContent5: 'نتائج طويلة الأمد، لا حاجة لماسكارا يومية',
    recLashEnhancementContent6: '3-4 أسابيع مع الرعاية المناسبة',
    recLashEnhancementContent7: '2. رفع الرموش',
    recLashEnhancementContent8: 'يتم تجعيد الرموش الطبيعية وصبغها لمظهر محسن.',
    recLashEnhancementContent9: 'مظهر طبيعي، صيانة منخفضة، طويل الأمد',
    recLashEnhancementContent10: '6-8 أسابيع',
    recLashEnhancementContent11: 'أنواع امتدادات الرموش',
    recLashEnhancementContent12: 'الامتدادات الكلاسيكية',
    recLashEnhancementContent13: 'الوصف:',
    recLashEnhancementContent14: 'امتداد واحد لكل رموش طبيعية لمظهر طبيعي',
    recLashEnhancementContent15: 'التحسين الطبيعي، الاستخدام اليومي',
    recLashEnhancementContent16: 'امتدادات الحجم',
    recLashEnhancementContent17: 'امتدادات متعددة لكل رموش طبيعية لحجم درامي',
    recLashEnhancementContent18: 'مظهر درامي، مناسبات خاصة',
    recLashEnhancementContent19: 'رعاية وصيانة الرموش',
    recLashEnhancementContent20: 'الرعاية اليومية',
    recLashEnhancementContent21: 'التنظيف اللطيف:',
    recLashEnhancementContent22: 'استخدم منظفًا خالياً من الزيت لإزالة المكياج',
    recLashEnhancementContent23: 'تجنب الفرك:',
    recLashEnhancementContent24: 'ربت بالجفاف بدلاً من الفرك',
    recLashEnhancementContent25: 'فرش الرموش:',
    recLashEnhancementContent26: 'استخدم عصا الماسكارا النظيفة لفرش الرموش',
    recLashEnhancementContent27: 'تجنب المنتجات القائمة على الزيت:',
    recLashEnhancementContent28: 'يمكن أن تسبب سقوط الامتدادات',
    recLashEnhancementQuickTip1: 'اختر الامتدادات الكلاسيكية للتحسين الطبيعي',
    recLashEnhancementQuickTip2: 'استخدم منظفًا خالياً من الزيت للحفاظ على امتدادات الرموش',
    recLashEnhancementQuickTip3: 'ضع في اعتبارك رفع الرموش للنتائج منخفضة الصيانة',
    recMakeupFoundationIntro: 'ابني أساسًا قويًا في تطبيق المكياج ونظرية الألوان وتحضير البشرة للحصول على نتائج مثالية وطويلة الأمد. يبدأ المكياج المهني بفهم هذه المبادئ الأساسية.',
    recMakeupFoundationContent1: 'يبدأ تطبيق المكياج المهني بفهم نظرية الألوان وتحضير البشرة واختيار المنتج المناسب. هذه التقنيات الأساسية تخلق اللوحة المثالية لأي مظهر مكياج، مما يضمن نتائج طويلة الأمد ومثالية تعزز جمالك الطبيعي.',
    recMakeupFoundationContent2: 'نظرية الألوان للمكياج',
    recMakeupFoundationContent3: 'درجات لون البشرة',
    recMakeupFoundationContent4: 'الدرجات الباردة:',
    recMakeupFoundationContent5: 'درجات وردية أو حمراء أو زرقاء في البشرة',
    recMakeupFoundationContent6: 'الدرجات الدافئة:',
    recMakeupFoundationContent7: 'درجات صفراء أو ذهبية أو خوخية في البشرة',
    recMakeupFoundationContent8: 'الدرجات المحايدة:',
    recMakeupFoundationContent9: 'مزيج من الدرجات الباردة والدافئة',
    recMakeupFoundationContent10: 'اختيار الأساس',
    recMakeupFoundationContent11: 'أنواع الأساس',
    recMakeupFoundationContent12: 'أساس سائل:',
    recMakeupFoundationContent13: 'تغطية متعددة الاستخدامات وقابلة للبناء',
    recMakeupFoundationContent14: 'أساس كريمي:',
    recMakeupFoundationContent15: 'تغطية كاملة، جيد للبشرة الجافة',
    recMakeupFoundationContent16: 'أساس بودرة:',
    recMakeupFoundationContent17: 'تغطية خفيفة، جيد للبشرة الدهنية',
    recMakeupFoundationContent18: 'أساس عصا:',
    recMakeupFoundationContent19: 'تغطية مريحة وقابلة للبناء',
    recMakeupFoundationContent20: 'تقنيات التطبيق',
    recMakeupFoundationContent21: 'تطبيق الفرشاة:',
    recMakeupFoundationContent22: 'استخدم فرشاة الأساس لتغطية متساوية',
    recMakeupFoundationContent23: 'تطبيق الإسفنجة:',
    recMakeupFoundationContent24: 'استخدم إسفنجة الجمال للدمج السلس',
    recMakeupFoundationContent25: 'تطبيق الأصابع:',
    recMakeupFoundationContent26: 'استخدم الأصابع للتطبيق الطبيعي والدافئ',
    recMakeupFoundationContent27: 'تقنية الطبقات:',
    recMakeupFoundationContent28: 'ابني التغطية تدريجيًا لمظهر طبيعي',
    recMakeupFoundationContent29: 'تقنيات الكونسيلر',
    recMakeupFoundationContent30: 'تصحيح اللون',
    recMakeupFoundationContent31: 'كونسيلر أخضر:',
    recMakeupFoundationContent32: 'يعادل الاحمرار',
    recMakeupFoundationContent33: 'كونسيلر خوخي/برتقالي:',
    recMakeupFoundationContent34: 'يعادل الهالات السوداء',
    recMakeupFoundationContent35: 'كونسيلر أصفر:',
    recMakeupFoundationContent36: 'يضيء ويصحح الدرجات البنفسجية',
    recMakeupFoundationContent37: 'كونسيلر بنفسجي:',
    recMakeupFoundationContent38: 'يعادل الدرجات الصفراء',
    recMakeupFoundationQuickTip1: 'حدد درجات لون بشرتك لمطابقة الأساس المثالية',
    recMakeupFoundationQuickTip2: 'استخدم تصحيح اللون لمعادلة الدرجات غير المرغوب فيها',
    recMakeupFoundationQuickTip3: 'ابني التغطية تدريجيًا للحصول على نتائج طبيعية المظهر',
    recEyeMakeupIntro: 'أتقن تقنيات مكياج العيون المتقدمة، من المظاهر اليومية الخفية إلى أنماط المساء الدرامية التي تعزز جمالك الطبيعي. مكياج العيون هو نقطة التركيز في العديد من المظاهر.',
    recEyeMakeupContent1: 'مكياج العيون هو نقطة التركيز في العديد من المظاهر، ويتطلب مهارة وإبداعًا وفهمًا لأشكال العيون ونظرية الألوان. من المظاهر اليومية الخفية إلى أنماط المساء الدرامية، إتقان تقنيات مكياج العيون يسمح لك بإنشاء تنويعات لا حصر لها تعزز جمالك الطبيعي.',
    recEyeMakeupContent2: 'تحليل شكل العين',
    recEyeMakeupContent3: 'أشكال العيون الشائعة',
    recEyeMakeupContent4: 'عيون لوزية:',
    recEyeMakeupContent5: 'متوازنة، مدببة قليلاً عند الزوايا الخارجية',
    recEyeMakeupContent6: 'عيون مستديرة:',
    recEyeMakeupContent7: 'شكل دائري، عرض وارتفاع متساويان',
    recEyeMakeupContent8: 'عيون مغطاة:',
    recEyeMakeupContent9: 'طية الجفن مخفية عندما تكون العيون مفتوحة',
    recEyeMakeupContent10: 'عيون أحادية الجفن:',
    recEyeMakeupContent11: 'لا توجد طية مرئية في الجفن',
    recEyeMakeupContent12: 'تقنيات ظلال العيون',
    recEyeMakeupContent13: 'التطبيق الأساسي',
    recEyeMakeupContent14: 'لون القاعدة:',
    recEyeMakeupContent15: 'طبق لونًا فاتحًا على كامل الجفن',
    recEyeMakeupContent16: 'لون الطية:',
    recEyeMakeupContent17: 'طبق لونًا متوسطًا في الطية',
    recEyeMakeupContent18: 'لون الجفن:',
    recEyeMakeupContent19: 'طبق اللون الرئيسي على الجفن',
    recEyeMakeupContent20: 'الإبراز:',
    recEyeMakeupContent21: 'طبق لونًا فاتحًا على عظمة الحاجب',
    recEyeMakeupContent22: 'التقنيات المتقدمة',
    recEyeMakeupContent23: 'قطع الطية:',
    recEyeMakeupContent24: 'خط حاد بين الجفن والطية',
    recEyeMakeupContent25: 'عيون مدخنة:',
    recEyeMakeupContent26: 'تأثير متدرج ومدمج',
    recEyeMakeupContent27: 'عيون هالة:',
    recEyeMakeupContent28: 'مركز فاتح مع حواف خارجية أغمق',
    recEyeMakeupContent29: 'عيون مجنحة:',
    recEyeMakeupContent30: 'كحل ممتد لتأثير درامي',
    recEyeMakeupContent31: 'تقنيات الكحل',
    recEyeMakeupContent32: 'أنواع الكحل',
    recEyeMakeupContent33: 'كحل قلم:',
    recEyeMakeupContent34: 'سهل الاستخدام، جيد للمبتدئين',
    recEyeMakeupContent35: 'كحل سائل:',
    recEyeMakeupContent36: 'دقيق، طويل الأمد',
    recEyeMakeupContent37: 'كحل جل:',
    recEyeMakeupContent38: 'متعدد الاستخدامات، يمكن استخدامه بالفرشاة',
    recEyeMakeupContent39: 'كحل قلم:',
    recEyeMakeupContent40: 'تطبيق مريح ودقيق',
    recEyeMakeupContent41: 'تطبيق الماسكارا',
    recEyeMakeupContent42: 'تقنيات التطبيق',
    recEyeMakeupContent43: 'تقنية التذبذب:',
    recEyeMakeupContent44: 'أذب العصا من الجذور إلى الأطراف',
    recEyeMakeupContent45: 'تقنية متعرجة:',
    recEyeMakeupContent46: 'حرك العصا بحركة متعرجة',
    recEyeMakeupContent47: 'تقنية الطبقات:',
    recEyeMakeupContent48: 'طبق طبقات متعددة للحجم',
    recEyeMakeupContent49: 'الرموش السفلية:',
    recEyeMakeupContent50: 'استخدم لمسة أخف للرموش السفلية',
    recEyeMakeupQuickTip1: 'حلل شكل عينيك قبل اختيار التقنيات',
    recEyeMakeupQuickTip2: 'ابدأ بالتطبيق الأساسي وابني التعقيد',
    recEyeMakeupQuickTip3: 'استخدم تقنية التذبذب لتطبيق الماسكارا',
    readyMasterProfessionalMakeup: 'مستعد لإتقان المكياج المهني؟',
    dontWaitLearnMakeup: 'لا تنتظر لتعلم تقنيات المكياج المهنية هذه! احجز استشارة مع أحد فناني المكياج الخبراء لدينا المتخصصين في تشكيل الحواجب وتحسين الرموش وتطبيق المكياج المهني. من المظاهر اليومية إلى مكياج المناسبات الخاصة، سنساعدك في تحقيق المظهر المثالي الذي يعزز جمالك الطبيعي ويزيد ثقتك.',
    bookMakeupService: 'احجز خدمة المكياج',
    bookBrowService: 'احجز خدمة الحواجب',
    // Spa & Wellness Content - Arabic
    completeSpaWellnessGuide: 'دليل السبا والعافية الشامل 2024',
    professionalWellnessGuide: 'دليل العافية المهني • محدث ديسمبر 2024',
    recSpaIntro: 'اكتشف القوة التحويلية لعلاجات السبا المهنية وعلاجات العافية. من التدليك العلاجي إلى العلاجات الجمالية المتقدمة، يغطي هذا الدليل الشامل كل ما تحتاج معرفته حول الاسترخاء والتجديد والعافية الشاملة. سواء كنت تبحث عن تخفيف التوتر أو تجديد البشرة أو العافية العامة، يوفر هذا الدليل رؤى الخبراء حول أحدث العلاجات والتقنيات.',
    professionalMassageTherapy: 'العلاج بالتدليك المهني وتقنيات الشفاء',
    discoverTherapeuticMassageTypes: 'اكتشف أنواع التدليك العلاجي وتعلم كيفية اختيار العلاج المناسب للاسترخاء وتخفيف الألم والعافية العامة',
    advancedAestheticMedicine: 'الطب الجمالي المتقدم وتجديد البشرة',
    exploreCuttingEdgeAesthetic: 'استكشف العلاجات الجمالية المتطورة وتعلم عن الحلول غير الغازية إلى الحد الأدنى من الغزو للبشرة الشابة والصحية',
    holisticWellnessTherapies: 'علاجات العافية الشاملة والشفاء الجسدي والعقلي',
    discoverHolisticTreatmentModalities: 'اكتشف طرق العلاج الشاملة التي تعالج الرفاهية الجسدية والعقلية والعاطفية للعافية الكاملة',
    completeSpaExperience: 'دليل تجربة السبا الكاملة ورحلة العافية',
    learnMaximizeSpaExperience: 'تعلم كيفية تعظيم تجربة السبا والحصول على أقصى قيمة من استثمارك في العافية',
    recMassageIntro: 'اكتشف أنواع التدليك العلاجي وتعلم كيفية اختيار العلاج المناسب للاسترخاء وتخفيف الألم والعافية العامة. يقدم العلاج بالتدليك المهني فوائد عديدة للرفاهية الجسدية والعقلية.',
    recMassageContent1: 'يقدم العلاج بالتدليك المهني فوائد عديدة للرفاهية الجسدية والعقلية. من العمل على الأنسجة العميقة إلى تقنيات الاسترخاء اللطيفة، تعالج أنماط التدليك المختلفة احتياجات وحالات متنوعة. فهم الأنواع المختلفة يساعدك في اختيار العلاج الأكثر فعالية لأهدافك المحددة.',
    recMassageContent2: 'أنواع التدليك الشائعة',
    recMassageContent3: '1. التدليك السويدي',
    recMassageContent4: 'الوصف:',
    recMassageContent5: 'تدليك استرخاء كلاسيكي يستخدم ضربات طويلة وعجن وحركات دائرية.',
    recMassageContent6: 'الفوائد:',
    recMassageContent7: 'تخفيف التوتر، تحسين الدورة الدموية، استرخاء العضلات',
    recMassageContent8: 'الأفضل لـ:',
    recMassageContent9: 'المبتدئين، تخفيف التوتر، الاسترخاء العام',
    recMassageContent10: 'المدة:',
    recMassageContent11: '60-90 دقيقة',
    recMassageContent12: '2. تدليك الأنسجة العميقة',
    recMassageContent13: 'تدليك مكثف يستهدف طبقات العضلات الأعمق والنسيج الضام.',
    recMassageContent14: 'تخفيف الألم، تحسين الحركة، تخفيف التوتر المزمن',
    recMassageContent15: 'الألم المزمن، توتر العضلات، الرياضيون',
    recMassageContent16: '3. تدليك الحجارة الساخنة',
    recMassageContent17: 'يتم وضع حجارة ساخنة على الجسم واستخدامها في ضربات التدليك.',
    recMassageContent18: 'استرخاء عميق، تحسين الدورة الدموية، تخفيف التوتر',
    recMassageContent19: 'تخفيف التوتر، توتر العضلات، الاسترخاء',
    recMassageContent20: '75-90 دقيقة',
    recMassageContent21: '4. تدليك رياضي',
    recMassageContent22: 'تدليك متخصص للرياضيين والأفراد النشطين.',
    recMassageContent23: 'منع الإصابات، تحسين الأداء، التعافي الأسرع',
    recMassageContent24: 'الرياضيون، الأفراد النشطون، منع الإصابات',
    recMassageContent25: 'تقنيات التدليك المتخصصة',
    recMassageContent26: 'علاج نقاط الزناد',
    recMassageContent27: 'يركز على نقاط الزناد المحددة لتخفيف الألم.',
    recMassageContent28: 'تخفيف الألم المستهدف، تحسين الوظيفة',
    recMassageContent29: 'الألم المزمن، عقد العضلات، صداع التوتر',
    recMassageContent30: 'إطلاق اللفافة العضلية',
    recMassageContent31: 'تقنية لطيفة تستهدف اللفافة (النسيج الضام).',
    recMassageContent32: 'تحسين المرونة، تخفيف الألم، وضعية أفضل',
    recMassageContent33: 'الألم المزمن، الحركة المحدودة، مشاكل الوضعية',
    recMassageContent34: 'فوائد التدليك',
    recMassageContent35: 'الفوائد الجسدية',
    recMassageContent36: 'تخفيف الألم:',
    recMassageContent37: 'يقلل توتر العضلات والألم المزمن',
    recMassageContent38: 'تحسين الدورة الدموية:',
    recMassageContent39: 'يعزز تدفق الدم والتصريف اللمفاوي',
    recMassageContent40: 'نوم أفضل:',
    recMassageContent41: 'يعزز الاسترخاء وجودة النوم الأفضل',
    recMassageContent42: 'مرونة محسنة:',
    recMassageContent43: 'يحسن نطاق الحركة والمرونة',
    recMassageContent44: 'دعم المناعة:',
    recMassageContent45: 'يعزز وظيفة الجهاز المناعي',
    recMassageContent46: 'الفوائد العقلية',
    recMassageContent47: 'تقليل التوتر:',
    recMassageContent48: 'يخفض مستويات الكورتيزول والتوتر',
    recMassageContent49: 'تحسين المزاج:',
    recMassageContent50: 'يزيد الإندورفين والسيروتونين',
    recMassageContent51: 'وضوح عقلي:',
    recMassageContent52: 'يحسن التركيز والوضوح العقلي',
    recMassageContent53: 'إطلاق عاطفي:',
    recMassageContent54: 'يساعد في معالجة المشاعر والصدمات',
    recMassageContent55: 'الاسترخاء:',
    recMassageContent56: 'يعزز الاسترخاء العميق والهدوء',
    recMassageQuickTip1: 'ابدأ بالتدليك السويدي للاسترخاء وتخفيف التوتر',
    recMassageQuickTip2: 'اختر الأنسجة العميقة للألم المزمن وتوتر العضلات',
    recMassageQuickTip3: 'تواصل بصراحة مع معالجك حول الضغط والراحة',
    recAestheticIntro: 'استكشف العلاجات الجمالية المتطورة وتعلم عن الحلول غير الغازية إلى الحد الأدنى من الغزو للبشرة الشابة والصحية. يجمع الطب الجمالي الخبرة الطبية مع العلاجات التجميلية.',
    recAestheticContent1: 'يجمع الطب الجمالي الخبرة الطبية مع العلاجات التجميلية لمعالجة مخاوف البشرة المختلفة وعلامات الشيخوخة. تقدم هذه العلاجات المتقدمة حلولاً غير غازية إلى الحد الأدنى من الغزو لتحقيق بشرة شابة وصحية المظهر مع وقت تعافي ضئيل ونتائج طويلة الأمد.',
    recAestheticContent2: 'العلاجات الجمالية الشائعة',
    recAestheticContent3: '1. حقن البوتوكس',
    recAestheticContent4: 'حقن السموم العصبية التي ترخي عضلات الوجه مؤقتًا.',
    recAestheticContent5: 'يقلل التجاعيد، يمنع الخطوط الجديدة، ينعم خطوط التعبير',
    recAestheticContent6: 'المناطق المعالجة:',
    recAestheticContent7: 'الجبهة، خطوط العين، خطوط العبوس',
    recAestheticContent8: 'النتائج تدوم 3-6 أشهر',
    recAestheticContent9: '2. حشوات الجلد',
    recAestheticContent10: 'مواد هلامية قابلة للحقن تعيد الحجم وتنعم التجاعيد.',
    recAestheticContent11: 'يعيد الحجم، ينعم التجاعيد، يعزز محيطات الوجه',
    recAestheticContent12: 'الشفاه، الخدود، طيات الأنف، تحت العينين',
    recAestheticContent13: 'النتائج تدوم 6-18 شهرًا حسب النوع',
    recAestheticContent14: '3. التقشير الكيميائي',
    recAestheticContent15: 'محاليل كيميائية تزيل طبقات الجلد التالفة.',
    recAestheticContent16: 'يحسن الملمس، يقلل الخطوط الدقيقة، يوحد لون البشرة',
    recAestheticContent17: 'الأنواع:',
    recAestheticContent18: 'تقشير خفيف ومتوسط وعميق',
    recAestheticContent19: 'وقت التعافي:',
    recAestheticContent20: 'يختلف من لا شيء إلى عدة أيام',
    recAestheticContent21: '4. علاجات الليزر',
    recAestheticContent22: 'تقنية الليزر لمخاوف البشرة المختلفة.',
    recAestheticContent23: 'تجديد البشرة، إزالة الشعر، علاج التصبغ',
    recAestheticContent24: 'الليزر الجزئي، IPL، إزالة الشعر بالليزر',
    recAestheticContent25: 'النتائج:',
    recAestheticContent26: 'تحسن تدريجي على جلسات متعددة',
    recAestheticContent27: 'علاجات البشرة المتقدمة',
    recAestheticContent28: 'الديرما رولر',
    recAestheticContent29: 'ينشئ إصابات دقيقة لتحفيز إنتاج الكولاجين.',
    recAestheticContent30: 'يحسن الملمس، يقلل الندوب، يشد البشرة',
    recAestheticContent31: 'احمرار خفيف لمدة 24-48 ساعة',
    recAestheticContent32: 'علاجات الترددات الراديوية',
    recAestheticContent33: 'يستخدم طاقة الترددات الراديوية لتسخين وشد البشرة.',
    recAestheticContent34: 'شد البشرة، تقليل التجاعيد، نحت الجسم',
    recAestheticContent35: 'ضئيل، احمرار طفيف',
    recAestheticContent36: 'علاج الموجات فوق الصوتية',
    recAestheticContent37: 'يستخدم طاقة الموجات فوق الصوتية لرفع وشد البشرة.',
    recAestheticContent38: 'رفع غير غازي، شد البشرة، نتائج طبيعية',
    recAestheticContent39: 'ضئيل، لا وقت تعافي',
    recAestheticContent40: 'تخطيط العلاج',
    recAestheticContent41: 'عملية الاستشارة',
    recAestheticContent42: 'تقييم البشرة:',
    recAestheticContent43: 'قيم حالة البشرة والمخاوف',
    recAestheticContent44: 'تحديد الأهداف:',
    recAestheticContent45: 'ناقش النتائج المرغوبة والتوقعات',
    recAestheticContent46: 'خطة العلاج:',
    recAestheticContent47: 'طور بروتوكول علاج مخصص',
    recAestheticContent48: 'الجدول الزمني:',
    recAestheticContent49: 'أنشئ جدول العلاج والصيانة',
    recAestheticContent50: 'العلاجات المركبة',
    recAestheticContent51: 'نهج متعدد الوسائط:',
    recAestheticContent52: 'اجمع علاجات مختلفة للحصول على نتائج مثالية',
    recAestheticContent53: 'علاجات متدرجة:',
    recAestheticContent54: 'افصل العلاجات بشكل مناسب',
    recAestheticContent55: 'جدول الصيانة:',
    recAestheticContent56: 'خطط للعلاجات المستمرة للنتائج المستدامة',
    recAestheticContent57: 'الرعاية المنزلية:',
    recAestheticContent58: 'دمج العلاجات المهنية مع الرعاية المنزلية',
    recAestheticQuickTip1: 'جدول الاستشارات لمناقشة خيارات العلاج والتوقعات',
    recAestheticQuickTip2: 'ضع في اعتبارك العلاجات المركبة للحصول على نتائج مثالية',
    recAestheticQuickTip3: 'خطط للعلاجات حول جدولك وتحمل وقت التعافي',
    recWellnessIntro: 'اكتشف طرق العلاج الشاملة التي تعالج الرفاهية الجسدية والعقلية والعاطفية للعافية الكاملة. تجمع هذه الأساليب الحكمة القديمة مع التقنيات الحديثة.',
    recWellnessContent1: 'تركز علاجات العافية على معالجة الشخص بالكامل، معالجة الرفاهية الجسدية والعقلية والعاطفية. تجمع هذه الأساليب الشاملة الحكمة القديمة مع التقنيات الحديثة لتعزيز التوازن والشفاء والعافية العامة. من العلاج بالعطور إلى التأمل، تدعم هذه العلاجات رحلتك نحو الصحة المثلى.',
    recWellnessContent2: 'طرق العلاج الشاملة',
    recWellnessContent3: '1. العلاج بالعطور',
    recWellnessContent4: 'يستخدم الزيوت الأساسية لتعزيز الرفاهية الجسدية والعاطفية.',
    recWellnessContent5: 'تخفيف التوتر، تحسين المزاج، الاسترخاء',
    recWellnessContent6: 'التطبيقات:',
    recWellnessContent7: 'التدليك، الاستنشاق، الحمامات، المبخرات',
    recWellnessContent8: 'الزيوت الشائعة:',
    recWellnessContent9: 'اللافندر، الأوكالبتوس، النعناع، البابونج',
    recWellnessContent10: '2. العلاج الانعكاسي',
    recWellnessContent11: 'يطبق الضغط على نقاط محددة على القدمين واليدين والأذنين.',
    recWellnessContent12: 'تخفيف التوتر، تحسين الدورة الدموية، تقليل الألم',
    recWellnessContent13: 'التقنية:',
    recWellnessContent14: 'ضغط مستهدف على نقاط الانعكاس',
    recWellnessContent15: '30-60 دقيقة',
    recWellnessContent16: '3. الريكي',
    recWellnessContent17: 'تقنية شفاء بالطاقة تعزز الاسترخاء والشفاء.',
    recWellnessContent18: 'تقليل التوتر، الشفاء العاطفي، توازن الطاقة',
    recWellnessContent19: 'لمسة خفيفة أو يدين تحومان فوق الجسم',
    recWellnessContent20: 'التجربة:',
    recWellnessContent21: 'استرخاء عميق، دفء، إحساس بالوخز',
    recWellnessContent22: '4. التأمل والوعي',
    recWellnessContent23: 'ممارسات التأمل الموجه والوعي للرفاهية العقلية.',
    recWellnessContent24: 'تقليل التوتر، تحسين التركيز، التوازن العاطفي',
    recWellnessContent25: 'التقنيات:',
    recWellnessContent26: 'تمارين التنفس، التصور، مسح الجسم',
    recWellnessContent27: '15-60 دقيقة',
    recWellnessContent28: 'علاجات الجسم',
    recWellnessContent29: 'العلاج القحفي العجزي',
    recWellnessContent30: 'علاج باللمس اللطيف يركز على النظام القحفي العجزي.',
    recWellnessContent31: 'تخفيف التوتر، تقليل الألم، تحسين الوظيفة',
    recWellnessContent32: 'الصداع، التوتر، التعافي من الصدمات',
    recWellnessContent33: 'التصريف اللمفاوي',
    recWellnessContent34: 'تقنية تدليك لطيفة لتحفيز تدفق اللمف.',
    recWellnessContent35: 'يقلل التورم، يعزز المناعة، إزالة السموم',
    recWellnessContent36: 'بعد الجراحة، التورم المزمن، دعم المناعة',
    recWellnessContent37: 'فوائد العافية',
    recWellnessContent38: 'الفوائد الجسدية',
    recWellnessContent39: 'تقليل التوتر:',
    recWellnessContent40: 'يخفض الكورتيزول وهرمونات التوتر',
    recWellnessContent41: 'نوم محسن:',
    recWellnessContent42: 'يعزز جودة النوم ومدته الأفضل',
    recWellnessContent43: 'تخفيف الألم:',
    recWellnessContent44: 'يقلل الألم المزمن والتوتر',
    recWellnessContent45: 'مناعة محسنة:',
    recWellnessContent46: 'يعزز وظيفة الجهاز المناعي',
    recWellnessContent47: 'دورة دموية أفضل:',
    recWellnessContent48: 'يحسن تدفق الدم واللمف',
    recWellnessContent49: 'الفوائد العقلية والعاطفية',
    recWellnessContent50: 'وضوح عقلي:',
    recWellnessContent51: 'يحسن التركيز والوظيفة المعرفية',
    recWellnessContent52: 'توازن عاطفي:',
    recWellnessContent53: 'يساعد في تنظيم المشاعر والمزاج',
    recWellnessContent54: 'تقليل القلق:',
    recWellnessContent55: 'يقلل القلق والقلق',
    recWellnessContent56: 'دعم الاكتئاب:',
    recWellnessContent57: 'يساعد في إدارة أعراض الاكتئاب',
    recWellnessContent58: 'الوعي الذاتي:',
    recWellnessContent59: 'يزيد الوعي والوعي الذاتي',
    recWellnessQuickTip1: 'جرب العلاج بالعطور لتخفيف التوتر وتحسين المزاج',
    recWellnessQuickTip2: 'ضع في اعتبارك العلاج الانعكاسي لتحسين الدورة الدموية وتقليل الألم',
    recWellnessQuickTip3: 'مارس التأمل والوعي للرفاهية العقلية',
    recSpaExperienceIntro: 'تعلم كيفية تعظيم تجربة السبا والحصول على أقصى قيمة من استثمارك في العافية. زيارة السبا هي أكثر من مجرد علاج—إنها تجربة عافية كاملة.',
    recSpaExperienceContent1: 'زيارة السبا هي أكثر من مجرد علاج—إنها تجربة عافية كاملة مصممة لتجديد عقلك وجسدك وروحك. فهم كيفية التحضير والاستفادة القصوى من تجربة السبا الخاصة بك يضمن أنك تتلقى أقصى فوائد ومتعة من استثمارك في العافية.',
    recSpaExperienceContent2: 'التحضير قبل السبا',
    recSpaExperienceContent3: 'قبل زيارتك',
    recSpaExperienceContent4: 'الترطيب:',
    recSpaExperienceContent5: 'اشرب الكثير من الماء قبل موعدك',
    recSpaExperienceContent6: 'وجبات خفيفة:',
    recSpaExperienceContent7: 'تناول طعامًا خفيفًا لتجنب الانزعاج أثناء العلاجات',
    recSpaExperienceContent8: 'احضر مبكرًا:',
    recSpaExperienceContent9: 'اسمح بالوقت للاسترخاء والتحضير عقليًا',
    recSpaExperienceContent10: 'تواصل الاحتياجات:',
    recSpaExperienceContent11: 'أبلغ الموظفين عن أي حالات صحية أو تفضيلات',
    recSpaExperienceContent12: 'ارتدِ ملابس مريحة:',
    recSpaExperienceContent13: 'ارتدِ ملابس فضفاضة ومريحة',
    recSpaExperienceContent14: 'ما يجب إحضاره',
    recSpaExperienceContent15: 'الهوية:',
    recSpaExperienceContent16: 'أحضر الهوية وأي وثائق ضرورية',
    recSpaExperienceContent17: 'عناصر الراحة:',
    recSpaExperienceContent18: 'أحضر العناصر الشخصية التي تعزز الاسترخاء',
    recSpaExperienceContent19: 'الأسئلة:',
    recSpaExperienceContent20: 'جهز أسئلة حول العلاجات والرعاية اللاحقة',
    recSpaExperienceContent21: 'عقل منفتح:',
    recSpaExperienceContent22: 'كن منفتحًا لتجربة علاجات وتجارب جديدة',
    recSpaExperienceContent23: 'أثناء زيارتك للسبا',
    recSpaExperienceContent24: 'مناطق الاسترخاء',
    recSpaExperienceContent25: 'مناطق الاستراحة:',
    recSpaExperienceContent26: 'خذ الوقت للاسترخاء قبل وبعد العلاجات',
    recSpaExperienceContent27: 'الساونا والبخار:',
    recSpaExperienceContent28: 'استخدم العلاج بالحرارة للحصول على فوائد إضافية',
    recSpaExperienceContent29: 'مساحات هادئة:',
    recSpaExperienceContent30: 'ابحث عن مناطق هادئة للتأمل أو القراءة',
    recSpaExperienceContent31: 'المشروبات:',
    recSpaExperienceContent32: 'استمتع بالوجبات الخفيفة والمشروبات الصحية',
    recSpaExperienceContent33: 'آداب العلاج',
    recSpaExperienceContent34: 'التواصل:',
    recSpaExperienceContent35: 'تواصل بصراحة مع معالجك',
    recSpaExperienceContent36: 'التغذية الراجعة:',
    recSpaExperienceContent37: 'قدم تغذية راجعة حول الضغط والراحة',
    recSpaExperienceContent38: 'الاسترخاء:',
    recSpaExperienceContent39: 'ركز على الاسترخاء والترك',
    recSpaExperienceContent40: 'الحضور:',
    recSpaExperienceContent41: 'كن حاضرًا وواعيًا أثناء العلاجات',
    recSpaExperienceContent42: 'الرعاية بعد العلاج',
    recSpaExperienceContent43: 'الرعاية الفورية',
    recSpaExperienceContent44: 'اشرب الكثير من الماء لطرد السموم',
    recSpaExperienceContent45: 'الراحة:',
    recSpaExperienceContent46: 'اسمح بالوقت للراحة ودمج العلاج',
    recSpaExperienceContent47: 'حركة لطيفة:',
    recSpaExperienceContent48: 'انخرط في حركة خفيفة ولطيفة',
    recSpaExperienceContent49: 'وجبات صحية:',
    recSpaExperienceContent50: 'تناول وجبات مغذية وخفيفة',
    recSpaExperienceContent51: 'الفوائد طويلة الأمد',
    recSpaExperienceContent52: 'الزيارات المنتظمة:',
    recSpaExperienceContent53: 'جدول علاجات منتظمة للفوائد المستمرة',
    recSpaExperienceContent54: 'الرعاية المنزلية:',
    recSpaExperienceContent55: 'دمج ممارسات الرعاية المنزلية الموصى بها',
    recSpaExperienceContent56: 'تغييرات نمط الحياة:',
    recSpaExperienceContent57: 'اعتمد عادات نمط حياة صحية',
    recSpaExperienceContent58: 'إدارة التوتر:',
    recSpaExperienceContent59: 'مارس تقنيات تقليل التوتر',
    recSpaExperienceContent60: 'اختيار السبا المناسب',
    recSpaExperienceContent61: 'عوامل البحث',
    recSpaExperienceContent62: 'السمعة:',
    recSpaExperienceContent63: 'اقرأ المراجعات واسأل عن التوصيات',
    recSpaExperienceContent64: 'الخدمات:',
    recSpaExperienceContent65: 'تأكد من أنها تقدم العلاجات التي تهتم بها',
    recSpaExperienceContent66: 'مؤهلات الموظفين:',
    recSpaExperienceContent67: 'تحقق من تدريب المعالجين والشهادات',
    recSpaExperienceContent68: 'جودة المنشأة:',
    recSpaExperienceContent69: 'زر لتقييم النظافة والجو',
    recSpaExperienceContent70: 'التسعير:',
    recSpaExperienceContent71: 'افهم التكاليف وخيارات الحزم',
    recSpaExperienceContent72: 'علامات حمراء يجب تجنبها',
    recSpaExperienceContent73: 'نظافة سيئة:',
    recSpaExperienceContent74: 'تجنب السبا التي لديها مشاكل نظافة',
    recSpaExperienceContent75: 'موظفون غير مؤهلين:',
    recSpaExperienceContent76: 'تأكد من أن المعالجين مدربون بشكل صحيح',
    recSpaExperienceContent77: 'تكتيكات الضغط:',
    recSpaExperienceContent78: 'تجنب السبا التي تضغط عليك للخدمات',
    recSpaExperienceContent79: 'تسعير غير واضح:',
    recSpaExperienceContent80: 'تأكد من التسعير والسياسات الشفافة',
    recSpaExperienceContent81: 'تواصل سيء:',
    recSpaExperienceContent82: 'اختر السبا التي تستمع لاحتياجاتك',
    recSpaExperienceQuickTip1: 'احضر مبكرًا للاسترخاء والتحضير عقليًا',
    recSpaExperienceQuickTip2: 'تواصل بصراحة مع معالجك حول التفضيلات',
    recSpaExperienceQuickTip3: 'حافظ على الترطيب واسترح بعد العلاجات',
    readyBeginWellnessJourney: 'مستعد لبدء رحلة العافية الخاصة بك؟',
    dontWaitExperienceSpa: 'لا تنتظر لتجربة الفوائد التحويلية لعلاجات السبا المهنية وعلاجات العافية! احجز استشارة مع أحد معالجينا الخبراء المتخصصين في العلاج بالتدليك والعلاجات الجمالية والعافية الشاملة. من تخفيف التوتر إلى تجديد البشرة، سنساعدك في تحقيق الصحة والرفاهية المثلى من خلال العلاجات والرعاية المخصصة.',
    bookSpaTreatment: 'احجز علاج السبا',
    bookMassage: 'احجز تدليك',
    // Privacy Policy
    privacyLead: 'نجمع فقط ما نحتاجه لتشغيل احجزلي، ولا نبيع بياناتك أبداً، ونحميها بضوابط أمنية قوية.',
    ppWhatWeCollect: 'ما نجمع',
    ppHowWeUse: 'كيف نستخدمها',
    ppSharing: 'المشاركة',
    ppSecurity: 'الأمان والاحتفاظ',
    ppYourChoices: 'خياراتك',
    // Category Components
    allBarbers: 'جميع الحلاقين',
    allHairNailSalons: 'جميع صالونات الشعر والأظافر',
    allTattooPiercingShops: 'جميع محلات الوشم والثقب',
    allLaserClinics: 'جميع عيادات الليزر',
    allBrowsLashes: 'جميع الحواجب والرموش',
    allMakeup: 'جميع المكياج',
    allMassage: 'جميع التدليك',
    allPetServices: 'جميع خدمات الحيوانات الأليفة',
    // Filter Components
    showFilters: 'إظهار خيارات التصفية',
    hideFilters: 'إخفاء خيارات التصفية',
    noSalonsFound: 'لم يتم العثور على صالونات',
    tryAdjustingFilters: 'جرّب تعديل خيارات التصفية أو مصطلحات البحث للعثور على المزيد من النتائج.',
    clearFilters: 'مسح خيارات التصفية',
    advancedFilters: 'خيارات التصفية المتقدمة',
    sortBy: 'الترتيب حسب:',
    minimumRating: 'الحد الأدنى للتقييم',
    filterByTown: 'تصفية حسب المنطقة',
    priceRange: 'نطاق السعر',
    // Booking Page - Days
    monday: 'الاثنين',
    tuesday: 'الثلاثاء',
    wednesday: 'الأربعاء',
    thursday: 'الخميس',
    friday: 'الجمعة',
    saturday: 'السبت',
    sunday: 'الأحد',
    // Booking Page - Time
    time: 'الوقت',
    selectTime: 'اختر وقتاً',
    availableTimes: 'الأوقات المتاحة',
    noAvailableTimes: 'لا توجد أوقات متاحة',
    morning: 'الصباح',
    afternoon: 'بعد الظهر',
    evening: 'المساء',
    // Booking Page Login Prompt
    signInToBook: '🔐 سجل الدخول لحجز موعدك',
    createAccountOrSignIn: 'أنشئ حساباً أو سجل الدخول للمتابعة مع حجزك. سيتم حفظ اختياراتك تلقائياً.',
    createAccount: 'إنشاء حساب',
    signIn: 'تسجيل الدخول',
    // AI Support
    aiSupportOpen: 'فتح الدعم الذكي',
    aiAssistantTitle: 'مساعد احجزلي الذكي',
    aiAssistantSubtitle: 'كيف يمكنني مساعدتك اليوم؟',
    aiWhatDoYouNeed: 'ما الذي تحتاج مساعدة بشأنه؟',
    aiQuickActions: 'إجراءات سريعة',
    aiBookAppointment: 'احجز موعدًا',
    aiViewBookings: 'عرض مواعيدي',
    aiContactSupport: 'اتصل بالدعم',
    aiReportProblem: 'الإبلاغ عن مشكلة',
    aiBackToCategories: 'رجوع ←',
    aiBackToQuestions: 'رجوع إلى الأسئلة ←',
    aiBookNow: 'احجز الآن',
    aiAskAnotherQuestion: 'اطرح سؤالاً آخر',
    aiContactHumanSupport: 'اتصل بالدعم البشري',
    aiNeedHelpWith: 'أحتاج مساعدة بخصوص:',
    aiWasThisHelpful: 'هل كان هذا مفيدًا؟',
    aiYes: 'نعم',
    aiNo: 'لا',
    aiTypeYourQuestion: 'اكتب سؤالك...',
    aiRelatedQuestions: 'أسئلة ذات صلة',
    aiFeedbackYes: 'رائع! يسعدني أنني استطعت المساعدة. هل هناك أي شيء آخر تود معرفته؟',
    aiFeedbackNo: 'آسف أن ذلك لم يكن مفيدًا. هل تود التواصل مع فريق الدعم لمزيد من المساعدة؟',
    aiNoSpecificAnswer: 'يمكنني المساعدة في الحجز أو حسابك أو إيجاد صالون. لأي شيء آخر راسلنا على واتساب.',
    aiCtaVerifyEmail: 'تفعيل الإيميل',
    aiCtaBrowseSalons: 'تصفح الصالونات',
    aiCtaSignUp: 'إنشاء حساب',
    aiCtaResetPassword: 'إعادة تعيين كلمة المرور',
    aiCtaEditProfile: 'فتح الملف الشخصي',
    aiCtaDeleteAccount: 'صفحة حذف الحساب',
    aiCtaExplore: 'فتح استكشف',
    aiCtaListBusiness: 'أضف نشاطك',
    aiCtaLeaveReview: 'فتح السجل',
    aiCtaContact: 'تواصل معنا',
    aiCtaPrivacy: 'سياسة الخصوصية',
    aiCtaWhatsApp: 'واتساب',
    aiCtaToggleLang: 'التبديل إلى الإنجليزية',
    // AI Support Categories
    aiCategoryBooking: 'الحجز',
    aiCategoryAccount: 'الحساب',
    aiCategoryBusiness: 'الصالونات',
    aiCategoryTechnical: 'الدعم',
    // AI Support Questions - Booking
    aiQHowToBook: 'كيف أحجز موعدًا؟',
    aiAHowToBook: 'من الصفحة الرئيسية اختر فئة ثم صالونًا. اختر الخدمة والموظف والتاريخ والوقت، ثم أرسل الطلب. الصالون يقبل أو يرفض، ويصلك إيميل. يمكنك أن يكون لديك حجز نشط واحد فقط في نفس الوقت.',
    aiQCancelAppointment: 'كيف ألغي حجزًا؟',
    aiACancelAppointment: 'افتح لوحة التحكم وألغِ حجزك الحالي. إعادة الجدولة غير متاحة بعد — لتغيير الوقت، ألغِ واحجز موعدًا جديدًا.',
    aiQBookingFailed: 'فشل حجزي، ماذا أفعل؟',
    aiABookingFailed: 'السبب عادة أن الإيميل غير مفعّل، أو الموعد محجوز، أو لديك حجز نشط بالفعل. احجزلي لا يأخذ دفعًا عند الحجز. راجع إيميلك لكود التفعيل، أو افتح لوحة التحكم لترى موعدك الحالي.',
    aiQNoAvailability: 'لا توجد أوقات متاحة',
    aiANoAvailability: 'قد يكون هذا الموظف أو هذا اليوم ممتلئًا. جرّب وقتًا آخر أو موظفًا آخر أو صالونًا مختلفًا.',
    aiQBookingPending: 'لماذا حجزي لا يزال قيد الانتظار؟',
    aiABookingPending: 'قيد الانتظار يعني أن الصالون لم يقبل أو يرفض بعد. انتظر ردهم — سيصلك إيميل. تابع الحجز من لوحة التحكم.',
    aiQBookingNotAvailable: 'ظهر لي غير متاح. ماذا أفعل؟',
    aiABookingNotAvailable: 'الصالون لم يستطع أخذ هذا الموعد. اختر وقتًا أو موظفًا أو صالونًا آخر وأرسل طلبًا جديدًا.',
    aiQActiveBookingBlock: 'لدي موعد بالفعل، لماذا لا أستطيع الحجز؟',
    aiAActiveBookingBlock: 'يمكنك أن يكون لديك حجز نشط واحد فقط (قيد الانتظار أو مؤكد). ألغِه من لوحة التحكم أولاً، ثم احجز الموعد الجديد.',
    aiQLeaveReview: 'كيف أترك تقييمًا؟',
    aiALeaveReview: 'بعد زيارة مكتملة، افتح السجل في لوحة التحكم وقيّم الصالون. نرسل أيضًا رابط التقييم بالإيميل.',
    // AI Support Questions - Account
    aiQCreateAccount: 'كيف أنشئ حسابًا؟',
    aiACreateAccount: 'اضغط إنشاء حساب، أدخل إيميلك ورقم هاتف مصري، ثم أدخل الكود الذي نرسله إلى إيميلك. تحتاج إيميلًا مفعّلًا للحجز.',
    aiQVerifyEmail: 'أريد تفعيل إيميلي / لم يصلني الكود',
    aiAVerifyEmail: 'نرسل كودًا من 4 أرقام إلى إيميلك، وليس SMS. راجع البريد المزعج. من شاشة التفعيل يمكنك طلب كود جديد. يجب التفعيل قبل الحجز.',
    aiQForgotPassword: 'نسيت كلمة المرور، كيف أعيد تعيينها؟',
    aiAForgotPassword: 'من صفحة تسجيل الدخول اضغط نسيت كلمة المرور. نرسل كود إعادة التعيين إلى إيميلك — وليس رابطًا. أدخل الكود واختر كلمة مرور جديدة.',
    aiQUpdateProfile: 'كيف أحدث ملفي الشخصي؟',
    aiAUpdateProfile: 'من لوحة التحكم افتح تبويب الملف الشخصي لتغيير الاسم أو الهاتف أو الصورة.',
    aiQDeleteAccount: 'كيف أحذف حسابي؟',
    aiADeleteAccount: 'أرسل طلبًا من صفحة حذف الحساب. يراجعه فريقنا — الحساب لا يُحذف فورًا.',
    aiQChangeLanguage: 'كيف أبدل بين الإنجليزية والعربية؟',
    aiAChangeLanguage: 'استخدم زر AR / EN أعلى الصفحة الرئيسية. الموقع وهذه المساعدة يتبعان هذه اللغة.',
    // AI Support Questions - Finding a salon
    aiQFindBusiness: 'كيف أجد صالونًا؟',
    aiAFindBusiness: 'استخدم مربعات الفئات في الصفحة الرئيسية. بعد تسجيل الدخول يمكنك أيضًا استخدام استكشف والخريطة. على الموقع، استكشف والخريطة يحتاجان حسابًا.',
    aiQListBusiness: 'كيف أضيف صالوني على احجزلي؟',
    aiAListBusiness: 'صاحب الصالون يضيف نشاطه من «أضف نشاطك»: الخدمات والموظفين والمواعيد والصور. لا تراسل صالونًا لتُدرج — استخدم النموذج.',
    aiQBusinessHours: 'كيف أتحقق من مواعيد الصالون؟',
    aiABusinessHours: 'افتح صالونًا وابدأ الحجز. الأوقات الظاهرة هي المواعيد التي يستقبلونها في ذلك اليوم.',
    aiQServicePrices: 'كيف أرى أسعار الخدمات؟',
    aiAServicePrices: 'تظهر الأسعار عند اختيار الخدمة في صفحة الصالون، ومرة أخرى في الملخص قبل إرسال الطلب.',
    aiQBusinessReviews: 'كيف أقرأ تقييمًا أو أتركه؟',
    aiABusinessReviews: 'اقرأ التقييمات في صفحة الصالون. بعد زيارة مكتملة، اترك تقييمك من السجل في لوحة التحكم، أو من إيميل التقييم الذي نرسله.',
    // AI Support Questions - Technical
    aiQAppNotWorking: 'الموقع لا يعمل بشكل صحيح',
    aiAAppNotWorking: 'حدّث الصفحة أو جرّب متصفحًا آخر. إذا استمرت المشكلة، تواصل معنا.',
    aiQNotificationsNotWorking: 'لا أتلقى إشعارات',
    aiANotificationsNotWorking: 'تحديثات الحجز تصل إلى إيميلك وإلى الإشعارات في لوحة التحكم. راجع البريد المزعج، وتأكد أن الإيميل على حسابك صحيح.',
    aiQSlowLoading: 'الموقع بطيء في التحميل',
    aiASlowLoading: 'تحقق من الاتصال، أغلق التبويبات الزائدة، وحدّث الصفحة. إذا استمر البطء، تواصل معنا.',
    aiQDataPrivacy: 'كيف يتم حماية بياناتي؟',
    aiADataPrivacy: 'نستخدم اسمك وإيميلك ورقم هاتفك لتشغيل حسابك وحجوزاتك. الصالون يرى ما يحتاجه للموعد. التفاصيل في سياسة الخصوصية.',
    aiQContactHuman: 'كيف أتواصل مع شخص؟',
    aiAContactHuman: 'راسلنا على واتساب أو أرسل رسالة من صفحة تواصل معنا. واتساب أسرع للرد.',
    // Hair & Nail Salon Recommended Content - Arabic
    recHairNailTitle: 'الخدمات الموصى بها',
    recHairNailSubtitle: 'نصائح عملية وقوائم تحقق ونصوص للوصول إلى النتيجة التي تريدها',
    recHairNailDescription: 'اكتشف خدمات مصممة لاحتياجاتك',
    // English keys for Arabic translations
    Oval: 'بيضاوي',
    Round: 'دائري',
    Square: 'مربع',
    Heart: 'قلبي',
    Diamond: 'معين',
    Long: 'طويل',
    'Trending looks and at-home approach': 'المظاهر الرائجة ونهج المنزل',
    'Textured lob / shag': 'لوب ملمسي / شاج',
    'Curtain bangs': 'هامش الستارة',
    'Blunt bob': 'بوب حاد',
    'Face-framing pieces': 'قطع تحيط بالوجه',
    'What different techniques do': 'ماذا تفعل التقنيات المختلفة',
    'Balayage / foilyage': 'بالياژ / فويلاج',
    'Root blending / smudge': 'مزج الجذور / تلطيخ',
    'Face-framing highlights (money piece)': 'تمييزات تحيط بالوجه (قطعة المال)',
    'Gloss / toner': 'لمعان / منعم',
    'Weekly habits': 'عادات أسبوعية',
    'Monthly / every 6–10 weeks': 'شهريًا / كل 6–10 أسابيع',
    'Daily Hair Care Routine': 'روتين العناية اليومية بالشعر',
    'Washing Frequency': 'تردد الغسيل',
    'Water Temperature': 'درجة حرارة الماء',
    'Shampoo Selection': 'اختيار الشامبو',
    Conditioning: 'البلسم',
    Drying: 'التجفيف',
    Frequency: 'التردد',
    'Always apply thermal spray before using any heat tools.': 'طبق دائمًا بخاخ حراري قبل استخدام أي أدوات حرارية.',
    'Use medium heat (300-350°F) for most hair types, lower for fine hair.': 'استخدم حرارة متوسطة (300-350°F) لمعظم أنواع الشعر، أقل للشعر الناعم.',
    'Ceramic and tourmaline tools distribute heat more evenly.': 'الأدوات السيراميك والتورمالين توزع الحرارة بشكل أكثر توازنًا.',
    'Use the cool shot button on your dryer to set styles and add shine.': 'استخدم زر التبريد على مجففك لتثبيت الأنماط وإضافة اللمعان.',
    'Apply cuticle oil daily and gently push back cuticles weekly.': 'طبق زيت البشرة يوميًا وادفع البشرة برفق أسبوعيًا.',
    'File nails in one direction only to prevent splitting and weakening.': 'برد الأظافر في اتجاه واحد فقط لمنع الانقسام والضعف.',
    'Keep nails at a practical length for your lifestyle to prevent breaks.': 'حافظ على الأظافر بطول عملي لنمط حياتك لمنع الكسر.',
    'Always use a base coat under polish to prevent staining and improve adhesion.': 'استخدم دائمًا طبقة أساسية تحت الطلاء لمنع البقع وتحسين الالتصاق.',
    'Apply top coat every 2-3 days to extend polish life and add shine.': 'طبق طبقة علوية كل 2-3 أيام لإطالة عمر الطلاء وإضافة اللمعان.',
    'Include lean meats, eggs, and legumes for keratin production.': 'اشمل اللحوم الخالية من الدهون والبيض والبقوليات لإنتاج الكيراتين.',
    'Found in nuts, seeds, and whole grains - essential for hair and nail growth.': 'موجود في المكسرات والبذور والحبوب الكاملة — ضروري لنمو الشعر والأظافر.',
    'Leafy greens and red meat prevent hair loss and brittle nails.': 'الخضار الورقية واللحوم الحمراء تمنع تساقط الشعر والأظافر الهشة.',
    'Fish, flaxseeds, and walnuts promote scalp health and nail strength.': 'السمك وبذور الكتان والجوز تعزز صحة فروة الرأس وقوة الأظافر.',
    'Drink 8-10 glasses of water daily for overall hair and nail health.': 'اشرب 8-10 أكواب من الماء يوميًا لصحة الشعر والأظافر بشكل عام.',
    'Use deep conditioning treatments weekly and avoid over-washing.': 'استخدم علاجات ترطيب عميقة أسبوعيًا وتجنب الغسيل المفرط.',
    'Regular trims every 6-10 weeks prevent further damage.': 'تقليمات منتظمة كل 6-10 أسابيع تمنع المزيد من التلف.',
    'Apply nail strengthener and avoid harsh chemicals.': 'طبق مقوي أظافر وتجنب المواد الكيميائية القاسية.',
    'Use color-safe products and protect from UV exposure.': 'استخدم منتجات آمنة للون واحم من التعرض للأشعة فوق البنفسجية.',
    'Keep nails moisturized and avoid picking at polish.': 'حافظ على الأظافر مرطبة وتجنب التقاط الطلاء.',
    'Every 6-10 weeks to maintain shape and remove damage.': 'كل 6-10 أسابيع للحفاظ على الشكل وإزالة التلف.',
    'Every 4-8 weeks depending on growth rate and color type.': 'كل 4-8 أسابيع حسب معدل النمو ونوع اللون.',
    'Monthly professional treatments for damaged hair.': 'علاجات احترافية شهرية للشعر التالف.',
    'Every 2-3 weeks for optimal nail health and appearance.': 'كل 2-3 أسابيع لصحة الأظافر ومظهرها الأمثل.',
    'Monthly for foot health and relaxation.': 'شهريًا لصحة القدم والاسترخاء.',
    // Hair & Nail Salon Recommended Content - Arabic
    recHairNailTitle: 'الخدمات الموصى بها',
    recHairNailSubtitle: 'نصائح عملية وقوائم تحقق ونصوص للوصول إلى النتيجة التي تريدها',
    recHairNailDescription: 'اكتشف خدمات مصممة لاحتياجاتك',
    recFaceShapeTitle: 'اعثر على قصة الشعر المثالية بناءً على شكل الوجه',
    recFaceShapeDescription: 'تعلم كيفية تحديد شكل وجهك واختيار قصات الشعر التي تعزز جمالك الطبيعي وتزيد ثقتك بنفسك',
    recFaceShapeContent1: 'فهم سريع ودقيق لشكل وجهك يساعد في اختيار قصات الشعر والهوامش التي تبرز ملامحك وتوفر الوقت وخيبة الأمل. قم باختبار الصورة + القياس البسيط في المنزل قبل استشارتك.',
    recFaceShapeContent2: 'افعل هذا قبل استشارة الصالون',
    recFaceShapeContent3: 'قف في ضوء طبيعي، اسحب الشعر للخلف والتقط صورة مباشرة.',
    recFaceShapeContent4: 'حدد أوسع النقاط (الجبهة/عظام الوجنتين/الفك) وقس النسب التقريبية.',
    recFaceShapeContent5: 'لاحظ مقدار الوقت الذي تريد قضاءه في التنسيق يوميًا — يجب أن يوجه ذلك التوصيات.',
    recFaceShapeContent6: 'إرشادات التنسيق حسب الشكل (سريع)',
    recFaceShapeContent7: 'معظم الأنماط تعمل. فكر في تجربة البوب، الطبقات الطويلة أو القطع التي تحيط بالوجه.',
    recFaceShapeContent8: 'أضف طولًا عموديًا وزوايا — طبقات طويلة، فرق جانبي عميق، تمييزات تحيط بالوجه.',
    recFaceShapeContent9: 'لطّف الفك بطبقات ملمسية وهامش جانبي.',
    recFaceShapeContent10: 'اجلب التوازن بإضافة عرض على مستوى الذقن — لوب، موجات ناعمة.',
    recFaceShapeContent11: 'استخدم هامش ناعم أو قطع بطول الذقن لموازنة عظام الوجنتين.',
    recFaceShapeContent12: 'أنشئ عرضًا بأنماط بطول الكتف، موجات، أو هامش حاد لتقليل الطول المتصور.',
    recFaceShapeContent13: 'حوّله إلى محادثة فعالة',
    recFaceShapeContent14: 'أحضر 2-3 صور تظهر المظهر الذي يعجبك من زوايا مختلفة وأخبر مصففك بكم الوقت الذي تريد قضاءه في التنسيق كل صباح.',
    recHairTrendsTitle: 'أتقن اتجاهات الشعر الرائجة والتنسيق في المنزل',
    recHairTrendsDescription: 'اكتشف أحدث اتجاهات الشعر لعام 2024 وتعلم تقنيات احترافية لإعادة إنشائها في المنزل بنتائج بجودة الصالون',
    recHairTrendsContent1: 'الأنماط الرائجة الآن تؤكد على الملمس والحركة الطبيعية بدلاً من الدقة الصارمة. يجب أن يناسب المظهر حياتك — إليك كيفية جعل هذه الاتجاهات تعمل من أجلك.',
    recHairTrendsContent2: 'المظاهر الرائجة ونهج المنزل',
    recHairTrendsContent3: 'لوب ملمسي / شاج: استخدم بخاخ ملح أو ملمس ونفّذ بخفة. اطلب طبقات داخلية (وليس إزالة وزن ثقيل) في الصالون للحفاظ على الشكل.',
    recHairTrendsContent4: 'هامش الستارة: التزام منخفض — قابل للنمو ومتسامح. نسّق بفرشاة مستديرة أو حركة سريعة بمكواة.',
    recHairTrendsContent5: 'بوب حاد: التنسيق الأنيق منخفض التجعيد يستفيد من منتج تنعيم وفرشاة مجداف عالية الجودة.',
    recHairTrendsContent6: 'قطع تحيط بالوجه: تمييزات إطار صغيرة أو طبقات أمامية أقصر قليلاً — تشرق وسهلة الصيانة.',
    recHairTrendsContent7: 'وصفات التنسيق (بسيطة)',
    recHairTrendsContent8: 'للموجات الناعمة: 1) اعمل واقي حراري على الشعر الرطب. 2) استخدم عصا تجعيد 1 بوصة، لف الأقسام بعيدًا عن وجهك لمدة 8-10 ثوانٍ، ثم مشط بالأصابع مع بخاخ ملمسي.',
    recHairColorTitle: 'دليل صبغ الشعر الاحترافي وصيانة اللون',
    recHairColorDescription: 'افهم تقنيات صبغ الشعر المختلفة، اختر اللون المناسب لبشرتك، وحافظ على لون نابض بالحياة بين زيارات الصالون',
    recHairColorContent1: 'يمكن للون أن يحول مظهرك — حافظ عليه صحيًا ويمكن ارتداؤه من خلال فهم التقنية والعناية المطلوبة.',
    recHairColorContent2: 'ماذا تفعل التقنيات المختلفة',
    recHairColorContent3: 'بالياژ / فويلاج: تمييزات مرسومة باليد تنمو بشكل غير مرئي — صيانة أقل لكثير من الناس.',
    recHairColorContent4: 'مزج الجذور / تلطيخ: يلطّف الخط بين الجذر الطبيعي واللون حتى تتمكن من تمديد الوقت بين اللمسات.',
    recHairColorContent5: 'تمييزات تحيط بالوجه (قطعة المال): يشرق الوجه ببضع خصلات أفتح موضوعة بشكل استراتيجي.',
    recHairColorContent6: 'لمعان / منعم: ينعش النغمة ويزيد اللمعان دون رفع كيميائي ثقيل.',
    recHairColorContent7: 'العناية في المنزل التي تساعد فعلاً',
    recHairColorContent8: 'استخدم شامبو وبلسم خالي من الكبريتات وآمن للون — تجنب الغسيل اليومي عند الإمكان.',
    recHairColorContent9: 'استخدم قناع ترطيب عميق أسبوعيًا إذا كان شعرك مساميًا أو معالجًا كيميائيًا.',
    recHairColorContent10: 'اختر شامبو بنفسجي فقط إذا رأيت نغمات دافئة/نحاسية على الأشقر؛ استخدمه باعتدال (مرة واحدة في الأسبوع للبدء).',
    recHairColorContent11: 'استخدم دائمًا واقي حراري قبل الأدوات الساخنة لحماية اللون وتقليل الكسر.',
    recHairColorContent12: 'اختبار التصحيح والحساسية',
    recHairColorContent13: 'إذا كان لديك ردود فعل سابقة أو بشرة حساسة، اطلب اختبار تصحيح قبل 48-72 ساعة من أي علاج لون جديد.',
    recNailCareTitle: 'دليل العناية الكامل بالأظافر وإلهام التصميم',
    recNailCareDescription: 'تعلم روتين العناية الأساسي بالأظافر، اختر شكل وطول الظفر المثالي لنمط حياتك، واكتشف أفكار تصميم مذهلة',
    recNailCareContent1: 'الأظافر ذات المظهر الرائع تبدأ بالتحضير الصحي والتوقعات الواقعية — اعرف الخيارات وروتين الصيانة الذي يحافظ على صحة الأظافر.',
    recNailCareContent2: 'اختيار نمط يناسب حياتك',
    recNailCareContent3: 'قصير/نظيف: صيانة دنيا، أسهل للمهام اليدوية والرياضة.',
    recNailCareContent4: 'متوسط مع لمسات فنية صغيرة: يوازن بين النمط والمتانة.',
    recNailCareContent5: 'طويل أو فن معقد: صيانة أعلى — خطط المواعيد وفقًا لذلك.',
    recNailCareContent6: 'نصائح التحضير والرعاية اللاحقة',
    recNailCareContent7: 'احضر بأظافر نظيفة (بدون طلاء) حتى يتمكن الفني من تقييم الحالة الطبيعية.',
    recNailCareContent8: 'استخدم زيت البشرة يوميًا للحفاظ على البشرة ناعمة ومنع الرفع.',
    recNailCareContent9: 'أغلق الحواف بطبقة علوية وأعد تطبيق طبقة علوية شفافة كل بضعة أيام لإطالة الاستخدام.',
    recNailCareContent10: 'إصلاحات سريعة لمشاكل الأظافر الشائعة',
    recNailCareContent11: 'رفع صغير أو كسر: ابرد الحافة برفق وضع طبقة رقيقة من الطبقة العلوية؛ راجع فنييك لإصلاح مناسب.',
    recNailCareContent12: 'ظفر طبيعي مكسور: نظف وجفف وضع رقعة لاصقة مرنة (أو اطلب من فنييك تعزيزها بطبقة رقيقة).',
    recMaintenanceTitle: 'صيانة نتائج الصالون وصحة الشعر/الأظافر',
    recMaintenanceDescription: 'مدد نتائج الصالون بروتين صيانة احترافي، اختيار المنتج المناسب، وعادات صحية لشعر وأظافر جميلة',
    recMaintenanceContent1: 'الاتساق يتفوق على التدخلات باهظة الثمن. بعض العادات الجيدة المتكررة بانتظام تحافظ على نتائج الصالون وصحة الشعر/الأظافر.',
    recMaintenanceContent2: 'عادات أسبوعية',
    recMaintenanceContent3: 'قلل الغسيل إلى 2-3× في الأسبوع إن أمكن (اضبط لدهنية فروة الرأس)؛ استخدم ماء فاتر أو بارد.',
    recMaintenanceContent4: 'طبق قناع ترطيب أو علاج ترطيب مرة واحدة في الأسبوع للشعر الجاف أو المصبوغ.',
    recMaintenanceContent5: 'استخدم زيت البشرة ليلاً وكريم يد مغذي بعد غسل اليدين.',
    recMaintenanceContent6: 'شهريًا / كل 6-10 أسابيع',
    recMaintenanceContent7: 'جد تقليمات لإزالة الأطراف المنقسمة والحفاظ على الشكل (التردد يعتمد على النمط).',
    recMaintenanceContent8: 'أنعش اللمعان/المنعم أو تجديد مستهدف إذا بدأ اللون يتلاشى بشكل ملحوظ.',
    recMaintenanceContent9: 'للتحسينات (الامتدادات، الطبقات)، جد مواعيد صيانة منتظمة موصى بها من فنييك.',
    recMaintenanceContent10: 'عادات يومية وقائية',
    recMaintenanceContent11: 'استخدم واقي حراري وتجنب إعدادات الحرارة القصوى على الأدوات.',
    recMaintenanceContent12: 'نم على وسادة حريرية أو استخدم وشاح حرير/ساتان لتقليل الاحتكاك.',
    recMaintenanceContent13: 'ارتدِ قفازات للتنظيف الممتد أو البستنة لحماية الأظافر واليدين من المواد الكيميائية القاسية.',
    recHairNailHealthTitle: 'نصائح أساسية لصحة الشعر والأظافر',
    recHairNailHealthDescription: 'تعلم نصائح احترافية للحفاظ على شعر وأظافر صحية بين زيارات الصالون، منع التلف، وتحقيق نتائج جمالية طويلة الأمد',
    recHairNailHealthContent1: 'الشعر والأظافر الصحية هي أساس نتائج الصالون الجميلة. هذه النصائح الاحترافية ستساعدك في الحفاظ على مظهر الصالون لفترة أطول ومنع مشاكل التلف الشائعة.',
    recHairNailHealthContent2: 'روتين العناية اليومية بالشعر',
    recHairNailHealthContent3: 'تردد الغسيل: اغسل الشعر 2-3 مرات في الأسبوع كحد أقصى للحفاظ على الزيوت الطبيعية واللون.',
    recHairNailHealthContent4: 'درجة حرارة الماء: استخدم ماء فاتر — الماء الساخن يزيل الرطوبة ويسبب التجعيد.',
    recHairNailHealthContent5: 'اختيار الشامبو: اختر صيغ خالية من الكبريتات للشعر المصبوغ، شامبو توضيحي للتراكم.',
    recHairNailHealthContent6: 'البلسم: طبق البلسم من منتصف الطول إلى الأطراف، اترك لمدة 2-3 دقائق قبل الشطف.',
    recHairNailHealthContent7: 'التجفيف: اربت الشعر برفق بمنشفة ميكروفايبر، تجنب الفرك الذي يسبب الكسر.',
    recHairNailHealthContent8: 'حماية التنسيق الحراري',
    recHairNailHealthContent9: 'واقي الحراري: طبق دائمًا بخاخ حراري قبل استخدام أي أدوات حرارية.',
    recHairNailHealthContent10: 'إعدادات درجة الحرارة: استخدم حرارة متوسطة (300-350°F) لمعظم أنواع الشعر، أقل للشعر الناعم.',
    recHairNailHealthContent11: 'اختيار الأداة: الأدوات السيراميك والتورمالين توزع الحرارة بشكل أكثر توازنًا.',
    recHairNailHealthContent12: 'التردد: قلل التنسيق الحراري إلى 2-3 مرات في الأسبوع كحد أقصى.',
    recHairNailHealthContent13: 'التبريد: استخدم زر التبريد على مجففك لتثبيت الأنماط وإضافة اللمعان.',
    recHairNailHealthContent14: 'أساسيات العناية بالأظافر',
    recHairNailHealthContent15: 'العناية بالبشرة: طبق زيت البشرة يوميًا وادفع البشرة برفق أسبوعيًا.',
    recHairNailHealthContent16: 'شكل الظفر: برد الأظافر في اتجاه واحد فقط لمنع الانقسام والضعف.',
    recHairNailHealthContent17: 'صيانة الطول: حافظ على الأظافر بطول عملي لنمط حياتك لمنع الكسر.',
    recHairNailHealthContent18: 'الطبقة الأساسية: استخدم دائمًا طبقة أساسية تحت الطلاء لمنع البقع وتحسين الالتصاق.',
    recHairNailHealthContent19: 'الطبقة العلوية: طبق طبقة علوية كل 2-3 أيام لإطالة عمر الطلاء وإضافة اللمعان.',
    recHairNailHealthContent20: 'التغذية لصحة الشعر والأظافر',
    recHairNailHealthContent21: 'البروتين: اشمل اللحوم الخالية من الدهون والبيض والبقوليات لإنتاج الكيراتين.',
    recHairNailHealthContent22: 'البيوتين: موجود في المكسرات والبذور والحبوب الكاملة — ضروري لنمو الشعر والأظافر.',
    recHairNailHealthContent23: 'الحديد: الخضار الورقية واللحوم الحمراء تمنع تساقط الشعر والأظافر الهشة.',
    recHairNailHealthContent24: 'أوميغا 3: السمك وبذور الكتان والجوز تعزز صحة فروة الرأس وقوة الأظافر.',
    recHairNailHealthContent25: 'الترطيب: اشرب 8-10 أكواب من الماء يوميًا لصحة الشعر والأظافر بشكل عام.',
    recHairNailHealthContent26: 'المشاكل الشائعة والحلول',
    recHairNailHealthContent27: 'استخدم علاجات ترطيب عميقة أسبوعيًا وتجنب الغسيل المفرط.',
    recHairNailHealthContent28: 'تقليمات منتظمة كل 6-10 أسابيع تمنع المزيد من التلف.',
    recHairNailHealthContent29: 'طبق مقوي أظافر وتجنب المواد الكيميائية القاسية.',
    recHairNailHealthContent30: 'استخدم منتجات آمنة للون واحم من التعرض للأشعة فوق البنفسجية.',
    recHairNailHealthContent31: 'حافظ على الأظافر مرطبة وتجنب التقاط الطلاء.',
    recHairNailHealthContent32: 'جدول الصيانة الاحترافية',
    recHairNailHealthContent33: 'كل 6-10 أسابيع للحفاظ على الشكل وإزالة التلف.',
    recHairNailHealthContent34: 'كل 4-8 أسابيع حسب معدل النمو ونوع اللون.',
    recHairNailHealthContent35: 'علاجات احترافية شهرية للشعر التالف.',
    recHairNailHealthContent36: 'كل 2-3 أسابيع لصحة الأظافر ومظهرها الأمثل.',
    recHairNailHealthContent37: 'شهريًا لصحة القدم والاسترخاء.',
    // Quick Tips for Hair & Nail Salon - Arabic
    quickTipPhoto: 'التقط صورة مباشرة مع سحب الشعر للخلف',
    quickTipMeasure: 'قم بقياس نسب وجهك',
    quickTipTime: 'ضع في اعتبارك وقت التنسيق اليومي الملتزم به',
    quickTipTexturedLob: 'اللوب الملمسي يعمل بشكل رائع مع بخاخ الملح',
    quickTipCurtainBangs: 'هامش الستارة منخفض الالتزام ومتسامح',
    quickTipHeatProtectant: 'استخدم واقي حراري قبل أدوات التنسيق',
    quickTipBalayage: 'البالياژ ينمو بشكل أكثر طبيعية من التمييزات التقليدية',
    quickTipSulfateFree: 'استخدم شامبو خالي من الكبريتات للحفاظ على اللون',
    quickTipPatchTest: 'اطلب دائمًا اختبار تصحيح للألوان الجديدة',
    quickTipCleanNails: 'احضر بأظافر نظيفة لتقييم أفضل',
    quickTipCuticleOil: 'استخدم زيت البشرة يوميًا لمنع الرفع',
    quickTipLength: 'اختر الطول بناءً على نمط حياتك',
    quickTipWashing: 'قلل غسل الشعر إلى 2-3 مرات في الأسبوع',
    quickTipSilk: 'استخدم وسائد حريرية لتقليل الاحتكاك',
    quickTipTrims: 'جدول تقليمات منتظمة كل 6-10 أسابيع',
    quickTipSulfateFreeHair: 'استخدم شامبو خالي من الكبريتات للشعر المصبوغ',
    quickTipCuticleOilNails: 'طبق زيت البشرة يوميًا لأظافر أقوى',
    quickTipThermalSprays: 'احمِ الشعر من التلف الحراري بالبخاخات الحرارية',
    // Additional section headings - Arabic
    'Dry Hair': 'شعر جاف',
    'Split Ends': 'أطراف منقسمة',
    'Brittle Nails': 'أظافر هشة',
    'Color Fading': 'تلاشي اللون',
    'Nail Peeling': 'تقشير الأظافر',
    'Hair Trims': 'تقليمات الشعر',
    'Color Touch-ups': 'لمسات اللون',
    'Deep Conditioning': 'الترطيب العميق',
    Manicures: 'مانيكير',
    Pedicures: 'بيديكير',
    // Tattoo & Piercing translations - Arabic
    completeTattooPiercingGuide: 'دليل الوشم والثقب الشامل 2024',
    professionalBodyArtGuide: 'دليل فن الجسد المهني • محدث ديسمبر 2024',
    exploreWorldBodyArt: 'استكشف عالم فن الجسد المهني من خلال دليلنا الشامل للوشم والثقب. من اختيار التصميم المثالي إلى فهم عملية الشفاء، اكتشف كل ما تحتاج معرفته حول تعديل الجسد الآمن والمهني. سواء كنت مبتدئًا أو تبحث عن توسيع مجموعتك، يغطي هذا الدليل إلهام التصميم واختيار الفنان والرعاية المناسبة.',
    professionalTattooDesign: 'تصميم الوشم المهني واختيار النمط',
    exploreTattooArtStyles: 'استكشف أنماط فن الوشم وتعلم كيفية اختيار التصاميم التي تعكس شخصيتك وتفضيلاتك الجمالية',
    expertTattooArtistSelection: 'اختيار فنان الوشم الخبير وتقييم المعرض',
    learnFindPerfectArtist: 'تعلم كيفية العثور على فنان الوشم المثالي وتقييم المعارض للجودة ومطابقة النمط والمعايير المهنية',
    completePiercingGuide: 'دليل الثقب الشامل وخيارات الموضع',
    discoverDifferentPiercing: 'اكتشف أنواع الثقب المختلفة وأوقات الشفاء وخيارات الموضع لتعديل الجسد الآمن والأنيق',
    professionalAftercare: 'الرعاية اللاحقة المهنية وعملية الشفاء',
    recTattooMasterAftercareRoutine: 'أتقن روتين الرعاية اللاحقة للشفاء الأمثل والرضا طويل الأمد مع فن جسدك',
    safetyStandardsHygiene: 'معايير السلامة وأفضل ممارسات النظافة',
    understandEssentialSafety: 'افهم اعتبارات السلامة الأساسية وممارسات النظافة لتعديل الجسد الآمن والمهني',
    recTattooDesignIntro: 'استكشف أنماط فن الوشم وتعلم كيفية اختيار التصاميم التي تعكس شخصيتك وتفضيلاتك الجمالية. تطور فن الوشم إلى شكل متطور من التعبير عن الذات.',
    recTattooDesignContent1: 'تطور فن الوشم إلى شكل متطور من التعبير عن الذات، مع أنماط وتقنيات لا حصر لها متاحة. من التصاميم التقليدية إلى الفن المعاصر، فهم أنماط الوشم المختلفة يساعدك في اختيار التصميم المثالي الذي يعكس شخصيتك وتفضيلاتك الجمالية.',
    recTattooDesignContent2: 'أنماط الوشم الشائعة',
    recTattooDesignContent3: '1. الوشم التقليدي/الكلاسيكي',
    recTattooDesignContent4: 'الخصائص:',
    recTattooDesignContent5: 'خطوط سوداء جريئة، ألوان صلبة، صور كلاسيكية مثل الورود والنسور والمراسي.',
    recTattooDesignContent6: 'الأفضل لـ:',
    recTattooDesignContent7: 'أولئك الذين يقدرون التصاميم الجريئة الخالدة برمزية قوية.',
    recTattooDesignContent8: 'الموتيفات الشائعة:',
    recTattooDesignContent9: 'الورود، النسور، المراسي، القلوب، الخناجر',
    recTattooDesignContent10: '2. الواقعي/الفوتوغرافي',
    recTattooDesignContent11: 'تمثيلات مفصلة للغاية وواقعية للأشخاص أو الحيوانات أو الأشياء.',
    recTattooDesignContent12: 'أولئك الذين يريدون تمثيلات فنية مفصلة بجودة فوتوغرافية.',
    recTattooDesignContent13: 'المواضيع الشائعة:',
    recTattooDesignContent14: 'البورتريهات، الحيوانات، مشاهد الطبيعة، الأشياء',
    recTattooDesignContent15: '3. وشم الألوان المائية',
    recTattooDesignContent16: 'تصاميم متدفقة وملونة تحاكي لوحات الألوان المائية بحواف ناعمة وألوان نابضة بالحياة.',
    recTattooDesignContent17: 'أولئك الذين يريدون تصاميم فنية ملونة بجمالية رسامية.',
    recTattooDesignContent18: 'العناصر الشائعة:',
    recTattooDesignContent19: 'الأشكال المجردة، مشاهد الطبيعة، التفسيرات الفنية',
    recTattooDesignContent20: '4. الوشم الهندسي',
    recTattooDesignContent21: 'خطوط وأشكال وأنماط دقيقة بدقة رياضية وتناظر.',
    recTattooDesignContent22: 'أولئك الذين يقدرون التصاميم النظيفة والحد الأدنى بمعنى رمزي.',
    recTattooDesignContent23: 'العناصر الشائعة:',
    recTattooDesignContent24: 'الماندالا، الهندسة المقدسة، الحيوانات الهندسية',
    recTattooDesignContent25: '5. الوشم البسيط',
    recTattooDesignContent26: 'تصاميم بسيطة ونظيفة بخطوط رفيعة وتفاصيل قليلة.',
    recTattooDesignContent27: 'أولئك الذين يفضلون التصاميم الخفية والمتواضعة التي يسهل الحفاظ عليها.',
    recTattooDesignContent28: 'العناصر الشائعة:',
    recTattooDesignContent29: 'الرموز البسيطة، الكلمات، الرسوم التوضيحية الصغيرة',
    recTattooDesignContent30: 'اعتبارات التصميم',
    recTattooDesignContent31: 'خيارات الموضع',
    recTattooDesignContent32: 'المناطق المرئية:',
    recTattooDesignContent33: 'الذراعين، الساقين، اليدين، الرقبة - ضع في اعتبارك الآثار المهنية',
    recTattooDesignContent34: 'المناطق المخفية:',
    recTattooDesignContent35: 'الظهر، الصدر، الأضلاع - موضع أكثر خصوصية',
    recTattooDesignContent36: 'مستويات الألم:',
    recTattooDesignContent37: 'بعض المناطق أكثر حساسية من غيرها',
    recTattooDesignContent38: 'اعتبارات الحجم:',
    recTattooDesignContent39: 'التصاميم الأكبر تحتاج مساحة أكبر',
    recTattooDesignContent40: 'نصائح التخصيص',
    recTattooDesignContent41: 'الرموز ذات المعنى:',
    recTattooDesignContent42: 'اختر تصاميم تمثل قيمك أو تجاربك',
    recTattooDesignContent43: 'التصاميم المخصصة:',
    recTattooDesignContent44: 'اعمل مع الفنانين لإنشاء قطع فريدة وشخصية',
    recTattooDesignContent45: 'تفضيلات اللون:',
    recTattooDesignContent46: 'ضع في اعتبارك كيف سيشيخ اللون ويتلاشى بمرور الوقت',
    recTattooDesignContent47: 'الحجم والتفاصيل:',
    recTattooDesignContent48: 'وازن بين التعقيد والطول والعمر والوضوح',
    recTattooDesignQuickTip1: 'اختر الأنماط التي تطابق جماليتك الشخصية ونمط حياتك',
    recTattooDesignQuickTip2: 'ضع في اعتبارك الموضع بعناية للآثار المهنية',
    recTattooDesignQuickTip3: 'اعمل مع الفنانين لإنشاء تصاميم مخصصة وذات معنى',
    recArtistSelectionIntro: 'تعلم كيفية العثور على فنان الوشم المثالي وتقييم المعارض للجودة ومطابقة النمط والمعايير المهنية. سيخلق الفنان المناسب عملاً جميلاً ويوفر التوجيه المناسب.',
    recArtistSelectionContent1: 'اختيار فنان الوشم المناسب أمر بالغ الأهمية لتحقيق أفضل النتائج وضمان تجربة آمنة ومهنية. لن يخلق الفنان المناسب عملاً جميلاً فحسب، بل سيوفر أيضاً التوجيه المناسب، ويحافظ على معايير النظافة العالية، ويساعدك في اتخاذ قرارات مستنيرة حول وشمك.',
    recArtistSelectionContent2: 'ما الذي تبحث عنه',
    recArtistSelectionContent3: 'جودة المعرض',
    recArtistSelectionContent4: 'مطابقة النمط:',
    recArtistSelectionContent5: 'اختر فناناً نمطه يتماشى مع رؤيتك',
    recArtistSelectionContent6: 'المهارة التقنية:',
    recArtistSelectionContent7: 'ابحث عن خطوط نظيفة ولون صلب وتظليل مناسب',
    recArtistSelectionContent8: 'الاتساق:',
    recArtistSelectionContent9: 'تحقق من أن جودة عملهم متسقة عبر القطع',
    recArtistSelectionContent10: 'صور الشفاء:',
    recArtistSelectionContent11: 'اطلب رؤية صور الوشم الملتئم، وليس فقط الطازج',
    recArtistSelectionContent12: 'المعايير المهنية',
    recArtistSelectionContent13: 'الترخيص:',
    recArtistSelectionContent14: 'تأكد من أن الفنان مرخص ومعتمد بشكل صحيح',
    recArtistSelectionContent15: 'النظافة:',
    recArtistSelectionContent16: 'تحقق من أن الاستوديو يحافظ على معايير النظافة العالية',
    recArtistSelectionContent17: 'التعقيم:',
    recArtistSelectionContent18: 'تحقق من أن المعدات معقمة بشكل صحيح',
    recArtistSelectionContent19: 'بروتوكولات السلامة:',
    recArtistSelectionContent20: 'اسأل عن إجراءات السلامة والنظافة الخاصة بهم',
    recArtistSelectionContent21: 'التواصل والاستشارة',
    recArtistSelectionContent22: 'مهارات الاستماع:',
    recArtistSelectionContent23: 'اختر فناناً يستمع لأفكارك ومخاوفك',
    recArtistSelectionContent24: 'الخبرة:',
    recArtistSelectionContent25: 'ابحث عن فنانين يمكنهم تقديم التوجيه والتوصيات',
    recArtistSelectionContent26: 'الشفافية:',
    recArtistSelectionContent27: 'اختر شخصاً يشرح العملية ويجيب على الأسئلة',
    recArtistSelectionContent28: 'مستوى الراحة:',
    recArtistSelectionContent29: 'تأكد من أنك تشعر بالراحة في مناقشة تصميمك',
    recArtistSelectionContent30: 'عملية البحث',
    recArtistSelectionContent31: 'البحث عبر الإنترنت',
    recArtistSelectionContent32: 'مواقع الاستوديو:',
    recArtistSelectionContent33: 'راجع المعارض والسير الذاتية للفنانين',
    recArtistSelectionContent34: 'وسائل التواصل الاجتماعي:',
    recArtistSelectionContent35: 'تحقق من إنستغرام وفيسبوك للأعمال الأخيرة',
    recArtistSelectionContent36: 'المراجعات:',
    recArtistSelectionContent37: 'اقرأ مراجعات العملاء والشهادات',
    recArtistSelectionContent38: 'التوصيات:',
    recArtistSelectionContent39: 'اسأل الأصدقاء والعائلة عن الإحالات',
    recArtistSelectionContent40: 'زيارات الاستوديو',
    recArtistSelectionContent41: 'النظافة:',
    recArtistSelectionContent42: 'زر الاستوديو لتقييم النظافة والتنظيم',
    recArtistSelectionContent43: 'الجو:',
    recArtistSelectionContent44: 'تأكد من أن البيئة تبدو مهنية ومريحة',
    recArtistSelectionContent45: 'توفر الفنان:',
    recArtistSelectionContent46: 'تحقق من توفر الفنان المفضل لديك',
    recArtistSelectionContent47: 'التسعير:',
    recArtistSelectionContent48: 'افهم هيكل التسعير وسياساتهم',
    recArtistSelectionContent49: 'عملية الاستشارة',
    recArtistSelectionContent50: 'التحضير قبل الاستشارة',
    recArtistSelectionContent51: 'أفكار التصميم:',
    recArtistSelectionContent52: 'أحضر صور مرجعية ووصف رؤيتك',
    recArtistSelectionContent53: 'الحجم والموضع:',
    recArtistSelectionContent54: 'ضع في اعتبارك أين تريد الوشم',
    recArtistSelectionContent55: 'الميزانية:',
    recArtistSelectionContent56: 'ضع ميزانية واقعية في الاعتبار',
    recArtistSelectionContent57: 'الأسئلة:',
    recArtistSelectionContent58: 'جهز أسئلة حول العملية والرعاية اللاحقة',
    recArtistSelectionContent59: 'أثناء الاستشارة',
    recArtistSelectionContent60: 'مناقشة التصميم:',
    recArtistSelectionContent61: 'اعمل معاً لتحسين تصميمك',
    recArtistSelectionContent62: 'الجدول الزمني:',
    recArtistSelectionContent63: 'افهم العملية والجدول الزمني',
    recArtistSelectionContent64: 'الرعاية اللاحقة:',
    recArtistSelectionContent65: 'تعلم عن الرعاية والشفاء المناسبين',
    recArtistSelectionContent66: 'التسعير:',
    recArtistSelectionContent67: 'احصل على تقدير واضح للتكاليف',
    recArtistSelectionQuickTip1: 'راجع المعارض لمطابقة النمط والمهارة التقنية',
    recArtistSelectionQuickTip2: 'تحقق من الترخيص ومعايير النظافة',
    recArtistSelectionQuickTip3: 'اختر فنانين يستمعون لأفكارك ومخاوفك',
    recPiercingIntro: 'اكتشف أنواع الثقب المختلفة وأوقات الشفاء وخيارات الموضع لتعديل الجسد الآمن والأنيق. فهم هذه العوامل يساعدك في اتخاذ قرارات مستنيرة حول فن جسدك.',
    recPiercingContent1: 'تقدم ثقوب الجسد مجموعة واسعة من الخيارات للتعبير عن الذات، من ثقوب الأذن الخفية إلى تعديلات الجسد الجريئة. فهم أنواع الثقب المختلفة وأوقات الشفاء ومتطلبات الرعاية يساعدك في اتخاذ قرارات مستنيرة حول خيارات فن جسدك.',
    recPiercingContent2: 'ثقوب الأذن',
    recPiercingContent3: 'ثقوب شحمة الأذن',
    recPiercingContent4: 'الوصف:',
    recPiercingContent5: 'الثقب الأكثر شيوعاً، عبر شحمة الأذن.',
    recPiercingContent6: 'وقت الشفاء:',
    recPiercingContent7: '6-8 أسابيع',
    recPiercingContent8: 'مستوى الألم:',
    recPiercingContent9: 'منخفض',
    recPiercingContent10: 'التنوع:',
    recPiercingContent11: 'يمكن أن تستوعب أنماط مجوهرات مختلفة',
    recPiercingContent12: 'ثقوب الغضروف',
    recPiercingContent13: 'ثقوب عبر غضروف الأذن.',
    recPiercingContent14: '3-12 شهراً',
    recPiercingContent15: 'متوسط إلى عالي',
    recPiercingContent16: 'الأنواع الشائعة:',
    recPiercingContent17: 'الهليكس، الترجوس، الكونش، الدايث',
    recPiercingContent18: 'ثقوب الوجه',
    recPiercingContent19: 'ثقوب الأنف',
    recPiercingContent20: 'ثقوب عبر فتحة الأنف أو الحاجز.',
    recPiercingContent21: '2-4 أشهر (فتحة الأنف)، 6-8 أشهر (الحاجز)',
    recPiercingContent22: 'منخفض إلى متوسط',
    recPiercingContent23: 'الاعتبارات:',
    recPiercingContent24: 'الآثار المهنية، خيارات المجوهرات',
    recPiercingContent25: 'ثقوب الشفاه',
    recPiercingContent26: 'ثقوب متنوعة في منطقة الشفاه والفم.',
    recPiercingContent27: '2-3 أشهر',
    recPiercingContent28: 'متوسط',
    recPiercingContent29: 'اللابريت، المونرو، لدغات الثعبان',
    recPiercingContent30: 'ثقوب الجسد',
    recPiercingContent31: 'ثقوب السرة',
    recPiercingContent32: 'ثقب عبر منطقة السرة.',
    recPiercingContent33: '6-12 شهراً',
    recPiercingContent34: 'الاعتبارات:',
    recPiercingContent35: 'خيارات الملابس، قيود النشاط',
    recPiercingContent36: 'الثقوب السطحية',
    recPiercingContent37: 'ثقوب تجلس على سطح الجلد.',
    recPiercingContent38: 'الاعتبارات:',
    recPiercingContent39: 'خطر الرفض الأعلى، مجوهرات متخصصة',
    recPiercingContent40: 'اختيار المجوهرات',
    recPiercingContent41: 'خيارات المواد',
    recPiercingContent42: 'الفولاذ الجراحي:',
    recPiercingContent43: 'مقاوم للحساسية، متين، بأسعار معقولة',
    recPiercingContent44: 'التيتانيوم:',
    recPiercingContent45: 'خفيف الوزن، مقاوم للحساسية، عالي الجودة',
    recPiercingContent46: 'الذهب:',
    recPiercingContent47: 'فاخر، مقاوم للحساسية، مكلف',
    recPiercingContent48: 'المواد المتوافقة حيوياً:',
    recPiercingContent49: 'آمن للبشرة الحساسة',
    recPiercingContent50: 'أنماط المجوهرات',
    recPiercingContent51: 'البراغي:',
    recPiercingContent52: 'بسيطة، متعددة الاستخدامات، جيدة للشفاء',
    recPiercingContent53: 'الحلقات:',
    recPiercingContent54: 'كلاسيكية، أحجام مختلفة متاحة',
    recPiercingContent55: 'حلقات الخرز الأسيرة:',
    recPiercingContent56: 'آمنة، زخرفية',
    recPiercingContent57: 'القضبان:',
    recPiercingContent58: 'مستقيمة أو منحنية، أطوال مختلفة',
    recPiercingQuickTip1: 'ابدأ بثقوب شحمة الأذن للمبتدئين',
    recPiercingQuickTip2: 'اختر مواد مقاومة للحساسية مثل التيتانيوم',
    recPiercingQuickTip3: 'ضع في اعتبارك أوقات الشفاء عند التخطيط لثقوب متعددة',
    recAftercareIntro: 'أتقن روتين الرعاية اللاحقة للشفاء الأمثل والرضا طويل الأمد مع فن جسدك. الرعاية اللاحقة المناسبة ضرورية للشفاء الناجح وتمنع المضاعفات.',
    recAftercareContent1: 'الرعاية اللاحقة المناسبة ضرورية للشفاء الناجح والرضا طويل الأمد مع فن جسدك. اتباع تعليمات الرعاية اللاحقة المهنية يساعد في منع العدوى وتعزيز الشفاء ويضمن أن يبدو وشمك أو ثقبك في أفضل حالاته لسنوات قادمة.',
    recAftercareContent2: 'الرعاية اللاحقة للوشم',
    recAftercareContent3: 'الرعاية الفورية (أول 24 ساعة)',
    recAftercareContent4: 'احتفظ بالضمادة:',
    recAftercareContent5: 'اترك الضمادة الأولية لمدة 2-4 ساعات',
    recAftercareContent6: 'التنظيف اللطيف:',
    recAftercareContent7: 'استخدم صابوناً لطيفاً خالياً من العطور',
    recAftercareContent8: 'ربت بالجفاف:',
    recAftercareContent9: 'ربت برفق بالجفاف بمنشفة نظيفة',
    recAftercareContent10: 'تجنب اللمس:',
    recAftercareContent11: 'لا تلمس الوشم بأيدي قذرة',
    recAftercareContent12: 'رعاية الأسبوع الأول',
    recAftercareContent13: 'اغسل مرتين يومياً:',
    recAftercareContent14: 'نظف بصابون لطيف وماء دافئ',
    recAftercareContent15: 'رطب:',
    recAftercareContent16: 'طبق طبقة رقيقة من المرطب الخالي من العطور',
    recAftercareContent17: 'تجنب النقع:',
    recAftercareContent18: 'لا سباحة، جاكوزي، أو استحمام طويل',
    recAftercareContent19: 'احم من الشمس:',
    recAftercareContent20: 'احتفظ مغطى وتجنب أشعة الشمس المباشرة',
    recAftercareContent21: 'عملية الشفاء',
    recAftercareContent22: 'الأسبوع 1:',
    recAftercareContent23: 'الاحمرار والتورم والحساسية',
    recAftercareContent24: 'الأسبوع 2-3:',
    recAftercareContent25: 'التقشير والتقشر',
    recAftercareContent26: 'الأسبوع 4-6:',
    recAftercareContent27: 'اكتمال الشفاء السطحي',
    recAftercareContent28: 'الشهر 2-3:',
    recAftercareContent29: 'الشفاء الكامل واستقرار اللون',
    recAftercareContent30: 'الرعاية اللاحقة للثقب',
    recAftercareContent31: 'روتين التنظيف',
    recAftercareContent32: 'محلول ملحي:',
    recAftercareContent33: 'استخدم محلول ملحي معقم مرتين يومياً',
    recAftercareContent34: 'التنظيف اللطيف:',
    recAftercareContent35: 'استخدم أعواد قطنية أو شاش',
    recAftercareContent36: 'دور المجوهرات:',
    recAftercareContent37: 'دور المجوهرات برفق أثناء التنظيف',
    recAftercareContent38: 'ربت بالجفاف:',
    recAftercareContent39: 'ربت برفق بالجفاف بعد التنظيف',
    recAftercareContent40: 'الجدول الزمني للشفاء',
    recAftercareContent41: 'الأسبوع 1:',
    recAftercareContent42: 'الاحمرار والتورم والحساسية',
    recAftercareContent43: 'الأسبوع 2-4:',
    recAftercareContent44: 'انخفاض تدريجي في التورم',
    recAftercareContent45: 'الشهر 2-3:',
    recAftercareContent46: 'تقدم كبير في الشفاء',
    recAftercareContent47: 'الشهر 3-12:',
    recAftercareContent48: 'الشفاء الكامل حسب نوع الثقب',
    recAftercareContent49: 'ما يجب تجنبه',
    recAftercareContent50: 'أثناء الشفاء',
    recAftercareContent51: 'السباحة:',
    recAftercareContent52: 'تجنب المسابح والجاكوزي والمسطحات المائية الطبيعية',
    recAftercareContent53: 'التعرض للشمس:',
    recAftercareContent54: 'احم من أشعة الشمس المباشرة',
    recAftercareContent55: 'المنتجات القاسية:',
    recAftercareContent56: 'تجنب الكحول وبيروكسيد الهيدروجين والصابون القاسي',
    recAftercareContent57: 'الالتقاط أو الخدش:',
    recAftercareContent58: 'لا تلتقط الجلبات أو القشور',
    recAftercareContent59: 'الملابس الضيقة:',
    recAftercareContent60: 'تجنب الملابس التي تفرك أو تهيج',
    recAftercareContent61: 'علامات العدوى',
    recAftercareContent62: 'الاحمرار المفرط:',
    recAftercareContent63: 'احمرار ينتشر أو يزداد سوءاً',
    recAftercareContent64: 'التورم:',
    recAftercareContent65: 'تورم مستمر أو متزايد',
    recAftercareContent66: 'الألم:',
    recAftercareContent67: 'ألم شديد أو متزايد',
    recAftercareContent68: 'الإفرازات:',
    recAftercareContent69: 'إفرازات صفراء أو خضراء',
    recAftercareContent70: 'الحمى:',
    recAftercareContent71: 'ارتفاع درجة حرارة الجسم',
    recAftercareContent72: 'متى تطلب المساعدة',
    recAftercareContent73: 'اتصل بفنانك أو ثاقبك إذا واجهت علامات العدوى أو ردود الفعل التحسسية أو أنماط الشفاء غير المعتادة. التدخل المبكر يمكن أن يمنع المضاعفات الخطيرة ويضمن الشفاء المناسب.',
    recAftercareQuickTip1: 'اتبع تعليمات الرعاية اللاحقة بعناية وباستمرار',
    recAftercareQuickTip2: 'احتفظ بالمناطق المعالجة نظيفة ومرطبة',
    recAftercareQuickTip3: 'تجنب التعرض للشمس والسباحة أثناء الشفاء',
    recSafetyIntro: 'افهم اعتبارات السلامة الأساسية وممارسات النظافة لتعديل الجسد الآمن والمهني. يجب أن تكون السلامة دائماً الأولوية القصوى عند الحصول على الوشم أو الثقب.',
    recSafetyContent1: 'يجب أن تكون السلامة دائماً الأولوية القصوى عند الحصول على الوشم أو الثقب. فهم ممارسات النظافة المناسبة وبروتوكولات السلامة والمخاطر المحتملة يساعد في ضمان تجربة آمنة ومهنية ويقلل من خطر المضاعفات.',
    recSafetyContent2: 'معايير سلامة الاستوديو',
    recSafetyContent3: 'متطلبات النظافة',
    recSafetyContent4: 'التعقيم:',
    recSafetyContent5: 'يجب تعقيم جميع المعدات بشكل صحيح',
    recSafetyContent6: 'العناصر القابلة للتصرف:',
    recSafetyContent7: 'إبر قابلة للاستخدام مرة واحدة وقفازات وعناصر أخرى',
    recSafetyContent8: 'بيئة نظيفة:',
    recSafetyContent9: 'يجب أن يكون الاستوديو نظيفاً ومنظماً',
    recSafetyContent10: 'الترخيص المناسب:',
    recSafetyContent11: 'يجب أن يكون الاستوديو والفنانون مرخصين',
    recSafetyContent12: 'بروتوكولات السلامة',
    recSafetyContent13: 'فحص الصحة:',
    recSafetyContent14: 'يجب أن يسأل الفنانون عن الحالات الصحية',
    recSafetyContent15: 'اختبار الحساسية:',
    recSafetyContent16: 'اختبر حساسية المعادن قبل الثقوب',
    recSafetyContent17: 'التقنية المناسبة:',
    recSafetyContent18: 'يجب أن يستخدم الفنانون تقنيات مناسبة',
    recSafetyContent19: 'إجراءات الطوارئ:',
    recSafetyContent20: 'يجب أن يكون لدى الاستوديو بروتوكولات طوارئ',
    recSafetyContent21: 'اعتبارات الصحة',
    recSafetyContent22: 'الحالات الطبية',
    recSafetyContent23: 'السكري:',
    recSafetyContent24: 'قد يؤثر على الشفاء ويتطلب رعاية خاصة',
    recSafetyContent25: 'اضطرابات الدم:',
    recSafetyContent26: 'قد يزيد من خطر النزيف',
    recSafetyContent27: 'مشاكل الجهاز المناعي:',
    recSafetyContent28: 'قد يؤثر على الشفاء وخطر العدوى',
    recSafetyContent29: 'حالات الجلد:',
    recSafetyContent30: 'قد يؤثر على الشفاء والمظهر',
    recSafetyContent31: 'الأدوية',
    recSafetyContent32: 'مميعات الدم:',
    recSafetyContent33: 'قد يزيد من خطر النزيف',
    recSafetyContent34: 'المضادات الحيوية:',
    recSafetyContent35: 'قد تؤثر على عملية الشفاء',
    recSafetyContent36: 'الستيرويدات:',
    recSafetyContent37: 'قد تؤثر على الشفاء والاستجابة المناعية',
    recSafetyContent38: 'الأكوتان:',
    recSafetyContent39: 'قد يسبب ندوباً مفرطة',
    recSafetyContent40: 'عوامل الخطر',
    recSafetyContent41: 'مخاطر العدوى',
    recSafetyContent42: 'النظافة السيئة:',
    recSafetyContent43: 'التنظيف غير المناسب يزيد من خطر العدوى',
    recSafetyContent44: 'المعدات الملوثة:',
    recSafetyContent45: 'المعدات غير المعقمة يمكن أن تسبب العدوى',
    recSafetyContent46: 'البيئة غير النظيفة:',
    recSafetyContent47: 'الاستوديوهات القذرة تزيد من خطر العدوى',
    recSafetyContent48: 'الرعاية اللاحقة غير المناسبة:',
    recSafetyContent49: 'الرعاية اللاحقة السيئة يمكن أن تؤدي إلى العدوى',
    recSafetyContent50: 'ردود الفعل التحسسية',
    recSafetyContent51: 'حساسية المعادن:',
    recSafetyContent52: 'النيكل والمعادن الأخرى يمكن أن تسبب ردود فعل',
    recSafetyContent53: 'حساسية الحبر:',
    recSafetyContent54: 'بعض الناس لديهم حساسية من حبر الوشم',
    recSafetyContent55: 'حساسية اللاتكس:',
    recSafetyContent56: 'القفازات ومنتجات اللاتكس الأخرى',
    recSafetyContent57: 'منتجات التنظيف:',
    recSafetyContent58: 'بعض محاليل التنظيف يمكن أن تسبب ردود فعل',
    recSafetyContent59: 'نصائح الوقاية',
    recSafetyContent60: 'قبل موعدك',
    recSafetyContent61: 'ابحث عن الاستوديوهات:',
    recSafetyContent62: 'اختر استوديوهات موثوقة ومرخصة',
    recSafetyContent63: 'تحقق من المراجعات:',
    recSafetyContent64: 'اقرأ مراجعات العملاء والشهادات',
    recSafetyContent65: 'زر الاستوديو:',
    recSafetyContent66: 'افحص النظافة والتنظيم',
    recSafetyContent67: 'اسأل الأسئلة:',
    recSafetyContent68: 'لا تتردد في السؤال عن إجراءات السلامة',
    recSafetyContent69: 'أثناء موعدك',
    recSafetyContent70: 'راقب النظافة:',
    recSafetyContent71: 'راقب ممارسات النظافة المناسبة',
    recSafetyContent72: 'اسأل عن المعدات:',
    recSafetyContent73: 'تأكد من أن المعدات معقمة بشكل صحيح',
    recSafetyContent74: 'تواصل المخاوف:',
    recSafetyContent75: 'تحدث إذا بدا شيء خاطئ',
    recSafetyContent76: 'اتبع التعليمات:',
    recSafetyContent77: 'استمع واتبع جميع تعليمات السلامة',
    recSafetyQuickTip1: 'اختر استوديوهات مرخصة مع تعقيم مناسب',
    recSafetyQuickTip2: 'أبلغ الفنانين عن الحالات الصحية والأدوية',
    recSafetyQuickTip3: 'راقب علامات العدوى واطلب المساعدة فوراً',
    readyExpressIndividuality: 'مستعد للتعبير عن فرديتك؟',
    dontWaitExploreBodyArt: 'لا تنتظر لاستكشاف عالم فن الجسد المهني! احجز استشارة مع أحد فنانينا الخبراء في الوشم والثقب المتخصصين في تعديل الجسد الآمن والمهني. من تصاميم الوشم المخصصة إلى ثقوب دقيقة، سنساعدك في إنشاء فن الجسد المثالي الذي يعكس أسلوبك وشخصيتك الفريدة.',
    bookTattooConsultation: 'احجز استشارة وشم',
    bookPiercingAppointment: 'احجز موعد ثقب',
  },
};

export function useI18n() {
  const { lang } = useLanguage();
  const dict = useMemo(() => DICT[lang] || DICT.en, [lang]);
  const t = useMemo(() => (key) => dict[key] ?? key, [dict]);
  return { t, lang };
}
